//Import Geral
import axios from "axios";
import Globais, {
  validateToken,
  logout,
  validaCPF,
  validacaoEmail,
  validaRg,
} from "../../components/Globais";

import React, { useEffect, useRef, useState } from "react";
import styled from "styled-components";
import { NumberParam, useQueryParams } from "use-query-params";
import { useNavigate } from "react-router-dom";

//Import Material UI - Steps

import Box from "@mui/material/Box";
import Button from "@mui/material/Button";

import Typography from "@mui/material/Typography";
import SettingsIcon from "@mui/icons-material/Settings";

//Import Ant-Design
import {
  Button as ButtonForm,
  Card,
  Checkbox,
  CheckboxProps,
  Col,
  Divider,
  Flex,
  Form,
  GetProp,
  Input,
  InputNumber,
  List,
  message,
  Radio,
  RadioChangeEvent,
  Row,
  Select,
  Skeleton,
  Space,
  Typography as TypographyAntd,
  Upload,
  UploadFile,
} from "antd";

import MaskedInput from "antd-mask-input";
import { ConsoleSqlOutlined, UploadOutlined } from "@ant-design/icons";
import type { UploadProps } from "antd";
import {
  verificarSeTemPeriodoUsuario,
  verificarSeTemPeriodoUsuarioDefinido,
} from "../../uteis/periodoUsuario/Globais";
import {
  atualizarCotaUsuarioGlobais,
  regularizarSituacaoCTU,
  verificarCTUChecada,
  verificarPagamentoPorStatus,
  verificarSeMaisInformacoesAnuncioEstaoAusentes,
  verificarSeTemArquivos,
} from "../../uteis/cotaUsuario/Globais";
import warning from "antd/es/_util/warning";
import {
  buscarAssinaturaPorCotaUsuario,
  criarAssinaturaCTU,
} from "../../uteis/assinatura/Globais";
import { buscarTodosOsRepresentantesCotaUsuario } from "../../uteis/representante/Globais";
import { atualizarUsuarioGlobais } from "../../uteis/usuario/Globais";
import { isHideMenuKey } from "@mui/x-data-grid/utils/keyboardUtils";
import { atualizarApartamento } from "../../uteis/apartamento/Globais";
import PhoneInput from "react-phone-input-2";
import { numberPadrao } from "../../uteis/formatPhoneNumber";
import { buscarPessoasService } from "../../services/buscarPessoasService";

//Styled-Components
const ContainerButton = styled.div`
  margin-top: -2%;
  @media (min-width: 200px) and (max-width: 430px) {
    margin-top: -10%;
  }
`;

const CardTitle = styled.div`
  font-size: 24px;
  font-weight: bold;
  text-wrap: wrap;
  @media (min-width: 200px) and (max-width: 430px) {
    font-size: 1rem;
  }
  @media (min-width: 431px) and (max-width: 820px) {
    font-size: 1.8rem;
  }
  @media (min-width: 821px) and (max-width: 1025px) {
    font-size: 2.2rem;
  }
`;

const StyledTitle = styled.h1`
  font-size: 2rem; /* Tamanho padrÃ£o para dispositivos maiores */

  /* Media query para dispositivos mÃ³veis */
  @media (max-width: 600px) {
    font-size: 1.5rem; /* Tamanho da fonte para dispositivos mÃ³veis */
  }

  /* Estilos adicionais, se necessÃ¡rio */
  text-align: center; /* Centraliza o texto */
  color: #000; /* Cor do texto */
  margin: 16px 0; /* Margem superior e inferior */
`;

export default function ViewCadastroPropriedade() {
  // --------------- Constantes --------------------
  const stepTitles = [
    "Cadastro inicial",
    "Validação de proprietário",
    "Configuração de propriedade",
    "Anúncio de venda",
    "Adicionar períodos",
    "Definir períodos",
    "Finalização",
  ]; //Array de steps, caso queria adicionar mais steps, sÃ³ incluir dentro do array

  const { Title } = TypographyAntd;

  const navigate = useNavigate();

  const layout = {
    //Layout que altera o tamanho e a posiÃ§Ã£o dos nomes e labels dos formulÃ¡rios de : Empreendimentos,EspecificaÃ§Ãµes de Apto,Cadastrar Apartamento,AtualizarCadastro,CadastroProprietario
    labelCol: { span: 10 },
    wrapperCol: { span: 16 },
  };
  const layoutAp = {
    //Layout que altera o tamanho e a posiÃ§Ã£o dos nomes e labels do formulÃ¡rio: Mais Info do Apartamento
    labelCol: { span: 16 },
    wrapperCol: { span: 8 },
  };

  /* eslint-disable no-template-curly-in-string */ // Constante que vÃ¡lida os campos de todos os  formulÃ¡rio
  const validarFormulario = {
    required: "${label} Ã© necessÃ¡rio!",
    types: {
      email: "${label} nÃ£o Ã© vÃ¡lido!",
      number: "${label} nÃ£o Ã© um nÃºmero!",
    },
  };
  /* eslint-enable no-template-curly-in-string */

  const estadoCivilOpcoes = [
    //Array de OpÃ§Ãµes usadas no SELECT de atualizar cadastro e cadastrar proprietario
    { id: 1, label: "Solteiro", value: "SOLTEIRO" },
    { id: 2, label: "Casado", value: "CASADO" },
    { id: 3, label: "Separado", value: "SEPARADO" },
    { id: 4, label: "Divorciado", value: "DIVORCIADO" },
    { id: 5, label: "ViÃºvo", value: "VIUVO" },
  ];
  const estadoCivil: EstadoCivil[] = estadoCivilOpcoes.map((ec) => ({
    // Map do array
    id: ec.id,
    label: ec.label,
    value: ec.value,
  }));

  const vistaOptions = [
    //Array de OpÃ§Ãµes usadas no SELECT de cadastrar apartamento
    { label: "NÃ£o Sei", value: "NAO_SEI" },
    { label: "Estacionamento", value: "ESTACIONAMENTO" },
    { label: "Mar", value: "MAR" },
    { label: "Montanha", value: "MONTANHA" },

    { label: "Piscina", value: "PISCINA" },
  ];

  const diasDaSemana = [
    //Array de OpÃ§Ãµes usadas no SELECT de dias da semana
    { id: 1, label: "Segunda-Feira", value: "SEGUNDA" },
    { id: 2, label: "TerÃ§a-Feira", value: "TERCA" },
    { id: 3, label: "Quarta-Feira", value: "QUARTA" },
    { id: 4, label: "Quinta-Feira", value: "QUINTA" },
    { id: 5, label: "Sexta-Feira", value: "SEXTA" },
    { id: 6, label: "SÃ¡bado", value: "SABADO" },
    { id: 7, label: "Domingo", value: "DOMINGO" },
  ];

  const situacaoPropriedade = [
    //Array de OpÃ§Ãµes usadas no SELECT de dias da semana
    { id: 1, label: "Escriturado", value: "ESCRITURADO" },
    { id: 2, label: "Quitado", value: "QUITADO" },
    { id: 3, label: "NÃ£o Quitado", value: "NAO_QUITADO" },
    { id: 4, label: "Na planta", value: "NA_PLANTA" },
  ];

  //----------------  Interfaces --------------------
  interface Estado {
    id: number;
    nome: string;
    abreviacao: string;
    origem: number;
  }

  interface Cidade {
    id: number;
    nome: string;
    estadoId: number;
  }

  interface EstadoCivil {
    id: number;
    label: string;
    value: string;
  }

  interface Pais {
    id: number;
    nome: string;
    abreviacao: string;
    origem: number;
  }
  interface Usuario {
    nome?: string;
    sobrenome?: string;
    email?: string;
    cpf?: string;
    rg?: string;
    celular?: string;
    estadoCivil?: string;
    nacionalidade?: string;
  }
  interface ApData {
    banheiros: number;
    capacidade: number;
    created_at: string;
    empreendId: number;
    estacionamento: number;
    id: number;
    metragem: number;
    nome: string;
    origem: number;
    quartos: number;
    terreo: number;
    updated_at: string;
    varanda: number;
  }
  interface Empreendimento {
    id?: number;
    cidadeId?: number;
    estado?: number;
    nome?: string;
    pais?: number;
    origem?: number;
    cronograma?: number;
  }
  interface Empreendimentos {
    id: number;
    cidadeId: number;
    estado: number;
    nome: string;
    pais: number;
    origem: number;
    created_at: Date;
  }

  interface Apartamento {
    id?: number;
    empreendId?: number;
    nome?: string;
    capacidade?: number;
    quartos?: number;
    banheiros?: number;
    metragem?: number;
    varanda?: number;
    terreo?: number;
    vista?: number;
    estacionamento?: number;
    origem?: number;
  }
  interface MaisInfoAp {
    cotaId?: number;
    usuarioId?: number;
    status?: string;
    andar?: number;
    bloco?: string;
    numeroApto?: string;
    vista?: string;
  }

  interface Cadastro {
    usuarioId?: number;
    nome?: string;
    sobrenome?: string;
    email?: string;
    cpf?: string;
    rg?: string;
    celular?: string;
    nacionalidade?: string;
    paisId?: number;
    estadoCivil?: string;
    endereco?: string;
    complemento?: string;
    estadoId?: number;
    cidadeId?: number;
  }
  interface Cotas {
    id: number;
    aptoId: number;
    origem: number;
    numeroCota: number;
    semanasPorAno: number;
    diaInicio: number;
  }
  interface CotaUsuario {
    id: number;
    cotaId: number;
    usuarioId: number;
    status: string;
    querAlugar?: number;
    querTrocar?: number;
    querVender?: number;
    prioridade: string;
    saldoDevedor: number;
    valorCondominio: number;
    valorVenda: number;
    situacao: string;
  }
  type EtapaCadastroCota =
    | "AGUARDANDO_EMPREENDIMENTO"
    | "AGUARDANDO_APARTAMENTO"
    | "AGUARDANDO_IDENTIFICACAO_COTA"
    | "AGUARDANDO_TITULARIDADE"
    | "AGUARDANDO_DISPONIBILIDADE"
    | "AGUARDANDO_PERIODOS"
    | "AGUARDANDO_VENDA"
    | "AGUARDANDO_OPORTUNIDADES_HOSPEDAGEM"
    | "AGUARDANDO_DADOS_COMPLEMENTARES"
    | "CONCLUIDO";
  interface FluxoCadastroEstado {
    etapaAtual: EtapaCadastroCota;
    etapaAnterior?: EtapaCadastroCota | null;
    proximaEtapa?: EtapaCadastroCota | null;
    etapasPercorridas?: EtapaCadastroCota[];
    concluido?: boolean;
    podeAvancar?: boolean;
    bloqueios?: any[];
    etapas?: any[];
    contextoFluxo?: {
      usuarioId: number;
      empreendimentoId: number;
      apartamentoId: number;
    };
  }
  interface IniciarFluxoCadastroResponse {
    success: boolean;
    cotaUsuarioId: number | null;
    etapaAtual?: EtapaCadastroCota;
    etapaAnterior?: EtapaCadastroCota | null;
    proximaEtapa?: EtapaCadastroCota | null;
    etapasPercorridas?: EtapaCadastroCota[];
    concluido: boolean;
    podeAvancar?: boolean;
    bloqueios?: any[];
    etapas?: any[];
    fluxoCadastro?: FluxoCadastroEstado;
    contextoFluxo?: {
      usuarioId: number;
      empreendimentoId: number;
      apartamentoId: number;
    };
  }
  type ContextoFluxoCadastro = {
    usuarioId: number;
    empreendimentoId: number;
    apartamentoId: number;
  };
  interface ServicosMulticotas {
    querAlugar: number;
    querTrocar: number;
    querVender: number;
  }

  const servicosMulticotasOptions: Array<{
    value: keyof ServicosMulticotas;
    titulo: string;
    descricao: string;
  }> = [
    {
      value: "querVender",
      titulo: "Quero vender minha cota",
      descricao: "Encontre compradores interessados.",
    },
    {
      value: "querAlugar",
      titulo: "Quero rentabilizar meus per\u00edodos",
      descricao:
        "Encontre oportunidades para gerar renda com meus per\u00edodos.",
    },
    {
      value: "querTrocar",
      titulo: "Quero receber oportunidades de hospedagem",
      descricao:
        "Conte-nos quando e para onde gostaria de se hospedar. A Multicotas buscar\u00e1 as melhores oportunidades para voc\u00ea, seja utilizando os per\u00edodos de sua multipropriedade, uma troca, uma compensa\u00e7\u00e3o, um hotel parceiro ou outras op\u00e7\u00f5es dispon\u00edveis.",
    },
  ];
  const relacaoPropriedadeOptions = [
    {
      value: 1,
      titulo: "Sou o titular",
      descricao: "A propriedade est\u00e1 em meu nome.",
    },
    {
      value: 2,
      titulo: "Sou c\u00f4njuge do titular",
      descricao: "A propriedade est\u00e1 em nome do meu marido ou esposa.",
    },
    {
      value: 3,
      titulo: "Sou familiar do titular",
      descricao: "Estou cadastrando a propriedade para um familiar.",
    },
    {
      value: 4,
      titulo: "Sou revendedor",
      descricao: "Administro ou comercializo a propriedade para o titular.",
    },
  ];
  //----------------  Hooks e VariÃ¡veis de Estado --------------------
  const isLoading = useRef(false);
  const status = useRef("");

  const [bloquearBotaoProximo, setBloquearBotaoProximo] = useState(true);
  const [propriedadeTemPeriodos, setPropriedadeTemPeriodos] = useState("NÃ£o");
  const [propriedadeTemPeriodosDefinidos, setPropriedadeTemPeriodosDefinidos] =
    useState("NÃ£o");
  const [pagamentoRegularizado, setPagamentoRegularizado] = useState("NÃ£o");
  const [representanteRegularizado, setRepresentanteRegularizado] =
    useState("NÃ£o");
  const [propriedadeAutenticada, setPropriedadeAutenticada] = useState("NÃ£o");
  const [textoFinalizacao, setTextoFinalizacao] = useState("");
  const [numeroCota, setNumeroCota] = useState("");
  const [openSucess, setOpenSucess] = useState(false);
  const [cpfEmailBloqueado, setCpfEmailBloqueado] = useState(false);

  // UseStates necessÃ¡rio para o useEffect de busca de informaÃ§Ãµes pendentes, armazena a cota e a cota do usuario
  const [cotaId, setCotaId] = useState<number>();
  const [cotaUsuarioId, setCotaUsuarioId] = useState<any>(0);
  const [usuarioLogadoId, setUsuarioLogadoId] = useState<number>(0);
  const [pCotaUsuarioId, setPcotaUsuarioId] = useQueryParams({
    pCotaUsuarioId: NumberParam,
  });

  const [phone, setPhone] = useState("");
  const handlePhoneChange = (value: string) => {
    setPhone(value);
  };

  // UseStates necessÃ¡rios para movimentaÃ§Ã£o do Step

  // activeStep = 0 (Telas referente a cadastro empreendimento apartamento)
  // renderApSteps = 0 - De qual Empreendimento Ã© sua Propriedade?

  // Empreendimento foi selecionado?

  // Sim
  // renderApSteps = 1 - Selecione seu apartamento?

  // NÃ£o

  // renderEmpSteps = 0 - Mensagem: Preenha informaÃ§Ãµes de apartamento
  // renderEmpSteps = 1 - Conte-me mais sobre o empreendimento
  // renderEmpSteps = 2 - Conte-me mais sobre o Apartamento

  // renderApSteps = 3 - Mais informaÃ§Ãµes do apartamento

  // activeStep = 1 (Telas referente a representante)
  const [activeStep, setActiveStep] = useState(0); // Passa para o prÃ³ximo passo
  const mobileStepIndex = Math.min(activeStep, stepTitles.length - 1);
  const [renderApSteps, setRenderApSteps] = useState(0); // Passa para o proximo render do fluxo de cadastro de Apartamentos
  const [renderEmpSteps, setRenderEmpSteps] = useState(0); //  Passa para o proximo render do fluxo de cadastro de Empreendimento
  const ultimoRenderEmpStep = useRef(0);
  const [renderCotaSteps, setRenderCotaSteps] = useState(0); // Passa para o proximo render do fluxo de Cotas
  const [renderPagamentoSteps, setRenderPagamentoSteps] = useState(0); // Passa para o proximo render do fluxo de Cotas
  const [renderPrioridadeSteps, setRenderPrioridadeSteps] = useState(0); // Passa para o proximo render do fluxo de Prioridade
  const [renderProprietario, setRenderProprietario] = useState(0); // Passa para o proximo render do fluxo titularidade da propriedade
  const [renderAdicionarPeriodo, setRenderAdicionarPeriodo] = useState(0);
  const [renderFinalizacao, setRenderFinalizacao] = useState(0);
  const [renderCronoFixo, setRenderCronoFixo] = useState(0);
  // UseStates necessÃ¡rios para o passo titularidade da propriedade
  const [propriedadeRes, setPropriedadeRes] = useState(0); // State que armazena o valor selecionado no Radio
  const [cronogramaFixoOuPrioridade, setCronogramaFixoOuPrioridade] =
    useState(0); // State que armazena o valor selecionado no Radio
  const possuiRelacaoSelecionada = () => propriedadeRes !== 0;
  const relacaoEhTitular = () => propriedadeRes === 1;
  const relacaoEhTerceiro = () => [2, 3, 4].includes(propriedadeRes);

  // UseStates necessÃ¡rios para o passo de atualizaÃ§Ã£o de cadastro, cadastro de proprietario, cadastrar empreendimento
  const [estados, setEstados] = useState<Estado[]>([]);
  const [cidades, setCidades] = useState<Cidade[]>([]);

  const [selectedEstado, setSelectedEstado] = useState<number>();
  const [selectedCidade, setSelectedCidade] = useState<number>();
  const [atualizado, setAtualizado] = useState<boolean>();
  const [paises, setPaises] = useState<Pais[]>([]);

  const [empreendimento, setEmpreendimento] = useState<Empreendimento[]>([]);
  const [empreendimentoSearch, setEmpreendimentoSearch] = useState("");

  const [empreedimentoSelecionado, setEmpreendimentoSelecionado] = useState<
    any | null
  >(null);
  const [empreendimentoNaoSelecionado, setEmpreendimentoNaoSelecionado] =
    useState<boolean>(false);

  // UseStates necessÃ¡rio para o passo de buscar informaÃ§Ãµes do apartamento do empreendimento selecionado
  const [empreendimentoAp, setEmpreendimentoAp] = useState<ApData[]>([]);
  const [empreendimentoSelecionadoAp, setEmpreendimentoSelecionadoAp] =
    useState<any | null>(null);

  // UseStates necessÃ¡rios para o passo de especificaÃ§Ãµes do apartamento selecionado
  const [apCriadoPeloUsuario, setApCriadoPeloUsuario] =
    useState<boolean>(false);
  const [apSelecionado, setApSelecionado] = useState<ApData | null>(null);
  const [formApartamento] = Form.useForm();
  const [formCadastrarApartamento] = Form.useForm();

  // UseStates necessÃ¡rios para o passo de cadastro de apartamento e busca de empreendimento cadastrado
  const [possuiVaranda, setPossuiVaranda] = useState<number>();
  const [estacionamento, setEstacionamento] = useState<number>();
  const [terreo, setTerreo] = useState<number>();
  const [meusEmpreendimentos, setMeusEmpreendimentos] = useState<
    Empreendimentos[]
  >([]);

  // UseState necessÃ¡rio para armazenamento dos dados do formulario de cadastro do empreendimento
  const [formEmpreendimento, setFormEmpreendimento] = useState<Empreendimento>(
    {}
  );

  // UseState necessÃ¡rio para armazenamento dos dados do formulÃ¡rio de cadastro do apartamento
  const [formAp, setFormAp] = useState<Apartamento>({});
  const [naoSeiApartamento, setNaoSeiApartamento] = useState({
    capacidade: false,
    quartos: false,
    banheiros: false,
  });

  // UseState necessÃ¡rio para armazenamento dos dados do formulÃ¡rio de mais informaÃ§oes do apartamento
  const [formInfo, setFormInfo] = useState<MaisInfoAp>({});

  // UseState necessÃ¡rio para armazenamento do Id do empreendimento selecionado no formulario de cadastro de apartamento
  const [ApEmpreendimentoId, setApEmpreendimentoId] = useState<number>();

  // UseState necessÃ¡rio para armazenamento dos dados do formulario de atualizaÃ§Ã£o de cadastro do usuÃ¡rio
  const [formAtualizarCadastro, setFormAtualizarCadastro] = useState<Cadastro>(
    {}
  );

  // UseState necessÃ¡rio para armazenamento de dados do formulario de cadastro de proprietario
  const [formCadastroProprietario, setFormCadastroProprietario] =
    useState<Cadastro>({});

  const [formCadastroNovoProprietario, setFormCadastroNovoProprietario] =
    useState<Cadastro>({});

  // UseState necessÃ¡rio para armazenamento do id do proprietario, para futuras buscas de dados icompletos ----Em TESTE---
  const [proprietarioId, setProprietarioId] = useState<number>();

  //variÃ¡vel que controla o checkbox de NÃ£o encontrou empreendimento
  const [naoEncontrouEmpreendimento, setNaoEncontrouEmpreendimento] =
    useState<boolean>(false);

  // UseStates necessÃ¡rios para o componente de cota ou prioridade

  const cotaRef = useRef<boolean>();

  //bloqueia a ediÃ§Ã£o dos campos caso a CTU tenha PEU
  const bloqueadoEdicao = useRef<boolean>(false);
  const prioridadeRef = useRef<boolean>();

  const changing = useRef<boolean>(false);

  const [valorCotaPrioridade, setValorCotaPrioridade] = useState<number>(0);

  // UseState para armazenamento se o usuario vai ou nao anunciar
  const [anunciar, setAnunciar] = useState<number>();
  const [mostrarMaisCotas, setMostrarMaisCotas] = useState(false);
  const [servicosSelecionados, setServicosSelecionados] =
    useState<ServicosMulticotas>({
      querAlugar: 0,
      querTrocar: 0,
      querVender: 0,
    });

  // UseState para armazenamento das cotas do Usuario
  const [cotasUsuario, setCotasUsuario] = useState<Cotas[]>([]);

  // UseState para armazanemento e posterior verificaÃ§Ã£o se existe cronograma dos empreendimentos
  // const [cronogramaEmp1, setCronogramaEmp1] = useState<number>();

  const cronogramaEmp = useRef(100);

  // UseRef necessÃ¡rio para referenciar se tem cronograma
  const cronogramaRef = useRef<number>(0);

  // UseRef necessÃ¡rio para referenciar se tem cronograma
  const cotaUsuarioRef = useRef<number>(0);

  // UseRef necessÃ¡rio para referenciar se tem cronograma
  const cotaIdRef = useRef<number>();

  // UseRef necessÃ¡rio para referenciar a origem do AP
  const origemApRef = useRef<number>(0);

  // UseRef necessÃ¡rio para referenciar o id do AP
  const idApRef = useRef<number>(0);
  // UseRef necessÃ¡rio para referenciar o id do AP
  const idEmpRef = useRef<number>(0);
  // UseRef necessÃ¡rio para referenciar a origem do AP
  const origemEmpRef = useRef<number>(0);

  // UseRef necessÃ¡rio para referenciar o representante
  const representanteRef = useRef<number>(0);

  // UseRef necessÃ¡rio para referenciar o id do Proprietario
  const proprietarioRef = useRef<number>(0);
  const contextoFluxoCadastroRef = useRef<ContextoFluxoCadastro | null>(null);
  const fluxoCadastroEstadoRef = useRef<FluxoCadastroEstado | null>(null);

  //UseState necessÃ¡rio para referenciar o marco
  const [state, setState] = useState<String>("");
  const stateNovo = useRef<String>("");

  const extrairEtapaCadastroAtual = (
    data: any
  ): EtapaCadastroCota | undefined =>
    data?.fluxoCadastro?.etapaAtual ??
    data?.CadastroCotaUsuario?.etapaAtual ??
    data?.cadastroCotaUsuario?.etapaAtual ??
    data?.etapaAtual;

  const extrairEtapaAnteriorFluxoCadastro = (
    data: any
  ): EtapaCadastroCota | undefined =>
    data?.fluxoCadastro?.etapaAnterior ??
    data?.CadastroCotaUsuario?.etapaAnterior ??
    data?.cadastroCotaUsuario?.etapaAnterior ??
    data?.etapaAnterior;

  const extrairEtapasPercorridasFluxoCadastro = (
    data: any
  ): EtapaCadastroCota[] =>
    data?.fluxoCadastro?.etapasPercorridas ??
    data?.CadastroCotaUsuario?.etapasPercorridas ??
    data?.cadastroCotaUsuario?.etapasPercorridas ??
    data?.etapasPercorridas ??
    [];

  const extrairFluxoCadastroEstado = (
    data: any
  ): FluxoCadastroEstado | null => {
    if (data?.fluxoCadastro) {
      return data.fluxoCadastro as FluxoCadastroEstado;
    }

    const etapaAtual = extrairEtapaCadastroAtual(data);

    if (!etapaAtual) {
      return null;
    }

    return {
      etapaAtual,
      etapaAnterior: extrairEtapaAnteriorFluxoCadastro(data) ?? null,
      proximaEtapa: data?.proximaEtapa ?? null,
      etapasPercorridas: extrairEtapasPercorridasFluxoCadastro(data),
      concluido: data?.concluido,
      podeAvancar: data?.podeAvancar,
      bloqueios: data?.bloqueios ?? [],
      etapas: data?.etapas ?? [],
      contextoFluxo: extrairContextoFluxoCadastro(data) ?? undefined,
    };
  };

  const obterEtapaAnteriorPelasEtapasPercorridas = (
    fluxo: FluxoCadastroEstado | null
  ): EtapaCadastroCota | null => {
    const etapasPercorridas = fluxo?.etapasPercorridas ?? [];

    if (etapasPercorridas.length >= 2) {
      return etapasPercorridas[etapasPercorridas.length - 2] ?? null;
    }

    return fluxo?.etapaAnterior ?? null;
  };

  const etapasPagamentoFluxo = new Set<EtapaCadastroCota>([
    "AGUARDANDO_VENDA",
    "AGUARDANDO_OPORTUNIDADES_HOSPEDAGEM",
  ]);

  const obterEtapaPagamentoPercorridaMaisRecente = (
    fluxo: FluxoCadastroEstado | null
  ): EtapaCadastroCota | null => {
    const etapasPercorridas = fluxo?.etapasPercorridas ?? [];

    for (let i = etapasPercorridas.length - 1; i >= 0; i -= 1) {
      const etapa = etapasPercorridas[i];

      if (etapasPagamentoFluxo.has(etapa)) {
        return etapa;
      }
    }

    if (fluxo?.etapaAtual && etapasPagamentoFluxo.has(fluxo.etapaAtual)) {
      return fluxo.etapaAtual;
    }

    return null;
  };

  const obterEtapaFluxoDaTelaAtual = (
    fluxo: FluxoCadastroEstado | null = fluxoCadastroEstadoRef.current
  ): EtapaCadastroCota | null => {
    switch (activeStep) {
      case 0:
        if (renderApSteps === 4) {
          return "AGUARDANDO_DISPONIBILIDADE";
        }

        if (
          renderApSteps === 1 ||
          renderApSteps === 2 ||
          renderApSteps === 3 ||
          renderApSteps === 100 ||
          renderEmpSteps === 3 ||
          renderEmpSteps === 4
        ) {
          return "AGUARDANDO_APARTAMENTO";
        }

        return "AGUARDANDO_EMPREENDIMENTO";

      case 1:
        return "AGUARDANDO_TITULARIDADE";

      case 2:
        return "AGUARDANDO_IDENTIFICACAO_COTA";

      case 3:
        if (renderPagamentoSteps !== 1) {
          return "AGUARDANDO_DADOS_COMPLEMENTARES";
        }

        return (
          obterEtapaPagamentoPercorridaMaisRecente(fluxo) ??
          "AGUARDANDO_VENDA"
        );

      case 4:
      case 5:
        return "AGUARDANDO_PERIODOS";

      case 6:
        return "CONCLUIDO";

      default:
        return fluxo?.etapaAtual ?? null;
    }
  };

  const obterEtapaAnteriorNavegacaoFluxoCadastro = (
    fluxo: FluxoCadastroEstado | null,
    etapaAtualTela: EtapaCadastroCota | null
  ): EtapaCadastroCota | null => {
    const etapasPercorridas = fluxo?.etapasPercorridas ?? [];

    if (etapaAtualTela) {
      const indiceEtapaAtual = etapasPercorridas.lastIndexOf(etapaAtualTela);

      if (indiceEtapaAtual > 0) {
        return etapasPercorridas[indiceEtapaAtual - 1] ?? null;
      }

      if (indiceEtapaAtual === 0) {
        return null;
      }
    }

    return obterEtapaAnteriorPelasEtapasPercorridas(fluxo);
  };

  const obterProximaEtapaNavegacaoFluxoCadastro = (
    fluxo: FluxoCadastroEstado | null,
    etapaAtualTela: EtapaCadastroCota | null
  ): EtapaCadastroCota | null => {
    const etapasPercorridas = fluxo?.etapasPercorridas ?? [];

    if (!etapaAtualTela) {
      return null;
    }

    const indiceEtapaAtual = etapasPercorridas.lastIndexOf(etapaAtualTela);

    if (
      indiceEtapaAtual >= 0 &&
      indiceEtapaAtual < etapasPercorridas.length - 1
    ) {
      return etapasPercorridas[indiceEtapaAtual + 1] ?? null;
    }

    return null;
  };

  const sincronizarEstadoTelaComEtapaFluxo = (
    etapaDestino: EtapaCadastroCota
  ) => {
    const statusFluxo = resolverStatusFluxoCadastro({
      etapaAtual: etapaDestino,
    });

    if (statusFluxo) {
      setState(statusFluxo);
      stateNovo.current = statusFluxo;
    }
  };

  const resolverStatusFluxoCadastro = (data: any): string => {
    const etapaAtual = extrairEtapaCadastroAtual(data);

    if (!etapaAtual) {
      return data?.status ?? "";
    }

    switch (etapaAtual) {
      case "AGUARDANDO_EMPREENDIMENTO":
        return "AGUARDANDO_CADASTRO";
      case "AGUARDANDO_APARTAMENTO":
        return "AGUARDANDO_APTO";
      case "AGUARDANDO_IDENTIFICACAO_COTA":
        return "AGUARDANDO_COTA";
      case "AGUARDANDO_TITULARIDADE":
        return "AGUARDANDO_TITULARIDADE";
      case "AGUARDANDO_DISPONIBILIDADE":
        return "AGUARDANDO_SERVICO";
      case "AGUARDANDO_PERIODOS":
        return "AGUARDANDO_PERIODOS";
      case "AGUARDANDO_VENDA":
        return "AGUARDANDO_DEFINICAO_ANUNCIO";
      case "AGUARDANDO_OPORTUNIDADES_HOSPEDAGEM":
        return "AGUARDANDO_PAGAMENTO";
      case "AGUARDANDO_DADOS_COMPLEMENTARES":
        return "AGUARDANDO_MAISINFO_ANUNCIO";
      case "CONCLUIDO":
        return data?.status ?? "AUTENTICADA_NIVEL1";
      default:
        return data?.status ?? "";
    }
  };

  const extrairContextoFluxoCadastro = (
    data: any
  ): ContextoFluxoCadastro | null =>
    data?.fluxoCadastro?.contextoFluxo ?? data?.contextoFluxo ?? null;

  const abrirEtapaFluxoCadastro = async (
    etapaDestino: EtapaCadastroCota
  ): Promise<boolean> => {
    switch (etapaDestino) {
      case "AGUARDANDO_EMPREENDIMENTO":
        sincronizarEstadoTelaComEtapaFluxo(etapaDestino);
        setActiveStep(0);
        setRenderApSteps(0);
        setRenderEmpSteps(0);
        setBloquearBotaoProximo(true);
        return true;
      case "AGUARDANDO_APARTAMENTO":
        sincronizarEstadoTelaComEtapaFluxo(etapaDestino);
        setActiveStep(0);
        if (origemEmpRef.current !== 0 || origemApRef.current !== 0 || apCriadoPeloUsuario) {
          setRenderApSteps(100);
          setRenderEmpSteps(3);
          setApCriadoPeloUsuario(true);
          verificarSeFormApartamentoProprietarioVazio();
        } else {
          setRenderEmpSteps(0);
          setRenderApSteps(1);
          setBloquearBotaoProximo(isCampoVazio() && !apCriadoPeloUsuario);
        }
        return true;
      case "AGUARDANDO_TITULARIDADE":
        abrirEtapaTitularidadeFluxoCadastro();
        return true;
      case "AGUARDANDO_IDENTIFICACAO_COTA":
        sincronizarEstadoTelaComEtapaFluxo(etapaDestino);
        await abrirEtapaCotaOuPrioridadeFluxoCadastro();
        return true;
      case "AGUARDANDO_DISPONIBILIDADE":
        sincronizarEstadoTelaComEtapaFluxo(etapaDestino);
        setActiveStep(0);
        setRenderEmpSteps(0);
        setRenderApSteps(4);
        setBloquearBotaoProximo(!possuiServicoSelecionado(servicosSelecionados));
        return true;
      case "AGUARDANDO_PERIODOS":
        sincronizarEstadoTelaComEtapaFluxo(etapaDestino);
        if (cronogramaEmp.current === 1 && deveUsarFluxoManualComCotaUsuario()) {
          await abrirFluxoManualPeriodosSemAtualizarStatus();
        } else {
          setActiveStep(4);
          setRenderAdicionarPeriodo(cronogramaEmp.current === 2 ? 2 : 1);
        }
        return true;
      case "AGUARDANDO_VENDA":
      case "AGUARDANDO_OPORTUNIDADES_HOSPEDAGEM":
        sincronizarEstadoTelaComEtapaFluxo(etapaDestino);
        setActiveStep(3);
        setRenderPagamentoSteps(1);
        return true;
      case "AGUARDANDO_DADOS_COMPLEMENTARES":
        sincronizarEstadoTelaComEtapaFluxo(etapaDestino);
        setActiveStep(3);
        setRenderPagamentoSteps(2);
        return true;
      case "CONCLUIDO":
        sincronizarEstadoTelaComEtapaFluxo(etapaDestino);
        setActiveStep(6);
        return true;
      default:
        return false;
    }
  };

  const etapasComAvancoNoBackend = new Set<EtapaCadastroCota>([
    "AGUARDANDO_TITULARIDADE",
    "AGUARDANDO_IDENTIFICACAO_COTA",
    "AGUARDANDO_DISPONIBILIDADE",
    "AGUARDANDO_PERIODOS",
    "AGUARDANDO_VENDA",
    "AGUARDANDO_OPORTUNIDADES_HOSPEDAGEM",
    "AGUARDANDO_DADOS_COMPLEMENTARES",
  ]);

  const statusQueDisparamAvancoFluxo = new Set([
    "AGUARDANDO_TITULARIDADE",
    "AGUARDANDO_SERVICO",
    "AGUARDANDO_PERIODOS",
    "AGUARDANDO_DEFINICAO_PERIODOS",
    "AGUARDANDO_DEFINICAO_ANUNCIO",
    "AGUARDANDO_MAISINFO_ANUNCIO",
    "AGUARDANDO_PAGAMENTO",
  ]);

  const buscarEtapaAtualFluxoCadastro = async (
    cotaUsuarioIdAtual: number
  ): Promise<EtapaCadastroCota | false> => {
    const Token = validateToken();

    if (!Token) {
      document.location.href = "/login";
      return false;
    }

    const URL = `${Globais.DOMINIOBACK}/cota-usuario/${cotaUsuarioIdAtual}`;

    try {
      const response = await axios.get(URL, {
        headers: { Authorization: Token.AuthStr },
        
      });
      console.log("response.data", response.data);

      fluxoCadastroEstadoRef.current = extrairFluxoCadastroEstado(response.data);

      return extrairEtapaCadastroAtual(response.data) ?? false;
    } catch (error) {
      console.log(error);
      return false;
    }
  };

  const avancarFluxoCadastro = async (
    cotaUsuarioIdAtual: number
  ): Promise<boolean> => {
    const Token = validateToken();

    if (!Token) {
      document.location.href = "/login";
      return false;
    }

    const etapaAtual = await buscarEtapaAtualFluxoCadastro(cotaUsuarioIdAtual);

    if (!etapaAtual) {
      return false;
    }

    if (!etapasComAvancoNoBackend.has(etapaAtual)) {
      return true;
    }

    const URL = `${Globais.DOMINIOBACK}/cota-usuario/${cotaUsuarioIdAtual}/fluxo-cadastro/avancar`;

    try {
      await axios.patch(
        URL,
        { etapaAtual },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: Token.AuthStr,
          },
        }
      );

      return true;
    } catch (error) {
      console.log(error);
      return false;
    }
  };

  const obterCotaUsuarioIdAtual = () =>
    Number(
      cotaUsuarioId || pCotaUsuarioId.pCotaUsuarioId || cotaUsuarioRef.current || 0
    );

  const extrairMensagemErroApi = (erro: unknown, fallback: string) => {
    if (axios.isAxiosError(erro)) {
      const dataErro = erro.response?.data as
        | { message?: string; error?: string; mensagem?: string }
        | undefined;
      const mensagem =
        dataErro?.message || dataErro?.error || dataErro?.mensagem;

      if (typeof mensagem === "string" && mensagem.trim() !== "") {
        return mensagem;
      }
    }

    return fallback;
  };

  const extrairPessoaIdDeRegistro = (registro: any): number | null => {
    const pessoaId =
      registro?.pessoaId ??
      registro?.Pessoa?.id ??
      registro?.PessoaTable?.id ??
      registro?.pessoa?.id ??
      registro?.id;

    return pessoaId ? Number(pessoaId) : null;
  };

  const extrairListaPessoas = (data: any): any[] => {
    if (Array.isArray(data)) {
      return data;
    }

    if (Array.isArray(data?.rows)) {
      return data.rows;
    }

    if (Array.isArray(data?.data)) {
      return data.data;
    }

    if (Array.isArray(data?.items)) {
      return data.items;
    }

    return [];
  };

  const buscarPessoaIdPorUsuarioId = async (
    usuarioId: number
  ): Promise<number | null> => {
    const Token = validateToken();

    if (!Token) {
      document.location.href = "/login";
      return null;
    }

    try {
      const responseUsuario = await axios.get(
        `${Globais.DOMINIOBACK}/usuario/${usuarioId}`,
        {
          headers: {
            Authorization: Token.AuthStr,
          },
        }
      );

      const pessoaIdUsuario = extrairPessoaIdDeRegistro(responseUsuario?.data);

      if (pessoaIdUsuario) {
        return pessoaIdUsuario;
      }
    } catch (erro) {
      console.log(erro);
    }

    const pessoas = extrairListaPessoas(await buscarPessoasService());

    const pessoa = pessoas.find((item: any) => {
      const usuarioRelacionado =
        item?.usuarioId ??
        item?.Usuario?.id ??
        item?.UsuarioTable?.id ??
        item?.usuario?.id;

      return Number(usuarioRelacionado) === Number(usuarioId);
    });

    return extrairPessoaIdDeRegistro(pessoa);
  };

  const garantirVinculoTitularidadeLegado = async (
    pessoaId: number
  ): Promise<boolean> => {
    const Token = validateToken();
    const cotaUsuarioIdAtual = obterCotaUsuarioIdAtual();

    if (!Token || !cotaUsuarioIdAtual) {
      if (!Token) {
        document.location.href = "/login";
      }
      return false;
    }

    const URLBusca = `${Globais.DOMINIOBACK}/vinculo-cota-usuario/cotausuario/${cotaUsuarioIdAtual}`;

    try {
      const response = await axios.get(URLBusca, {
        headers: { Authorization: Token.AuthStr },
      });

      const vinculos = Array.isArray(response.data)
        ? response.data
        : Array.isArray(response.data?.vinculos)
        ? response.data.vinculos
        : [];

      const vinculoTitular = vinculos.find((vinculo: any) => {
        const pessoaRelacionada =
          vinculo?.pessoaId ??
          vinculo?.Pessoa?.id ??
          vinculo?.PessoaTable?.id ??
          vinculo?.pessoa?.id;

        return (
          vinculo?.tipoVinculo === "TITULAR" &&
          Number(pessoaRelacionada) === Number(pessoaId) &&
          (vinculo?.principal === true || vinculo?.principal === 1)
        );
      });

      if (vinculoTitular) {
        return true;
      }
    } catch (erro) {
      error(
        extrairMensagemErroApi(
          erro,
          "NÃ£o foi possÃ­vel validar o vÃ­nculo de titularidade."
        )
      );
      return false;
    }

    const URLCriar = `${Globais.DOMINIOBACK}/vinculo-cota-usuario`;

    try {
      const payloadVinculo = {
        cotaUsuarioId: cotaUsuarioIdAtual,
        pessoaId,
        tipoVinculo: "TITULAR",
        principal: true,
      };

      console.log("[Titularidade] Enviando vinculo-cota-usuario", {
        url: URLCriar,
        payload: payloadVinculo,
      });

      const responseCriarVinculo = await axios.post(
        URLCriar,
        payloadVinculo,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: Token.AuthStr,
          },
        }
      );

      console.log("[Titularidade] Resposta vinculo-cota-usuario", {
        status: responseCriarVinculo.status,
        data: responseCriarVinculo.data,
      });

      return true;
    } catch (erro) {
      console.error("[Titularidade] Erro ao criar vinculo-cota-usuario", erro);
      error(
        extrairMensagemErroApi(
          erro,
          "NÃ£o foi possÃ­vel salvar o vÃ­nculo de titularidade."
        )
      );
      return false;
    }
  };

  const salvarTitularidadeEAvancar = async (
    usuarioId: number
  ): Promise<boolean> => {
    const pessoaId = await buscarPessoaIdPorUsuarioId(usuarioId);

    if (!pessoaId) {
      error("NÃ£o foi possÃ­vel localizar a pessoa vinculada a este usuÃ¡rio.");
      return false;
    }

    const vinculoTitularSalvo = await garantirVinculoTitularidadeLegado(
      pessoaId
    );

    if (!vinculoTitularSalvo) {
      return false;
    }

    return concluirEtapaFluxoCadastro("AGUARDANDO_TITULARIDADE", {
      pessoaId,
      tipoVinculo: "TITULAR",
      principal: true,
    });

    /*
    const cotaUsuarioIdAtual = obterCotaUsuarioIdAtual();

    if (!cotaUsuarioIdAtual) {
      error("NÃ£o foi possÃ­vel identificar a cota do usuÃ¡rio.");
      return false;
    }

    const fluxoAtualizado = await avancarFluxoCadastro(cotaUsuarioIdAtual);

    if (!fluxoAtualizado) {
      error("NÃ£o foi possÃ­vel avanÃ§ar o fluxo de cadastro.");
      return false;
    }

    return buscarDadosCotaUsuario();
    */
  };

  const concluirEtapaFluxoCadastro = async (
    etapaAtual: EtapaCadastroCota,
    payload: Record<string, any> = {}
  ): Promise<boolean> => {
    const Token = validateToken();
    const cotaUsuarioIdAtual = obterCotaUsuarioIdAtual();

    if (!Token || !cotaUsuarioIdAtual) {
      if (!Token) {
        document.location.href = "/login";
      }
      return false;
    }

    const URL = `${Globais.DOMINIOBACK}/cota-usuario/${cotaUsuarioIdAtual}/fluxo-cadastro/concluir-etapa`;

    try {
      console.log("[FluxoCadastro] Enviando concluir-etapa", {
        url: URL,
        etapaAtual,
        payload,
      });

      const responseConcluirEtapa = await axios.post(
        URL,
        {
          etapaAtual,
          payload,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: Token.AuthStr,
          },
        }
      );

      console.log("[FluxoCadastro] Resposta concluir-etapa", {
        status: responseConcluirEtapa.status,
        data: responseConcluirEtapa.data,
      });

      return buscarDadosCotaUsuario();
    } catch (erro) {
      console.error("[FluxoCadastro] Erro ao concluir etapa", erro);
      error(
        extrairMensagemErroApi(
          erro,
          "NÃƒÂ£o foi possÃƒÂ­vel concluir a etapa do fluxo de cadastro."
        )
      );
      return false;
    }
  };

  const identificarCotaFluxoCadastro = async (
    payload: { cotaId?: number; naoSei?: boolean }
  ): Promise<boolean> => {
    const Token = validateToken();
    const contextoFluxo = contextoFluxoCadastroRef.current;

    if (!Token) {
      document.location.href = "/login";
      return false;
    }

    if (!contextoFluxo) {
      error("Nao foi possivel recuperar o contexto do fluxo de cadastro.");
      return false;
    }

    const URL = `${Globais.DOMINIOBACK}/cota-usuario/fluxo-cadastro/identificar-cota`;

    try {
      const response = await axios.post<IniciarFluxoCadastroResponse>(
        URL,
        {
          payload: {
            usuarioId: contextoFluxo.usuarioId ?? Token.id,
            empreendimentoId: contextoFluxo.empreendimentoId,
            apartamentoId: contextoFluxo.apartamentoId,
            ...payload,
          },
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: Token.AuthStr,
          },
        }
      );

      const cotaUsuarioIdFluxo = response.data?.cotaUsuarioId ?? 0;

      if (!response.data?.success || !cotaUsuarioIdFluxo) {
        error("Nao foi possivel identificar a cota selecionada.");
        return false;
      }

      const resultUsuario = await atualizarUsuarioGlobais(+Token.id, {
        status: "REGULAR",
      });

      if (!resultUsuario) {
        error("Nao foi possivel atualizar o status do usuario.");
        return false;
      }

      cotaUsuarioRef.current = cotaUsuarioIdFluxo;
      setCotaUsuarioId(cotaUsuarioIdFluxo);
      setPcotaUsuarioId({
        pCotaUsuarioId: cotaUsuarioIdFluxo,
      });

      return buscarDadosCotaUsuario();
    } catch (erro) {
      error(
        extrairMensagemErroApi(
          erro,
          "Nao foi possivel identificar a cota no fluxo de cadastro."
        )
      );
      return false;
    }
  };

  const buscarStatusFluxoCadastro = async (
    cotaUsuarioIdAtual: number
  ): Promise<string | false> => {
    const Token = validateToken();

    if (!Token) {
      document.location.href = "/login";
      return false;
    }

    const URL = `${Globais.DOMINIOBACK}/cota-usuario/${cotaUsuarioIdAtual}`;

    try {
      const response = await axios.get(URL, {
        headers: { Authorization: Token.AuthStr },
      });

      console.log("response.data", response.data);

      fluxoCadastroEstadoRef.current = extrairFluxoCadastroEstado(response.data);

      return resolverStatusFluxoCadastro(response.data);
    } catch (error) {
      console.log(error);
      return false;
    }
  };

  const hidratarContextoFluxoCadastro = async (data: any): Promise<boolean> => {
    const contextoFluxo =
      extrairContextoFluxoCadastro(data) ?? contextoFluxoCadastroRef.current;

    if (!contextoFluxo) {
      return true;
    }

    contextoFluxoCadastroRef.current = contextoFluxo;

    const apartamentoIdFluxo =
      data?.aptoId ??
      formAp.id ??
      idApRef.current ??
      contextoFluxo.apartamentoId;
    const empreendimentoIdFluxo =
      data?.empreendimentoId ??
      formEmpreendimento.id ??
      idEmpRef.current ??
      contextoFluxo.empreendimentoId;

    if (apartamentoIdFluxo && idApRef.current !== apartamentoIdFluxo) {
      return buscarMeuAp(apartamentoIdFluxo);
    }

    if (empreendimentoIdFluxo && idEmpRef.current !== empreendimentoIdFluxo) {
      return buscarMeuEmp(empreendimentoIdFluxo);
    }

    return true;
  };

  // UseState para armazanemento e posterior verificaÃ§Ã£o da origem dos apartamentos
  const [origemAp, setOrigemAp] = useState<number>();

  // UseState para armazenamento do formulario de informaÃ§Ãµes da prioridade

  // const [formMinhaCota, setFormNumeroCota] = useState<any | null>(null);
  const [formPrioridade, setFormPrioridade] = useState({
    prioridade: null,
  });

  //UseState para armazenamento do ID da cota do usuario
  const [idMinhaCota, setIdMinhaCota] = useState<number>();
  const [minhaCotaUsuario, setMinhaCotaUsuario] = useState({
    saldoDevedor: null,
    valorCondominio: null,
    valorVenda: null,
  });
  const [origemMinhaCota, setOrigemMinhaCota] = useState<number>();

  // UseState para armazenamento do formulario de informaÃ§Ãµes de quantas semanas por ano
  const [formSemanasPorAno, setFormSemanasPorAno] = useState({
    semanasPorAno: null,
  });

  // UseState necessÃ¡rio para armazenado do formulario MaisInfo
  const [formMaisInfo, setFormMaisInfo] = useState({
    saldoDevedor: null,
    valorCondominio: null,
    valorVenda: null,
    situacao: null,
  });
  // UseState para armazenamento do formulario de informaÃ§Ãµes da prioridade
  const [formDiaDaSemana, setFormDiaDaSemana] = useState({
    diaDaSemana: null,
  });

  const [formMinhaCota, setFormMinhaCota] = useState<{
    id: number | null;
    numeroCota: number | null;
  }>({
    id: null,
    numeroCota: null,
  });
  const [formMinhaCotaOrigemProprietario, setFormMinhaCotaOrigemProprietario] =
    useState<{
      numeroCota: number | undefined;
    }>({ numeroCota: undefined });

  //necessÃ¡rio para apresentaÃ§Ã£o das mensagens de erro e sucesso
  const [messageApi, contextHolder] = message.useMessage();

  const [fileList, setFileList] = useState<UploadFile[]>([]);
  const [uploading, setUploading] = useState(false);
  const [naoSabeNumeroCota, setNaoSabeNumeroCota] = useState(false);

  const [formNumeroCota] = Form.useForm();

  const [formAtualizarEstadoEmpreendimento] = Form.useForm();
  const [formAtualizarEstadoCadastro] = Form.useForm();
  const [formAtualizarEstadoDadosProprietario] = Form.useForm();

  type FileType = Parameters<GetProp<UploadProps, "beforeUpload">>[0];

  //UseEffect para resgatar dados pendentes, caso o usuario nao tenha finalizado todo o cadastro
  // dependendo do step onde ele parou, irÃ¡ recomeÃ§ar exatamente onde ele parou
  // useEffect(() => {
  //   resgatarDadosPendentes();
  // }, []);

  useEffect(() => {
    const buscarCota = async () => {
      if (pCotaUsuarioId.pCotaUsuarioId) {
        if (pCotaUsuarioId.pCotaUsuarioId !== 0) {
          const result = buscarDadosCotaUsuario();
          if (await result) {
            setCotaUsuarioId(+pCotaUsuarioId.pCotaUsuarioId);
            isLoading.current = false;
          } else {
            error("Erro ao buscar a propriedade");
          }
        } else {
          setCotaUsuarioId(+pCotaUsuarioId.pCotaUsuarioId);
        }
      }
      // resgatarDadosPendentes();
    };
    buscarCota();
  }, []);

  useEffect(() => {
    if (renderEmpSteps === 3 && ultimoRenderEmpStep.current !== 3) {
      setNaoSeiApartamento({
        capacidade: false,
        quartos: false,
        banheiros: false,
      });
      formCadastrarApartamento.resetFields();
      formCadastrarApartamento.setFieldsValue({
        ...formAp,
        empreendId:
          formAp.empreendId ?? idEmpRef.current ?? empreedimentoSelecionado?.id,
        nome: undefined,
      });
    }

    ultimoRenderEmpStep.current = renderEmpSteps;
  }, [
    renderEmpSteps,
    formCadastrarApartamento,
    formAp,
    empreedimentoSelecionado,
  ]);

  // UseEffect necessÃ¡rio para buscar os Paises
  useEffect(() => {
    const fetchToken = async () => {
      const Token = validateToken();

      if (Token) {
        const URL = `${Globais.DOMINIOBACK}/pais`;

        try {
          const response = await axios.get(URL, {
          headers: { Authorization: Token.AuthStr },
        });
          if (response) {
            const paises: Pais[] = response.data;

            // Filtrando os paises com origem igual a 0
            const paisesComOrigemZero = paises.filter(
              (pais: Pais) => pais.origem === 0
            );

            setPaises(paisesComOrigemZero);
          }
        } catch (error) {
          if (error.response.status === 401) {
            logout();
            console.log(error);
          } else {
            console.error("Erro ao buscar paises:", error);
          }
        }
      } else {
        document.location.href = "/login";
      }
    };
    fetchToken();
  }, []);

  // UseEffect necessÃ¡rio para Buscar Estado
  useEffect(() => {
    const fetchToken = async () => {
      const Token = validateToken();

      if (Token) {
        const URL = `${Globais.DOMINIOBACK}/estado`;

        try {
          const response = await axios.get(URL, {
            headers: { Authorization: Token.AuthStr },
          });
          if (response) {
            const estados: Estado[] = response.data;

            // Filtrando os estados com origem igual a 0
            const estadosComOrigemZero = estados.filter(
              (estado: Estado) => estado.origem === 0
            );

            setEstados(estadosComOrigemZero);
          }
        } catch (error) {
          if (error.response.status === 401) {
            logout();
            console.log(error);
          } else {
            console.error("Erro ao buscar estados:", error);
          }
        }
      }
    };
    fetchToken();
  }, []);

  //Buscar Cidade de acordo com o Estado selecionado
  useEffect(() => {
    if (selectedEstado) {
      const fetchToken = async () => {
        const Token = validateToken();

        if (Token) {
          const URL = `${Globais.DOMINIOBACK}/cidade`;
          try {
            const response = await axios.get(URL, {
              headers: { Authorization: Token.AuthStr },
            });
            if (response) {
              const cidades: Cidade[] = response.data;
              // Filtrando as cidades selecionadas
              const cidade = cidades.filter(
                (cidade: Cidade) => cidade.estadoId === selectedEstado
              );

              setCidades(cidade);
            }
          } catch (error) {
            if (error.response.status === 401) {
              logout();
              console.log(error);
            } else {
              console.error("Erro ao buscar cidades:", error);
            }
          }
        }
      };
      fetchToken();
    }
  }, [selectedEstado]);

  // UseEffect necessÃ¡rio para buscar os empreendimentos
  useEffect(() => {
    const fetchToken = async () => {
      const Token = validateToken();

      if (Token) {
        const URL = `${Globais.DOMINIOBACK}/empreendimento/system`;

        try {
          const response = await axios.get(URL, {
            headers: { Authorization: Token.AuthStr },
          });
          if (response) {
            const empreend = await response.data;

            setEmpreendimento(empreend);
          }
        } catch (error) {
          if (error.response.status === 401) {
            logout();
            console.log(error);
          }
        }
      }
    };
    fetchToken();
  }, []);

  //UseState necessÃ¡rio de seleÃ§Ã£o do empreendimento
  useEffect(() => {
    const fetchToken = async () => {
      const Token = validateToken();

      if (Token && empreedimentoSelecionado) {
        const URL = `${Globais.DOMINIOBACK}/apto/info/${empreedimentoSelecionado.id}`;

        try {
          const response = await axios.get(URL, {
            headers: { Authorization: Token.AuthStr },
          });
          if (response) {
            const empreend = await response.data;
            setEmpreendimentoAp(empreend);
          }
        } catch (error) {
          if (error.response.status === 401) {
            logout();
            console.log(error);
          }
        }
      }
    };
    fetchToken();
  }, [empreedimentoSelecionado]);

  //UseEffect necessÃ¡rio para trazer as informaÃ§Ãµes do apartamento selecionado
  useEffect(() => {
    if (empreendimentoSelecionadoAp) {
      const fetchToken = async () => {
        const Token = validateToken();
        if (Token) {
          const URL = `${Globais.DOMINIOBACK}/apto/${empreendimentoSelecionadoAp.id}`;
          try {
            const response = await axios.get(URL, {
              headers: { Authorization: Token.AuthStr },
            });
            if (response) {
              const ape = response.data;
              idApRef.current = ape.id;
              setFormAp((prevState) => ({
                ...prevState,
                id: ape.id,
                empreendId: ape.empreendId,
                nome: ape.nome,
                capacidade: ape.capacidade,
                quartos: ape.quartos,
                banheiros: ape.banheiros,
                metragem: ape.metragem,
                varanda: ape.varanda,
                terreo: ape.terreo,
                estacionamento: ape.estacionamento,
                origem: ape.origem,
                vista: ape.vista,
              }));

              setApEmpreendimentoId(ape.id);

              setApSelecionado(ape);
              formApartamento.setFieldsValue({
                propriedade: {
                  capacidade: ape.capacidade,
                  quartos: ape.quartos,
                  banheiros: ape.banheiros,
                  metragem: ape.metragem,
                  varanda:
                    ape.varanda === 1
                      ? "Sim"
                      : ape.varanda === 2
                      ? "NÃ£o"
                      : "NÃ£o definido",
                  terreo:
                    ape.terreo === 1
                      ? "Sim"
                      : ape.terreo === 2
                      ? "NÃ£o"
                      : "NÃ£o definido",
                  estacionamento:
                    ape.estacionamento === 1
                      ? "Sim"
                      : ape.estacionamento === 2
                      ? "NÃ£o"
                      : "NÃ£o definido",
                },
              });
            }
          } catch (error) {
            if (error.response && error.response.status === 401) {
              logout();
              console.log(error);
            }
          }
        }
      };
      fetchToken();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [empreendimentoSelecionadoAp]);

  //UseEffect necessÃ¡rio que traz as informaÃ§Ãµes do usuario, caso ele tenha estado civil e nacionalidade.
  useEffect(() => {
    const buscarInfoUsuario = async () => {
      const Token = validateToken();
      if (Token) {
        const tokenId = Token.id;
        const URL = `${Globais.DOMINIOBACK}/usuario/${tokenId}`;
        const response = await axios.get(URL, {
          headers: { Authorization: Token.AuthStr },
        });
        if (
          response.data &&
          response.data.estadoCivil &&
          Object.keys(response.data.estadoCivil).length > 0 &&
          response.data.nacionalidade &&
          Object.keys(response.data.nacionalidade).length > 0
        ) {
          setFormAtualizarCadastro((prevState) => ({
            ...prevState,
            estadoCivil: response.data.estadoCivil,
            nacionalidade: response.data.nacionalidade,
            rg: response.data.rg,
          }));
        }
      }
    };
    buscarInfoUsuario();
  }, []);

  //UseEffect necessÃ¡rio que traz as informaÃ§Ãµes do usuario, caso ele tenha endereÃ§o.
  useEffect(() => {
    const buscarInfoUsuario = async () => {
      const Token = validateToken();
      if (Token) {
        const tokenId = Token.id;
        const URL = `${Globais.DOMINIOBACK}/endereco/usuario/${tokenId}`;

        const response = await axios.get(URL, {
          headers: { Authorization: Token.AuthStr },
        });

        if (response.data && Object.keys(response.data).length > 0) {
          setFormAtualizarCadastro((prevState) => ({
            ...prevState,
            endereco: response.data.endereco,
            complemento: response.data.complemento,
            estadoId: response.data.estadoId,
            cidadeId: response.data.cidadeId,
          }));
        }
      }
    };
    buscarInfoUsuario();
  }, []);

  // UseEffect necessÃ¡rio para realizar a busca apÃ³s o envio do comprovante
  useEffect(() => {
    const buscarMeuArquivo = async () => {
      const formData = new FormData();
      const Token = validateToken();
      if (Token) {
        const URL = `${Globais.DOMINIOBACK}/arquivo-cota-usuario/cotaUsuario/${cotaUsuarioRef.current}`;

        try {
          const response = await axios.get(URL, {
            headers: {
              Authorization: Token.AuthStr,
              "Content-type": "multipart/form-data",
            },
          });

          setUploadedFiles(response.data);
        } catch (error) {
          console.log(error);
        }
      }
    };
    buscarMeuArquivo();
  }, [uploading]);

  const success = (texto: string) => {
    messageApi.open({
      type: "success",
      content: texto,
    });
  };

  const error = (texto: string) => {
    messageApi.open({
      type: "error",
      content: texto,
    });
  };
  const warning = (texto: string) => {
    messageApi.open({
      type: "warning",
      content: texto,
    });
  };

  const criandoTelaFinalizacao = async (cotaUsuarioId: number) => {
    let texto = "";

    const resultPagamentoAtiva = await verificarPagamentoPorStatus(
      "ATIVA",
      cotaUsuarioId
    );

    if (resultPagamentoAtiva) {
      setPagamentoRegularizado("Sim");
    } else {
      const resultPagamentoPendente = verificarPagamentoPorStatus(
        "PENDENTE",
        cotaUsuarioId
      );
      if (await resultPagamentoPendente) {
        setPagamentoRegularizado("NÃ£o. Aguardando confirmaÃ§Ã£o");
        texto +=
          "Vi aqui que seu pagamento ainda estÃ¡ pendente. \n Se jÃ¡ efetuou o pagamento nÃ£o se preocupe, aguarde a confirmaÃ§Ã£o.\n";
      } else {
        setPagamentoRegularizado("NÃ£o hÃ¡ pagamentos");
      }
    }

    const representantes = await buscarTodosOsRepresentantesCotaUsuario(
      cotaUsuarioId
    );
    if (representantes) {
      if (
        representantes[0].checked === 0 &&
        representantes[0].dataVencimento === null
      ) {
        setRepresentanteRegularizado("NÃ£o");
        texto +=
          "Consta que o representante nÃ£o estÃ¡ regularizado.\n Se jÃ¡ incluiu os dados do representante basta aguardar a equipe terminar o procedimento.\n";
      } else {
        setRepresentanteRegularizado("Sim");
      }
    } else {
      setRepresentanteRegularizado("NÃ£o hÃ¡ representantes");
    }

    const resultCTUChecada = verificarCTUChecada(cotaUsuarioId);
    if (await resultCTUChecada) {
      setPropriedadeAutenticada("Sim");
    } else {
      setPropriedadeAutenticada("NÃ£o");
      texto +=
        "Sua propriedade ainda nÃ£o estÃ¡ autenticada, \n se jÃ¡ incluiu o comprovante basta aguardar a equipe confirmar o procedimento.\n";
    }

    const result = verificarSeTemPeriodoUsuarioDefinido(cotaUsuarioId);
    if (await result) {
      bloqueadoEdicao.current = true;
      setBloquearBotaoProximo(false);
      setPropriedadeTemPeriodos("Sim");
      setPropriedadeTemPeriodosDefinidos("Sim");
      texto +=
        "Quanto aos seus perÃ­odos estÃ¡ tudo certo. \n Agora basta aguardar que entraremos em contato caso existam interessados nos seus perÃ­odos.";
    } else {
      const result = verificarSeTemPeriodoUsuario(cotaUsuarioId);
      if (await result) {
        setPropriedadeTemPeriodos("Sim");
        setPropriedadeTemPeriodosDefinidos("NÃ£o");
      } else {
        setPropriedadeTemPeriodos("NÃ£o");
        setPropriedadeTemPeriodosDefinidos("NÃ£o");
      }
    }

    setTextoFinalizacao(texto);
  };

  const telaDePagamento = async () => {
    const resultPagamentoAtivo = await verificarPagamentoPorStatus(
      "ATIVA",
      cotaUsuarioId
    );
    const resultPagamentoPendente = await verificarPagamentoPorStatus(
      "PENDENTE",
      cotaUsuarioId
    );
    if (resultPagamentoAtivo || resultPagamentoPendente) {
      switch (anunciar) {
        case 1:
          const result = await verificarSeMaisInformacoesAnuncioEstaoAusentes(
            cotaUsuarioId
          );
          if (result) {
            setBloquearBotaoProximo(true);
          }
          setActiveStep(3);
          setRenderPagamentoSteps(2);

          break;
        case 2:
          let sucesso;
          switch (cronogramaEmp.current) {
            case 0:
              const periodosDefinidos =
                verificarSeTemPeriodoUsuarioDefinido(cotaUsuarioId);
              if (await periodosDefinidos) {
                setActiveStep(6);
              } else {
                const temPeriodos = await verificarSeTemPeriodoUsuario(
                  cotaUsuarioId
                );
                if (temPeriodos) {
                  sucesso = atualizarCotaUsuario(
                    "AGUARDANDO_DEFINICAO_PERIODOS"
                  );
                  if (await sucesso) {
                    changing.current = false;
                    //indo para mensagem de desistencia pagamento
                    setActiveStep(5);
                    setRenderAdicionarPeriodo(3);
                  } else {
                    error("HÃ¡ algo de errado. CÃ³digo de erro: VCP-074");
                  }
                } else {
                  sucesso = atualizarCotaUsuario("AGUARDANDO_PERIODOS");
                  if (await sucesso) {
                    changing.current = false;
                    //indo para mensagem de desistencia pagamento
                    setActiveStep(4);
                    setRenderAdicionarPeriodo(1);
                  } else {
                    error("HÃ¡ algo de errado. CÃ³digo de erro: VCP-073");
                  }
                }
              }

              break;
            case 1:
              const periodosDefinidosCase1 =
                verificarSeTemPeriodoUsuarioDefinido(cotaUsuarioId);
              if (await periodosDefinidosCase1) {
                setActiveStep(6);
              } else if (deveUsarFluxoManualComCotaUsuario()) {
                await atualizarFluxoManualPeriodos("VCP-074", "VCP-075");
              } else {
                sucesso = atualizarCotaUsuario("AGUARDANDO_DEFINICAO_PERIODOS");
                if (await sucesso) {
                  changing.current = false;
                  //indo para mensagem de desistencia pagamento
                  setActiveStep(5);
                  setRenderAdicionarPeriodo(3);
                } else {
                  error("HÃ¡ algo de errado. CÃ³digo de erro: VCP-074");
                }
              }

              break;

            case 2:
              const periodosDefinidosCase2 =
                verificarSeTemPeriodoUsuarioDefinido(cotaUsuarioId);
              if (await periodosDefinidosCase2) {
                setActiveStep(6);
              } else {
                const temPeriodos = await verificarSeTemPeriodoUsuario(
                  cotaUsuarioId
                );
                if (temPeriodos) {
                  sucesso = atualizarCotaUsuario(
                    "AGUARDANDO_DEFINICAO_PERIODOS"
                  );
                  if (await sucesso) {
                    changing.current = false;
                    //indo para mensagem de desistencia pagamento
                    setActiveStep(5);
                    setRenderAdicionarPeriodo(3);
                  } else {
                    error("HÃ¡ algo de errado. CÃ³digo de erro: VCP-074");
                  }
                } else {
                  sucesso = atualizarCotaUsuario("AGUARDANDO_PERIODOS");
                  if (await sucesso) {
                    changing.current = false;
                    //indo para mensagem de desistencia pagamento
                    setActiveStep(4);
                    setRenderAdicionarPeriodo(2);
                  } else {
                    error("HÃ¡ algo de errado. CÃ³digo de erro: VCP-075");
                  }
                }
              }

              break;
          }
          break;
      }
    } else {
      setActiveStep(3);
      setRenderPagamentoSteps(1);
    }
  };

  const deveUsarFluxoManualComCotaUsuario = () =>
    cronogramaEmp.current === 1 &&
    origemApRef.current === 0 &&
    (naoSabeNumeroCota ||
      (origemMinhaCota !== undefined && origemMinhaCota !== 0));

  const abrirTelaInclusaoManualPeriodos = () => {
    setActiveStep(4);
    setRenderAdicionarPeriodo(2);
  };

  const abrirTelaDefinicaoManualPeriodos = () => {
    setActiveStep(5);
    setRenderAdicionarPeriodo(4);
  };

  const atualizarFluxoManualPeriodos = async (
    codigoErroDefinicao: string,
    codigoErroPeriodo: string
  ): Promise<boolean> => {
    const temPeriodos = await verificarSeTemPeriodoUsuario(cotaUsuarioId);

    if (temPeriodos) {
      const sucesso = atualizarCotaUsuario("AGUARDANDO_DEFINICAO_PERIODOS");
      if (await sucesso) {
        changing.current = false;
        abrirTelaDefinicaoManualPeriodos();
        return true;
      }

      error(`HÃ¡ algo de errado. CÃ³digo de erro: ${codigoErroDefinicao}`);
      return false;
    }

    const sucesso = atualizarCotaUsuario("AGUARDANDO_PERIODOS");
    if (await sucesso) {
      changing.current = false;
      abrirTelaInclusaoManualPeriodos();
      return true;
    }

    error(`HÃ¡ algo de errado. CÃ³digo de erro: ${codigoErroPeriodo}`);
    return false;
  };

  const abrirFluxoManualPeriodosSemAtualizarStatus = async () => {
    const temPeriodos = await verificarSeTemPeriodoUsuario(cotaUsuarioId);

    if (temPeriodos) {
      abrirTelaDefinicaoManualPeriodos();
    } else {
      abrirTelaInclusaoManualPeriodos();
    }
  };

  const buscarDadosCotaUsuario = async (): Promise<boolean> => {
    const Token = validateToken();
    if (Token) {
      const cotaUsuarioIdAtual = obterCotaUsuarioIdAtual();

      if (!cotaUsuarioIdAtual) {
        return false;
      }

      const URL = `${Globais.DOMINIOBACK}/cota-usuario/${cotaUsuarioIdAtual}`;

      setUsuarioLogadoId(+Token.id);

      const tokenId = Token.id;
      try {
        const response = await axios.get(URL, {
          headers: { Authorization: Token.AuthStr },
        });

        setMinhaCotaUsuario((prevState) => ({
          ...prevState,
          saldoDevedor: response.data.saldoDevedor,
          valorCondominio: response.data.valorCondominio,
          valorVenda: response.data.valorVenda,
        }));

        console.log("response.data", response.data);
        // Armazena as informaÃ§os de cota Usuario ao formulario Mais Info Anuncio
        setFormMaisInfo({
          saldoDevedor: response.data.saldoDevedor,
          valorCondominio: response.data.valorCondominio,
          valorVenda: response.data.valorVenda,
          situacao: response.data.situacao,
        });
        setServicosSelecionados(obterServicosSelecionados(response.data));

        setMinhaSituacao(response.data.situacao);
        let isAuthorized = true;
        setCotaUsuarioId(response.data.id);

        if (
          response.data.usuarioId !== tokenId &&
          cotaUsuarioIdAtual !== 0
        ) {
          // VERIFICA SE A COTA USUARIO PERTENCE AO USUARIO LOGADO
          const URLRepresentante = `${Globais.DOMINIOBACK}/representante/usuario/${Token.id}`;
          try {
            // VERIFICA SE A COTA USUARIO PERTENCE AO USUARIO LOGADO COMO REPRESENTANTE
            const representante = await axios.get(URLRepresentante, {
              headers: { Authorization: Token.AuthStr },
            });

            if (representante) {
              let resultado = representante.data.filter((p: any) => {
                if (p.cotasUsuariosId === cotaUsuarioIdAtual) {
                  return p;
                }
              });
              if (resultado.length === 0) {
                isAuthorized = false;
              } else {
                representanteRef.current = 1;
              }
            } else {
              error("HÃ¡ algo de errado. CÃ³digo de erro: VCP-039");
            }
          } catch (error) {
            console.error(error);
            isAuthorized = false; // Se der erro, tambÃ©m nÃ£o serÃ¡ autorizado
          }
        }

        // Verifica se estÃ¡ autorizado antes de continuar
        if (!isAuthorized) {
          // SE NÃƒO FOR ENCONTRADO, O USUARIO Ã‰ REDIRECIONADO A HOME
          error("Acesso negado: usuÃ¡rio nÃ£o autorizado.");
          setTimeout(() => {
            document.location.href = "/cadastroCotas";
          }, 2000);

          return false; // Sai da funÃ§Ã£o se nÃ£o estiver autorizado
        } else {
          setCotaUsuarioId(response.data.id);
          setCotaId(response.data.cotaId ?? 0);
          formPrioridade.prioridade = response.data.prioridade
            ? response.data.prioridade
            : null;

          const contextoFluxoHidratado = await hidratarContextoFluxoCadastro(
            response.data
          );

          if (!contextoFluxoHidratado) {
            error("HÃƒÂ¡ algo de errado. CÃƒÂ³digo de erro: VCP-098");
            return false;
          }

          if (origemEmpRef.current === 0) {
            setNaoEncontrouEmpreendimento(false);
            setEmpreendimentoNaoSelecionado(false);
          } else {
            setNaoEncontrouEmpreendimento(true);
            setEmpreendimentoNaoSelecionado(true);
          }

          const statusFluxo = resolverStatusFluxoCadastro(response.data);

          switch (statusFluxo) {
            case "AGUARDANDO_APTO":
              setFormInfo(response.data);

              const sucessoMinhaCotaAptoMaisApto = await buscarMinhaCota(
                response.data.cotaId
              );
              if (sucessoMinhaCotaAptoMaisApto) {
                setBloquearBotaoProximo(true);
                setRenderEmpSteps(3);
                setActiveStep(0);

                if (origemEmpRef.current !== 0 && origemApRef.current !== 0) {
                  setEmpreendimentoSelecionado(null);
                  setApCriadoPeloUsuario(true);
                } else if (
                  origemEmpRef.current === 0 &&
                  origemApRef.current !== 0
                ) {
                  setApCriadoPeloUsuario(true);
                } else {
                  setApCriadoPeloUsuario(false);
                }
                stateNovo.current = "AGUARDANDO_APTO";
                setState("AGUARDANDO_APTO");
              } else {
                error("HÃ¡ algo de errado. CÃ³digo erro: VCP-009");
              }

              return true;
            case "AGUARDANDO_TITULARIDADE":
              setFormInfo(response.data);
              stateNovo.current = "AGUARDANDO_TITULARIDADE";
              setState("AGUARDANDO_TITULARIDADE");

              const [
                sucessobuscarMinhaCota,
                sucessobuscarDadosProprietario,
                sucessobuscarEndereco,
                sucessoDadosRepresentante,
              ] = await Promise.all([
                buscarMinhaCota(response.data.cotaId),
                buscarDadosProprietario(response.data.usuarioId),
                buscarEndereco(response.data.usuarioId, "representante"),
                buscarDadosRepresentante(),
              ]);
              if (
                sucessobuscarMinhaCota &&
                sucessobuscarDadosProprietario &&
                sucessobuscarEndereco &&
                sucessoDadosRepresentante
              ) {
                //EMPREENDIMENTO  E APARTAMENTO DO USUARIO
                if (origemEmpRef.current !== 0 && origemApRef.current !== 0) {
                  setActiveStep(1);
                  setApCriadoPeloUsuario(true);
                  setEmpreendimentoSelecionado(null);
                  setNaoEncontrouEmpreendimento(true);
                  setEmpreendimentoNaoSelecionado(true);
                }
                //EMPREENDIMENTO DO SISTEMA E APARTAMENTO DO USUARIO
                else if (
                  origemEmpRef.current === 0 &&
                  origemApRef.current !== 0
                ) {
                  setActiveStep(1);
                  setApCriadoPeloUsuario(true);
                }
                //EMPREENDIMENTO  E APARTAMENTO DO SISTEMA
                else {
                  setActiveStep(1);
                  setApCriadoPeloUsuario(false);
                }

                if (propriedadeRes === 0) {
                  setBloquearBotaoProximo(true);
                }

                return true;
              } else {
                return false;
              }
            case "AGUARDANDO_REPRESENTANTE":
              setFormInfo(response.data);
              stateNovo.current = "AGUARDANDO_REPRESENTANTE";
              setState("AGUARDANDO_REPRESENTANTE");

              setPropriedadeRes(2);
              setBloquearBotaoProximo(false);

              const [
                sucessobuscarMinhaCotaRep,
                sucessobuscarDadosProprietarioRep,
                sucessobuscarEnderecoRep,
                sucessoDadosRepresentanteRep,
              ] = await Promise.all([
                buscarMinhaCota(response.data.cotaId),
                buscarDadosProprietario(response.data.usuarioId),
                buscarEndereco(response.data.usuarioId, "representante"),
                buscarDadosRepresentante(),
              ]);
              if (
                sucessobuscarMinhaCotaRep &&
                sucessobuscarDadosProprietarioRep &&
                sucessobuscarEnderecoRep &&
                sucessoDadosRepresentanteRep
              ) {
                //EMPREENDIMENTO  E APARTAMENTO DO USUARIO
                if (origemEmpRef.current !== 0 && origemApRef.current !== 0) {
                  setRenderEmpSteps(4);

                  setApCriadoPeloUsuario(true);
                  setEmpreendimentoSelecionado(null);
                }
                //EMPREENDIMENTO DO SISTEMA E APARTAMENTO DO USUARIO
                else if (
                  origemEmpRef.current === 0 &&
                  origemApRef.current !== 0
                ) {
                  setRenderApSteps(3);

                  setApCriadoPeloUsuario(true);
                }
                //EMPREENDIMENTO  E APARTAMENTO DO SISTEMA
                else {
                  setRenderApSteps(3);

                  setApCriadoPeloUsuario(false);
                }
                if (origemEmpRef.current === 0) {
                  setNaoEncontrouEmpreendimento(false);
                  setEmpreendimentoNaoSelecionado(false);
                } else {
                  setNaoEncontrouEmpreendimento(true);
                  setEmpreendimentoNaoSelecionado(true);
                }

                return true;
              } else {
                return false;
              }
            case "AGUARDANDO_COMPROVANTE":
              setFormInfo(response.data);
              stateNovo.current = "AGUARDANDO_COMPROVANTE";
              setState("AGUARDANDO_COMPROVANTE");

              const [
                sucesso,
                sucessoProprietario,
                sucessoEnderecoProprietario,
                sucessoRepresentante,
              ] = await Promise.all([
                buscarMinhaCota(response.data.cotaId),
                buscarDadosProprietario(response.data.usuarioId),
                buscarEndereco(response.data.usuarioId, "proprietario"),
                buscarDadosRepresentante(),
              ]);
              if (
                sucesso &&
                sucessoProprietario &&
                sucessoEnderecoProprietario &&
                sucessoRepresentante
              ) {
                // Se empreendimeto e apartamento tiverem origem diferente de 0
                if (origemEmpRef.current !== 0 && origemApRef.current !== 0) {
                  //EMPREENDIMENTO  E APARTAMENTO DO USUARIO
                  setEmpreendimentoSelecionado(null);
                  setRenderEmpSteps(4);
                  setApCriadoPeloUsuario(true);
                } else if (
                  // EMPREENDIMENTO DO SISTEMA E APARTAMENTO DO USUARIO
                  origemEmpRef.current === 0 &&
                  origemApRef.current !== 0
                ) {
                  setRenderApSteps(3);
                  setApCriadoPeloUsuario(true);
                } else {
                  //EMPREENDIMENTO  E APARTAMENTO DO SISTEMA
                  setApCriadoPeloUsuario(false);

                  setRenderApSteps(3);
                }
                if (origemEmpRef.current === 0) {
                  setNaoEncontrouEmpreendimento(false);
                  setEmpreendimentoNaoSelecionado(false);
                } else {
                  setNaoEncontrouEmpreendimento(true);
                  setEmpreendimentoNaoSelecionado(true);
                }
                if (representanteRef.current === 0) {
                  setPropriedadeRes(1);
                } else {
                  setCpfEmailBloqueado(true);
                  setPropriedadeRes(2);
                }
                setRenderProprietario(4);
                setActiveStep(1);
                const resultado = await verificarSeTemArquivos(cotaUsuarioId);
                if (resultado) {
                  setBloquearBotaoProximo(false);
                } else {
                  setBloquearBotaoProximo(true);
                }

                return true;
              } else {
                console.log("Falha ao obter todas as informaÃ§Ãµes necessÃ¡rias");
                return false;
              }
            case "AGUARDANDO_COTA":
              setFormInfo(response.data);

              cotaUsuarioRef.current = response.data.id;
              stateNovo.current = "AGUARDANDO_COTA";
              buscarMeuArquivo();
              setState("AGUARDANDO_COTA");
              const [
                sucessoAGCT,
                sucessoProprietarioAGCT,
                sucessoEnderecoProprietarioAGCT,
                sucessoRepresentanteAGCT,
              ] = await Promise.all([
                buscarMinhaCota(response.data.cotaId),
                buscarDadosProprietario(response.data.usuarioId),
                buscarEndereco(response.data.usuarioId, "proprietario"),
                buscarDadosRepresentante(),
              ]);
              if (
                sucessoAGCT &&
                sucessoProprietarioAGCT &&
                sucessoEnderecoProprietarioAGCT &&
                sucessoRepresentanteAGCT
              ) {
                // Se empreendimeto e apartamento tiverem origem diferente de 0
                if (origemEmpRef.current !== 0 && origemApRef.current !== 0) {
                  //EMPREENDIMENTO  E APARTAMENTO DO USUARIO
                  setEmpreendimentoSelecionado(null);

                  setApCriadoPeloUsuario(true);
                } else if (
                  // EMPREENDIMENTO DO SISTEMA E APARTAMENTO DO USUARIO
                  origemEmpRef.current === 0 &&
                  origemApRef.current !== 0
                ) {
                  setApCriadoPeloUsuario(true);
                } else {
                  //EMPREENDIMENTO  E APARTAMENTO DO SISTEMA
                  setApCriadoPeloUsuario(false);
                }
                if (origemEmpRef.current === 0) {
                  setNaoEncontrouEmpreendimento(false);
                  setEmpreendimentoNaoSelecionado(false);
                } else {
                  setNaoEncontrouEmpreendimento(true);
                  setEmpreendimentoNaoSelecionado(true);
                }

                switch (cronogramaEmp.current) {
                  case 0:
                    prioridadeRef.current = true;
                    setRenderProprietario(100);
                    setRenderPrioridadeSteps(1);
                    setRenderCotaSteps(0);
                    setActiveStep(2);
                    break;
                  case 1:
                    
                    cotaRef.current = true;
                    buscarCotas();
                    setRenderProprietario(100);
                    setRenderPrioridadeSteps(0);
                    setRenderCotaSteps(1);
                    if (
                      formMinhaCotaOrigemProprietario.numeroCota ===
                        undefined ||
                      formMinhaCotaOrigemProprietario.numeroCota === 0
                    ) {
                      setBloquearBotaoProximo(true);
                    } else {
                      
                      setBloquearBotaoProximo(false);
                    }
                    setActiveStep(2);
                    break;
                  case 2:
                    setEmpreendimentoSelecionado(null);
                    setRenderProprietario(100);
                    setRenderPrioridadeSteps(0);
                    setRenderCotaSteps(0);
                    setActiveStep(2);
                    break;
                }

                if (representanteRef.current === 0) {
                  setPropriedadeRes(1);
                } else {
                  setCpfEmailBloqueado(true);
                  setPropriedadeRes(2);
                }
                if (cronogramaFixoOuPrioridade === 0) {
                  
                  setBloquearBotaoProximo(true);
                } else {
                  setBloquearBotaoProximo(false);
                }

                return true;
              } else {
                error("Nao foi possivel carregar os dados da cota selecionada.");
                return false;
              }
            case "AGUARDANDO_DEFINICAO_ANUNCIO":
              setState("AGUARDANDO_DEFINICAO_ANUNCIO");
              stateNovo.current = "AGUARDANDO_DEFINICAO_ANUNCIO";
              setFormInfo(response.data);
              setBloquearBotaoProximo(true);

              cotaUsuarioRef.current = response.data.id;

              buscarMeuArquivo();
              const [
                sucessoAGPGT,
                sucessoProprietarioAGPGT,
                sucessoEnderecoProprietarioAGPGT,
                sucessoRepresentanteAGPGT,
              ] = await Promise.all([
                buscarMinhaCota(response.data.cotaId),
                buscarDadosProprietario(response.data.usuarioId),
                buscarEndereco(response.data.usuarioId, "proprietario"),
                buscarDadosRepresentante(),
              ]);

              if (
                sucessoAGPGT &&
                sucessoProprietarioAGPGT &&
                sucessoEnderecoProprietarioAGPGT &&
                sucessoRepresentanteAGPGT
              ) {
                // Se empreendimeto e apartamento tiverem origem diferente de 0
                if (origemEmpRef.current !== 0 && origemApRef.current !== 0) {
                  //EMPREENDIMENTO  E APARTAMENTO DO USUARIO
                  setEmpreendimentoSelecionado(null);
                  setRenderEmpSteps(4);

                  setApCriadoPeloUsuario(true);
                } else if (
                  // EMPREENDIMENTO DO SISTEMA E APARTAMENTO DO USUARIO
                  origemEmpRef.current === 0 &&
                  origemApRef.current !== 0
                ) {
                  setApCriadoPeloUsuario(true);
                  setRenderApSteps(3);
                } else {
                  //EMPREENDIMENTO  E APARTAMENTO DO SISTEMA
                  setApCriadoPeloUsuario(false);
                  setRenderApSteps(3);
                }
                if (origemEmpRef.current === 0) {
                  setNaoEncontrouEmpreendimento(false);
                  setEmpreendimentoNaoSelecionado(false);
                } else {
                  setNaoEncontrouEmpreendimento(true);
                  setEmpreendimentoNaoSelecionado(true);
                }
                if (representanteRef.current === 0) {
                  setPropriedadeRes(1);
                } else {
                  setCpfEmailBloqueado(true);
                  setPropriedadeRes(2);
                }

                // Faz a verificaÃ§Ã£o se existe cronograma, se sim vai para tela de cotas se nao , volta para a tela de prioridades
                if (cronogramaRef.current !== 0) {
                  cotaRef.current = true;
                  setRenderCotaSteps(1);
                } else {
                  prioridadeRef.current = true;
                  setRenderPrioridadeSteps(3);
                }
                setRenderProprietario(4);

                buscarCotas();
                telaDePagamento();

                return true;
              } else {
                console.log("Falha ao obter todas as informaÃ§Ãµes necessÃ¡rias");
                return false;
              }
            case "AGUARDANDO_MAISINFO_ANUNCIO":
              setState("AGUARDANDO_MAISINFO_ANUNCIO");
              stateNovo.current = "AGUARDANDO_MAISINFO_ANUNCIO";
              setFormInfo(response.data);
              setBloquearBotaoProximo(true);

              cotaUsuarioRef.current = response.data.id;

              buscarMeuArquivo();
              const [
                sucessoAGPGTMINFO,
                sucessoProprietarioAGPGTMINFO,
                sucessoEnderecoProprietarioAGPGTMINFO,
                sucessoRepresentanteAGPGTMINFO,
              ] = await Promise.all([
                buscarMinhaCota(response.data.cotaId),
                buscarDadosProprietario(response.data.usuarioId),
                buscarEndereco(response.data.usuarioId, "proprietario"),
                buscarDadosRepresentante(),
              ]);

              if (
                sucessoAGPGTMINFO &&
                sucessoProprietarioAGPGTMINFO &&
                sucessoEnderecoProprietarioAGPGTMINFO &&
                sucessoRepresentanteAGPGTMINFO
              ) {
                // Se empreendimeto e apartamento tiverem origem diferente de 0
                if (origemEmpRef.current !== 0 && origemApRef.current !== 0) {
                  //EMPREENDIMENTO  E APARTAMENTO DO USUARIO
                  setEmpreendimentoSelecionado(null);
                  setRenderEmpSteps(4);
                } else if (
                  // EMPREENDIMENTO DO SISTEMA E APARTAMENTO DO USUARIO
                  origemEmpRef.current === 0 &&
                  origemApRef.current !== 0
                ) {
                  setApCriadoPeloUsuario(true);
                  setRenderApSteps(3);
                } else {
                  //EMPREENDIMENTO  E APARTAMENTO DO SISTEMA
                  setApCriadoPeloUsuario(false);
                  setRenderApSteps(3);
                }
                if (origemEmpRef.current === 0) {
                  setNaoEncontrouEmpreendimento(false);
                  setEmpreendimentoNaoSelecionado(false);
                } else {
                  setNaoEncontrouEmpreendimento(true);
                  setEmpreendimentoNaoSelecionado(true);
                }
                if (representanteRef.current === 0) {
                  setPropriedadeRes(1);
                } else {
                  setCpfEmailBloqueado(true);
                  setPropriedadeRes(2);
                }
                setRenderProprietario(4);

                if (
                  minhaCotaUsuario.saldoDevedor === null ||
                  minhaCotaUsuario.valorCondominio === null ||
                  minhaCotaUsuario.valorVenda === null
                ) {
                  // setBloquearBotaoProximo(true);
                }

                buscarCotas();
                setAnunciar(1);

                setRenderPagamentoSteps(2);
                setActiveStep(3);

                return true;
              } else {
                console.log("Falha ao obter todas as informaÃ§Ãµes necessÃ¡rias");
                return false;
              }
            case "AGUARDANDO_PERIODOS":
              setFormInfo(response.data);
              setBloquearBotaoProximo(false); //

              cotaUsuarioRef.current = response.data.id;
              formPrioridade.prioridade = response.data.prioridade;

              buscarMeuArquivo();
              stateNovo.current = "AGUARDANDO_PERIODOS";
              setState("AGUARDANDO_PERIODOS");
              const [
                sucessoAGPE,
                sucessoProprietarioAGPE,
                sucessoEnderecoProprietarioAGPE,
                sucessoRepresentanteAGPE,
              ] = await Promise.all([
                buscarMinhaCota(response.data.cotaId),
                buscarDadosProprietario(response.data.usuarioId),
                buscarEndereco(response.data.usuarioId, "proprietario"),
                buscarDadosRepresentante(),
              ]);

              if (
                sucessoAGPE &&
                sucessoProprietarioAGPE &&
                sucessoEnderecoProprietarioAGPE &&
                sucessoRepresentanteAGPE
              ) {
                // Se empreendimeto e apartamento tiverem origem diferente de 0
                if (origemEmpRef.current !== 0 && origemApRef.current !== 0) {
                  //EMPREENDIMENTO  E APARTAMENTO DO USUARIO
                  setEmpreendimentoSelecionado(null);
                  setRenderEmpSteps(4);
                  setRenderApSteps(0);
                  setApCriadoPeloUsuario(true);
                } else if (
                  // EMPREENDIMENTO DO SISTEMA E APARTAMENTO DO USUARIO
                  origemEmpRef.current === 0 &&
                  origemApRef.current !== 0
                ) {
                  setApCriadoPeloUsuario(true);
                  setRenderApSteps(3);
                  setRenderEmpSteps(0);
                } else {
                  //EMPREENDIMENTO  E APARTAMENTO DO SISTEMA
                  setApCriadoPeloUsuario(false);
                  setRenderApSteps(3);
                  setRenderEmpSteps(0);
                }
                if (representanteRef.current === 0) {
                  setPropriedadeRes(1);
                } else {
                  setCpfEmailBloqueado(true);
                  setPropriedadeRes(2);
                }

                buscarCotas();

                const assinatura = await buscarAssinaturaPorCotaUsuario(
                  cotaUsuarioRef.current
                );
                if (assinatura) {
                  setAnunciar(1);
                } else {
                  setAnunciar(2);
                }

                switch (cronogramaEmp.current) {
                  case 0:
                    setActiveStep(4);
                    if (origemApRef.current !== 0) {
                      setRenderAdicionarPeriodo(2);
                    } else {
                      setRenderAdicionarPeriodo(1);
                    }

                    setCronogramaFixoOuPrioridade(2);
                    break;
                  case 1:
                    if (deveUsarFluxoManualComCotaUsuario()) {
                      abrirTelaInclusaoManualPeriodos();
                    } else {
                      setActiveStep(5);
                      if (origemApRef.current !== 0) {
                        setRenderAdicionarPeriodo(4);
                      } else {
                        setRenderAdicionarPeriodo(3);
                      }
                    }

                    setCronogramaFixoOuPrioridade(1);
                    break;
                  case 2:
                    setActiveStep(4);
                    setRenderAdicionarPeriodo(2);

                    break;
                }
                return true;
              } else {
                error("HÃ¡ algo de errado. CÃ³digo de erro: VCP-076");
                return false;
              }

            case "AGUARDANDO_DEFINICAO_PERIODOS":
              setBloquearBotaoProximo(false);

              // nÃ£o tem periodos definidos. vai para a mensagem de definiÃ§Ã£o.
              setFormInfo(response.data);
              setBloquearBotaoProximo(false);
              cotaUsuarioRef.current = response.data.id;

              formPrioridade.prioridade = response.data.prioridade;
              buscarMeuArquivo();
              stateNovo.current = "AGUARDANDO_DEFINICAO_PERIODOS";
              setState("AGUARDANDO_DEFINICAO_PERIODOS");
              const [
                sucessoAGPDE,
                sucessoProprietarioAGPDE,
                sucessoEnderecoProprietarioAGPDE,
                sucessoRepresentanteAGPDE,
              ] = await Promise.all([
                buscarMinhaCota(response.data.cotaId),
                buscarDadosProprietario(response.data.usuarioId),
                buscarEndereco(response.data.usuarioId, "proprietario"),
                buscarDadosRepresentante(),
              ]);

              if (
                sucessoAGPDE &&
                sucessoProprietarioAGPDE &&
                sucessoEnderecoProprietarioAGPDE &&
                sucessoRepresentanteAGPDE
              ) {
                // Se empreendimeto e apartamento tiverem origem diferente de 0
                if (origemEmpRef.current !== 0 && origemApRef.current !== 0) {
                  //EMPREENDIMENTO  E APARTAMENTO DO USUARIO
                  setEmpreendimentoSelecionado(null);

                  setApCriadoPeloUsuario(true);
                } else if (
                  // EMPREENDIMENTO DO SISTEMA E APARTAMENTO DO USUARIO
                  origemEmpRef.current === 0 &&
                  origemApRef.current !== 0
                ) {
                  setApCriadoPeloUsuario(true);
                } else {
                  //EMPREENDIMENTO  E APARTAMENTO DO SISTEMA
                  setApCriadoPeloUsuario(false);
                }
                if (origemEmpRef.current === 0) {
                  setNaoEncontrouEmpreendimento(false);
                  setEmpreendimentoNaoSelecionado(false);
                } else {
                  setNaoEncontrouEmpreendimento(true);
                  setEmpreendimentoNaoSelecionado(true);
                }
                if (representanteRef.current === 0) {
                  setPropriedadeRes(1);
                } else {
                  setCpfEmailBloqueado(true);
                  setPropriedadeRes(2);
                }

                buscarCotas();

                const assinatura = await buscarAssinaturaPorCotaUsuario(
                  cotaUsuarioRef.current
                );
                if (assinatura) {
                  setAnunciar(1);
                } else {
                  setAnunciar(2);
                }

                switch (cronogramaEmp.current) {
                  case 0:
                    setActiveStep(5);
                    setRenderAdicionarPeriodo(4);
                    
                    setCronogramaFixoOuPrioridade(2);
                    break;
                  case 1:
                    if (deveUsarFluxoManualComCotaUsuario()) {
                      abrirTelaDefinicaoManualPeriodos();
                    } else {
                      setActiveStep(5);
                      if (origemApRef.current !== 0) {
                        setRenderAdicionarPeriodo(4);
                      } else {
                        setRenderAdicionarPeriodo(3);
                      }
                    }

                    setCronogramaFixoOuPrioridade(1);
                    break;
                  case 2:
                    
                    setActiveStep(5);
                    setRenderAdicionarPeriodo(4);
                    setCronogramaFixoOuPrioridade(2);
                    break;
                }
              }

              return true;

            case "AGUARDANDO_APTOMAISINFO":
              setFormInfo(response.data);
              const sucessoMinhaCotaAptoMaisInfo = await buscarMinhaCota(
                response.data.cotaId
              );
              stateNovo.current = "AGUARDANDO_APTOMAISINFO";
              setState("AGUARDANDO_APTOMAISINFO");
              if (sucessoMinhaCotaAptoMaisInfo) {
                if (origemEmpRef.current !== 0 && origemApRef.current !== 0) {
                  setEmpreendimentoSelecionado(null);
                  setApCriadoPeloUsuario(true);
                }
                //EMPREENDIMENTO DO SISTEMA E APARTAMENTO DO USUARIO
                else if (
                  origemEmpRef.current === 0 &&
                  origemApRef.current !== 0
                ) {
                  setApCriadoPeloUsuario(true);
                }
                //EMPREENDIMENTO  E APARTAMENTO DO SISTEMA
                else {
                  setApCriadoPeloUsuario(false);
                }

                if (
                  response.data.numeroApto === null ||
                  response.data.andar === null ||
                  response.data.vista === null
                ) {
                  setBloquearBotaoProximo(true);
                } else {
                  setBloquearBotaoProximo(false);
                }

                setActiveStep(0);
                setRenderApSteps(3);
                setRenderEmpSteps(0);

                setState("AGUARDANDO_APTOMAISINFO");
                if (origemEmpRef.current === 0) {
                  setNaoEncontrouEmpreendimento(false);
                  setEmpreendimentoNaoSelecionado(false);
                } else {
                  setNaoEncontrouEmpreendimento(true);
                  setEmpreendimentoNaoSelecionado(true);
                }

                break;
              } else {
                error("HÃ¡ algo de errado. CÃ³digo erro: VCP-001.");
                break;
              }

            case "AGUARDANDO_SERVICO":
              setFormInfo(response.data);
              stateNovo.current = "AGUARDANDO_SERVICO";
              setState("AGUARDANDO_SERVICO");

              const sucessoMinhaCotaServico = await buscarMinhaCota(
                response.data.cotaId
              );

              if (sucessoMinhaCotaServico) {
                const servicos = obterServicosSelecionados(response.data);

                setServicosSelecionados(servicos);

                if (origemEmpRef.current !== 0 && origemApRef.current !== 0) {
                  setEmpreendimentoSelecionado(null);
                  setApCriadoPeloUsuario(true);
                } else if (
                  origemEmpRef.current === 0 &&
                  origemApRef.current !== 0
                ) {
                  setApCriadoPeloUsuario(true);
                } else {
                  setApCriadoPeloUsuario(false);
                }

                setBloquearBotaoProximo(!possuiRelacaoSelecionada());
                setActiveStep(0);
                setRenderApSteps(2);
                setRenderEmpSteps(0);

                if (origemEmpRef.current === 0) {
                  setNaoEncontrouEmpreendimento(false);
                  setEmpreendimentoNaoSelecionado(false);
                } else {
                  setNaoEncontrouEmpreendimento(true);
                  setEmpreendimentoNaoSelecionado(true);
                }

                break;
              } else {
                error("HÃ¡ algo de errado. CÃ³digo erro: VCP-097.");
                break;
              }

            default:
              setBloquearBotaoProximo(false);

              criandoTelaFinalizacao(response.data.id);

              setFormInfo(response.data);

              cotaUsuarioRef.current = response.data.id;

              formPrioridade.prioridade = response.data.prioridade;
              buscarMeuArquivo();
              stateNovo.current = statusFluxo;

              const [
                sucessoDFT,
                sucessoProprietarioDFT,
                sucessoEnderecoProprietarioDFT,
                sucessoRepresentanteDFT,
              ] = await Promise.all([
                buscarMinhaCota(response.data.cotaId),
                buscarDadosProprietario(response.data.usuarioId),
                buscarEndereco(response.data.usuarioId, "proprietario"),
                buscarDadosRepresentante(),
              ]);

              setActiveStep(0);
              setRenderApSteps(0);

              if (
                sucessoDFT &&
                sucessoProprietarioDFT &&
                sucessoEnderecoProprietarioDFT &&
                sucessoRepresentanteDFT
              ) {
                // Se empreendimeto e apartamento tiverem origem diferente de 0
                if (origemEmpRef.current !== 0 && origemApRef.current !== 0) {
                  //EMPREENDIMENTO  E APARTAMENTO DO USUARIO
                  setEmpreendimentoSelecionado(null);
                  setApCriadoPeloUsuario(true);
                } else if (
                  // EMPREENDIMENTO DO SISTEMA E APARTAMENTO DO USUARIO
                  origemEmpRef.current === 0 &&
                  origemApRef.current !== 0
                ) {
                  setApCriadoPeloUsuario(true);
                } else {
                  //EMPREENDIMENTO  E APARTAMENTO DO SISTEMA
                  setApCriadoPeloUsuario(false);
                }
                if (origemEmpRef.current === 0) {
                  setNaoEncontrouEmpreendimento(false);
                  setEmpreendimentoNaoSelecionado(false);
                } else {
                  setNaoEncontrouEmpreendimento(true);
                  setEmpreendimentoNaoSelecionado(true);
                }

                // Faz a verificaÃ§Ã£o se existe cronograma, se sim vai para tela de cotas se nao , volta para a tela de prioridades
                if (cronogramaRef.current !== 0) {
                  cotaRef.current = true;
                } else {
                  prioridadeRef.current = true;
                }
                if (representanteRef.current === 0) {
                  setPropriedadeRes(1);
                } else {
                  setCpfEmailBloqueado(true);
                  setPropriedadeRes(2);
                }
                const assinatura = await buscarAssinaturaPorCotaUsuario(
                  cotaUsuarioRef.current
                );
                if (assinatura) {
                  setAnunciar(1);
                } else {
                  setAnunciar(2);
                }

                const anuncioPropriedade = await verificarAnuncioPropriedade();
                if (anuncioPropriedade) {
                  setAnuncioPropriedade(true);
                } else {
                  setAnuncioPropriedade(false);
                }

                return true;
              } else {
                error("HÃ¡ algo de errado. CÃ³digo de erro: VCP-078");
                return false;
              }
          }
        }
      } catch (err) {
        console.error(error);
        error("HÃ¡ algo de errado. CÃ³digo de erro: VCP-079");
      }
      return true;
    } else {
      document.location.href = "/login";
      return false;
    }
  };

  // FunÃ§Ã£o que busca a cota
  const buscarMinhaCota = async (cotaId: number): Promise<boolean> => {
    if (!cotaId) {
      setIdMinhaCota(0);
      setOrigemMinhaCota(0);
      setFormMinhaCota({
        id: 0,
        numeroCota: 0,
      });
      setFormMinhaCotaOrigemProprietario({
        numeroCota: 0,
      });
      formNumeroCota.resetFields();
      setNaoSabeNumeroCota(false);
      return true;
    }

    const Token = validateToken();
    if (Token) {
      const URL = `${Globais.DOMINIOBACK}/cota/${cotaId}`;
      try {
        const response = await axios.get(URL, {
          headers: {
            "Content-Type": "application/json",
            Authorization: Token.AuthStr,
          },
        });

        if (response && response.data) {
          setIdMinhaCota(response.data.id);

          setOrigemMinhaCota(response.data.origem);
          formSemanasPorAno.semanasPorAno = response.data.qtdSemanas;
          formDiaDaSemana.diaDaSemana = response.data.diaDaSemanaInicio;

          const numeroCotaAtual =
            cronogramaEmp.current === 1 && origemApRef.current === 0
              ? response.data.id
              : response.data.numeroCota;

          setFormMinhaCota({
            id: response.data.id,
            numeroCota: response.data.numeroCota,
          });
          setFormMinhaCotaOrigemProprietario({
            numeroCota: numeroCotaAtual,
          });
          formNumeroCota.setFieldsValue({
            numeroCota: numeroCotaAtual,
          });
          setNaoSabeNumeroCota(
            cronogramaEmp.current === 1 &&
              origemApRef.current === 0 &&
              response.data.origem !== 0 &&
              response.data.numeroCota === 1
          );

          // setFormSemanasPorAno(response.data.qtdSemanas);

          // setFormMinhaCotaOrigemProprietario(response.data.numeroCota);

          if (cotaUsuarioId !== 0) {
            setFormMinhaCota((prevState) => ({
              ...prevState,
              numeroCota: response.data.numeroCota,
            }));
            // setFormSemanasPorAno({
            //   semanasPorAno: response.data.qtdSemanas,
            // })
          }

          // Aguarda a conclusÃ£o da funÃ§Ã£o buscarMeuAp
          const sucessoAp = await buscarMeuAp(response.data.aptoId);

          if (!sucessoAp) {
            error("HÃ¡ algo de errado. CÃ³digo de erro: VCP-055");
            return false;
          }

          // setFormSemanasPorAno(response.data.qtdSemanas);

          // setFormDiaDaSemana(response.data.diaDaSemanaInicio);
        } else {
          error("HÃ¡ algo de errado. CÃ³digo de erro: VCP-056");
          return false;
        }

        return true;
      } catch (error) {
        error("HÃ¡ algo de errado. CÃ³digo de erro: VCP-057");
        return false;
      }
    } else {
      return false;
    }
  };

  // FunÃ§Ã£o que busca a cota do usuario
  const buscarMinhaCotaUsuario = async (
    cotaUsuarioId: number
  ): Promise<CotaUsuario | null> => {
    const Token = validateToken();
    if (Token) {
      const URL = `${Globais.DOMINIOBACK}/cota-usuario/${cotaUsuarioId}`;
      try {
        const response = await axios.get(URL, {
          headers: { Authorization: Token.AuthStr },
        });
        formPrioridade.prioridade = response.data.prioridade
          ? response.data.prioridade
          : null;

        return response.data;
      } catch (error) {
        console.log(error);
        error("HÃ¡ algo de errado. CÃ³digo de erro: VCP-058");
        return null;
      }
    } else {
      return null;
    }
  };

  // FunÃ§Ã£o que busca o apartamento do usuario
  const buscarMeuAp = async (apId: number): Promise<boolean> => {
    const Token = validateToken();
    if (Token) {
      const URL = `${Globais.DOMINIOBACK}/apto/${apId}`;
      try {
        const response = await axios.get(URL, {
          headers: {
            "Content-Type": "application/json",
            Authorization: Token.AuthStr,
          },
        });

        if (response && response.data) {
          setOrigemAp(response.data.origem);
          origemApRef.current = response.data.origem;
          idApRef.current = response.data.id;
          const values: Apartamento = {
            id: response.data.id,
            empreendId: response.data.empreendId,
            nome: response.data.nome,
            capacidade: response.data.capacidade,
            quartos: response.data.quartos,
            banheiros: response.data.banheiros,
            varanda: response.data.varanda,
            metragem: response.data.metragem,
            estacionamento: response.data.estacionamento,
            terreo: response.data.terreo,
            vista: response.data.vista,
          };

          setFormAp(values);

          formApartamento.setFieldsValue({
            propriedade: {
              nomeAp: values.nome,
              capacidade: values.capacidade,
              quartos: values.quartos,
              banheiros: values.banheiros,
              varanda: values.varanda,
              metragem: values.metragem,
              estacionamento: values.estacionamento,
              terreo: values.terreo,
              vista: values.vista,
            },
          });

          // Aguarda a conclusÃ£o da funÃ§Ã£o buscarMeuEmp
          const sucessoEmp = await buscarMeuEmp(response.data.empreendId);
          setApEmpreendimentoId(response.data.id);

          if (!sucessoEmp) {
            error("HÃ¡ algo de errado. CÃ³digo de erro: VCP-059");
            return false;
          }
        }

        return true;
      } catch (error) {
        console.log(error);
        error("HÃ¡ algo de errado. CÃ³digo de erro: VCP-060");
        return false;
      }
    } else {
      return false;
    }
  };

  // FunÃ§Ã£o que busca o empreendimento do usuario
  const atualizarMeuEmp = async (empreendId: number): Promise<boolean> => {
    const Token = validateToken();
    if (Token) {
      const URL = `${Globais.DOMINIOBACK}/empreendimento/${empreendId}`;
      const cronogramaNovo =
        cronogramaFixoOuPrioridade === 1
          ? 1
          : cronogramaFixoOuPrioridade === 2
          ? 0
          : null;

      const values = {
        cronograma: cronogramaNovo,
      };

      try {
        const response = await axios.put(URL, values, {
          headers: {
            "Content-Type": "application/json",
            Authorization: Token.AuthStr,
          },
        });

        if (response) {
          return true;
        } else {
          error("HÃ¡ algo de errado. CÃ³digo de erro: VCP-064");
          return false;
        }
      } catch (error) {
        console.log(error);
        error("HÃ¡ algo de errado. CÃ³digo de erro: VCP-063");
        return false;
      }
    } else {
      document.location.href = "/login";
      return false;
    }
  };

  // FunÃ§Ã£o que busca o empreendimento do usuario
  const buscarMeuEmp = async (empreendId: number): Promise<boolean> => {
    const Token = validateToken();
    if (Token) {
      const URL = `${Globais.DOMINIOBACK}/empreendimento/${empreendId}`;
      try {
        const response = await axios.get(URL, {
          headers: {
            "Content-Type": "application/json",
            Authorization: Token.AuthStr,
          },
        });
        

        if (response && response.data) {
          const values = {
            nome: response.data.nome,
            cronograma: response.data.cronograma,
          };
          

          switch (response.data.origem) {
            case 0:
              
              switch (response.data.cronograma) {
                case 0:
                  cronogramaEmp.current = 0;
                  break;
                case 1:
                  cronogramaEmp.current = 1;
                  break;
              }
              break;
            default:
              
              cronogramaEmp.current = 2;
              
              break;
          }

          setFormEmpreendimento(values);
          setEmpreendimentoSelecionado(response.data);

         

          switch (await stateNovo.current) {
            case "AGUARDANDO_CADASTRO":
            case "AGUARDANDO_APTO":
            case "AGUARDANDO_APTOMAISINFO":
            case "AGUARDANDO_SERVICO":
            case "AGUARDANDO_TITULARIDADE":
            case "AGUARDANDO_REPRESENTANTE":
            case "AGUARDANDO_COMPROVANTE":
            case "AGUARDANDO_COTA":
            case "":
              break;
            default:
              
              const cronogramaFixoOuPrioridadeNovo =
                response.data.cronograma == 1
                  ? 1
                  : response.data.cronograma == 0
                  ? 2
                  : 0;

              setCronogramaFixoOuPrioridade(cronogramaFixoOuPrioridadeNovo);

              break;
          }

       
          if (
            cronogramaFixoOuPrioridade !== 0 &&
            renderCotaSteps === 0 &&
            renderPrioridadeSteps === 0
          ) {
            setBloquearBotaoProximo(false);
          }

          cronogramaRef.current = values.cronograma;
          origemEmpRef.current = response.data.origem;
          idEmpRef.current = response.data.id;

          buscarMinhaCidade(response.data.cidadeId, "empreendimento");
          setFormAp((prevState) => ({
            ...prevState, // mantÃ©m os valores antigos do estado
            empreendId: response.data.nome, // atualiza empreendId com o valor da resposta
          }));
        }

        return true;
      } catch (error) {
        console.log(error);
        error("HÃ¡ algo de errado. CÃ³digo de erro: VCP-061");
        return false;
      }
    } else {
      return false;
    }
  };

  // FunÃ§Ã£o que busca a cidade resgitrada pelo usuario
  const buscarMinhaCidade = async (cidadeId: number, tipo: string) => {
    const Token = validateToken();
    if (Token) {
      const URL = `${Globais.DOMINIOBACK}/cidade/${cidadeId}`;
      try {
        const response = await axios.get(URL, {
          headers: {
            "Content-Type": "application/json",
            Authorization: Token.AuthStr,
          },
        });

        if (response && response.data) {
          if (tipo === "proprietario") {
            setFormCadastroProprietario((prevState) => ({
              ...prevState,
              cidadeId: response.data.nome,
            }));
          } else if (tipo === "representante") {
            setFormAtualizarCadastro((prevState) => ({
              ...prevState,
              cidadeId: response.data.nome,
            }));
          } else if (tipo === "empreendimento") {
            setFormEmpreendimento((prevState) => ({
              ...prevState,
              cidadeId: response.data.nome,
            }));
          }

          buscarMeuEstado(response.data.estadoId);
        }
      } catch (error) {
        console.log(error);
      }
    }
  };

  // FunÃ§Ã£o que busca o estado registrado pelo usuÃ¡rio
  const buscarMeuEstado = async (estadoId: number) => {
    const Token = validateToken();
    if (Token) {
      const URL = `${Globais.DOMINIOBACK}/estado/${estadoId}`;
      try {
        const response = await axios.get(URL, {
          headers: {
            "Content-Type": "application/json",
            Authorization: Token.AuthStr,
          },
        });

        if (response && response.data) {
          setFormEmpreendimento((prevState) => ({
            ...prevState, // mantÃ©m os valores antigos do estado
            estado: response.data.nome, // atualiza empreendId com o valor da resposta
          }));
          setSelectedEstado(response.data.nome);
          buscarMeuPais(response.data.paisId);
        }

        return true;
      } catch (error) {
        console.log(error);
        return false;
      }
    } else {
      return false;
    }
  };

  // FunÃ§Ã£o que busca o pais registrado pelo usuario
  const buscarMeuPais = async (paisId: number) => {
    const Token = validateToken();
    if (Token) {
      const URL = `${Globais.DOMINIOBACK}/pais/${paisId}`;
      try {
        const response = await axios.get(URL, {
          headers: {
            "Content-Type": "application/json",
            Authorization: Token.AuthStr,
          },
        });

        if (response && response.data) {
          setFormEmpreendimento((prevState) => ({
            ...prevState, // mantÃ©m os valores antigos do estado
            pais: response.data.nome, // atualiza empreendId com o valor da resposta
          }));
        }

        return true;
      } catch (error) {
        console.log(error);
        return false;
      }
    } else {
      return false;
    }
  };

  const regularizarCTUAguardandoMaisInfoAnuncio = async () => {
    const representantes = await buscarTodosOsRepresentantesCotaUsuario(
      cotaUsuarioId
    );
    if (representantes) {
      if (
        representantes[0].checked === 0 &&
        representantes[0].dataVencimento === null
      ) {
        const result = await atualizarCotaUsuario("AGUARDANDO_PROCURACAO");
        if (result) {
          criandoTelaFinalizacao(cotaUsuarioId);
          setActiveStep(6);
        } else {
          error("HÃ¡ algo de errado. VCP-090");
        }
      } else {
        const CTUChecada = await verificarCTUChecada(cotaUsuarioId);
        if (CTUChecada) {
          const result = await atualizarCotaUsuario("AUTENTICADA_NIVEL1");
          if (result) {
            criandoTelaFinalizacao(cotaUsuarioId);
            setActiveStep(6);
          } else {
            error("HÃ¡ algo de errado. VCP-088");
          }
        } else {
          const result = await atualizarCotaUsuario("AGUARDANDO_AUTENTICACAO");
          if (result) {
            criandoTelaFinalizacao(cotaUsuarioId);
            setActiveStep(6);
          } else {
            error("HÃ¡ algo de errado. VCP-089");
          }
        }
      }
    } else {
      const CTUChecada = await verificarCTUChecada(cotaUsuarioId);
      if (CTUChecada) {
        const result = await atualizarCotaUsuario("AUTENTICADA_NIVEL1");
        if (result) {
          criandoTelaFinalizacao(cotaUsuarioId);
          setActiveStep(6);
        } else {
          error("HÃ¡ algo de errado. VCP-086");
        }
      } else {
        const result = await atualizarCotaUsuario("AGUARDANDO_AUTENTICACAO");
        if (result) {
          criandoTelaFinalizacao(cotaUsuarioId);
          setActiveStep(6);
        } else {
          error("HÃ¡ algo de errado. VCP-087");
        }
      }
    }
  };

  const isCampoVazio = () => {
    const propriedade = formApartamento.getFieldValue("propriedade");

    

    // Verifica se o objeto "propriedade" existe

    // Verifica se o objeto "propriedade" e o campo "nome" existem e se "nome" estÃ¡ vazio
    return !propriedade || !propriedade.capacidade;
  };

  const possuiServicoSelecionado = (
    servicos: ServicosMulticotas = servicosSelecionados
  ) =>
    servicos.querAlugar === 1 ||
    servicos.querTrocar === 1 ||
    servicos.querVender === 1;

  const obterServicosSelecionados = (
    data?: Partial<ServicosMulticotas>
  ): ServicosMulticotas => ({
    querAlugar: data?.querAlugar === 1 ? 1 : 0,
    querTrocar: data?.querTrocar === 1 ? 1 : 0,
    querVender: data?.querVender === 1 ? 1 : 0,
  });

  const servicosMulticotasChange = (checkedValues: Array<string | number>) => {
    changing.current = true;

    const nextValues = {
      querAlugar: checkedValues.includes("querAlugar") ? 1 : 0,
      querTrocar: checkedValues.includes("querTrocar") ? 1 : 0,
      querVender: checkedValues.includes("querVender") ? 1 : 0,
    };

    setServicosSelecionados(nextValues);
    setBloquearBotaoProximo(!possuiServicoSelecionado(nextValues));
  };


  const abrirEtapaTitularidadeFluxoCadastro = () => {
    setRenderApSteps(0);
    setRenderEmpSteps(0);
    setActiveStep(1);
    setRenderProprietario(0);
    setState("AGUARDANDO_TITULARIDADE");
    stateNovo.current = "AGUARDANDO_TITULARIDADE";
    setBloquearBotaoProximo(!possuiRelacaoSelecionada());
  };

  const abrirEtapaCotaOuPrioridadeFluxoCadastro = async () => {
    setRenderProprietario(100);
    setActiveStep(2);

    switch (cronogramaEmp.current) {
      case 0:
        setRenderCotaSteps(0);
        if (origemApRef.current !== 0) {
          setRenderPrioridadeSteps(0);
          setBloquearBotaoProximo(cronogramaFixoOuPrioridade === 0);
        } else {
          setRenderPrioridadeSteps(1);
          setBloquearBotaoProximo(
            formPrioridade.prioridade === null ||
              formPrioridade.prioridade === ""
          );
        }
        return;

      case 1:
        if (origemApRef.current !== 0) {
          setRenderCotaSteps(0);
          setRenderPrioridadeSteps(0);
          setBloquearBotaoProximo(cronogramaFixoOuPrioridade === 0);
          return;
        }

        await buscarCotas();
        setRenderPrioridadeSteps(0);
        setRenderCotaSteps(1);
        setBloquearBotaoProximo(
          !naoSabeNumeroCota &&
            !(
              formMinhaCotaOrigemProprietario.numeroCota ??
              formMinhaCota.id ??
              0
            )
        );
        return;

      case 2:
        setRenderPrioridadeSteps(0);
        setRenderCotaSteps(0);
        setBloquearBotaoProximo(cronogramaFixoOuPrioridade === 0);
        return;
    }
  };

  const avancarEtapaInicialFluxoCadastro = async () => {
    if (renderEmpSteps === 1) {
      formAtualizarEstadoEmpreendimento.resetFields();
      formEmpreendimento.nome = "";
      formEmpreendimento.pais = undefined;
      formEmpreendimento.estado = undefined;
      formEmpreendimento.cidadeId = undefined;
      changing.current = false;
      setBloquearBotaoProximo(true);
      setRenderEmpSteps(2);
      return;
    }

    if (renderEmpSteps === 2) {
      verificarSeFormApartamentoProprietarioVazio();

      if (cotaUsuarioId !== 0 && !changing.current) {
        setRenderEmpSteps(3);
        return;
      }

      const sucessoEmpreendimento =
        cotaUsuarioId !== 0 && origemMinhaCota !== 0
          ? await cadastrarOuAtualizarEmpreendimento(true)
          : await cadastrarOuAtualizarEmpreendimento();

      if (!sucessoEmpreendimento) {
        error("Ha algo de errado. Codigo de erro: VCP-030.");
        return;
      }

      changing.current = false;
      setRenderEmpSteps(3);
      return;
    }

    if (renderEmpSteps === 3) {
      cronogramaEmp.current = 2;

      if (cotaUsuarioId !== 0 && changing.current) {
        const sucessoEdicaoApartamento = await editarAP();

        if (!sucessoEdicaoApartamento) {
          error("Ha algo de errado. Codigo de erro: VCP-095.");
          return;
        }

        changing.current = false;
        abrirEtapaTitularidadeFluxoCadastro();
        return;
      }

      const sucessoApartamento = await cadastrarNovoApartamento();

      if (!sucessoApartamento) {
        return;
      }

      if (stateNovo.current !== "AGUARDANDO_COTA") {
        abrirEtapaTitularidadeFluxoCadastro();
      }
      return;
    }

    switch (renderApSteps) {
      case 0:
        if (empreedimentoSelecionado) {
          origemEmpRef.current = 0;

          if (changing.current) {
            formApartamento.resetFields();
            setApCriadoPeloUsuario(false);
            setBloquearBotaoProximo(true);
            changing.current = false;
          } else {
            const vazio = isCampoVazio();
            setBloquearBotaoProximo(vazio && !apCriadoPeloUsuario);
          }

          setRenderApSteps(1);
          return;
        }

        setNaoEncontrouEmpreendimento(true);

        if (changing.current) {
          setRenderEmpSteps(1);
          setRenderApSteps(0);
          return;
        }

        setBloquearBotaoProximo(
          formEmpreendimento.cidadeId === undefined ||
            formEmpreendimento.estado === undefined ||
            formEmpreendimento.pais === undefined ||
            formEmpreendimento.nome === ""
        );
        setRenderEmpSteps(2);
        setRenderApSteps(0);
        return;

      case 1:
        if (apCriadoPeloUsuario) {
          idEmpRef.current = empreedimentoSelecionado.id;
          setRenderApSteps(100);
          setRenderEmpSteps(3);
          setBloquearBotaoProximo(true);
          return;
        }

        const sucessoInicioFluxo = await iniciarFluxoCadastroCota();

        if (!sucessoInicioFluxo) {
          error("Ocorreu um erro ao avancar. Tente novamente.");
          return;
        }

        if (stateNovo.current !== "AGUARDANDO_COTA") {
          abrirEtapaTitularidadeFluxoCadastro();
        }
        return;

      case 2:
      case 3:
      case 4:
        abrirEtapaTitularidadeFluxoCadastro();
        return;

      default:
        error("Nao foi possivel determinar a etapa inicial do fluxo.");
        return;
    }
  };

  const avancarEtapaTitularidadeFluxoCadastro = async () => {
    if (renderProprietario === 0) {
      if (bloqueadoEdicao.current) {
        await abrirEtapaCotaOuPrioridadeFluxoCadastro();
        return;
      }

      if (relacaoEhTitular()) {
        const Token = validateToken();

        if (!Token) {
          document.location.href = "/login";
          return;
        }

        const titularidadeSalva = await salvarTitularidadeEAvancar(+Token.id);

        if (!titularidadeSalva) {
          error("Ha algo de errado. Codigo de erro: VCP-003.");
        }
        return;
      }

      if (relacaoEhTerceiro()) {
        setRenderProprietario(1);
        setState("AGUARDANDO_REPRESENTANTE");
        return;
      }

      setBloquearBotaoProximo(true);
      return;
    }

    if (renderProprietario === 1) {
      setRenderProprietario(2);

      if (
        formAtualizarCadastro.nacionalidade === undefined ||
        formAtualizarCadastro.cidadeId === undefined ||
        formAtualizarCadastro.rg === undefined ||
        formAtualizarCadastro.complemento === undefined ||
        formAtualizarCadastro.endereco === undefined ||
        formAtualizarCadastro.estadoCivil === undefined ||
        formAtualizarCadastro.estadoId === undefined
      ) {
        setBloquearBotaoProximo(true);
      }
      return;
    }

    if (renderProprietario === 2) {
      if (state === "AGUARDANDO_REPRESENTANTE") {
        setBloquearBotaoProximo(true);
        setFormCadastroProprietario((prevState) => ({
          ...prevState,
          endereco: undefined,
          complemento: undefined,
          estadoId: undefined,
          cidadeId: undefined,
          usuarioId: undefined,
          nome: undefined,
          sobrenome: undefined,
          email: undefined,
          cpf: undefined,
          celular: undefined,
          nacionalidade: undefined,
          paisId: undefined,
          estadoCivil: undefined,
        }));
      }

      if (changing.current) {
        changing.current = false;
        const sucesso = await atualizarDados("REPRESENTANTE");

        if (!sucesso) {
          error("Ha algo de errado. Codigo de erro: VCP-035.");
          return;
        }
      }

      setRenderProprietario(3);
      return;
    }

    if (renderProprietario === 3) {
      if (changing.current) {
        if (
          !formCadastroNovoProprietario.cpf ||
          !validaCPF(formCadastroNovoProprietario.cpf)
        ) {
          error("CPF invalido. Favor verificar.");
          return;
        }

        if (
          !formCadastroNovoProprietario.email ||
          !validacaoEmail(formCadastroNovoProprietario.email)
        ) {
          error("E-mail invalido. Favor verificar.");
          return;
        }

        const usuarioIdProprietario = obterUsuarioIdCTU();
        const usuarioIdLogado = validateToken()?.id;

        if ((await usuarioIdProprietario) === usuarioIdLogado) {
          const usuario = await buscarUsuario(String(usuarioIdLogado));

          switch (usuario.resultado) {
            case 0: {
              const sucesso = await cadastrarProprietario();

              if (!sucesso) {
                error("Ha algo de errado. Codigo de erro: VCP-042");
                return;
              }

              changing.current = false;
              return;
            }

            case 1: {
              const sucessoPropExistente = await cadastrarProprietario(
                usuario.id
              );

              if (!sucessoPropExistente) {
                error("Ha algo de errado. Codigo de erro: VCP-091");
                return;
              }

              changing.current = false;
              return;
            }

            case 2:
              error("Ja existe uma conta com esse e-mail, favor utilizar outro.");
              return;

            case 3:
              error(
                "O CPF incluido no formulario e o mesmo que voce cadastrou como seu CPF. Inclua o CPF do proprietario"
              );
              return;

            default:
              error("Ha algo de errado. Codigo de erro: VCP-045");
              return;
          }
        }

        const sucesso = await atualizarDados("PROPRIETARIO");

        if (!sucesso) {
          error("Ha algo de errado. Codigo de erro: VCP-043");
          return;
        }

        const titularidadeSalva = await salvarTitularidadeEAvancar(
          Number(await usuarioIdProprietario)
        );

        if (!titularidadeSalva) {
          error("Ha algo de errado. Codigo de erro: VCP-043A");
        }
        return;
      }

      const resultado = await verificarSeTemArquivos(cotaUsuarioId);
      setBloquearBotaoProximo(!resultado);
      setRenderProprietario(4);
      return;
    }

    if (renderProprietario === 4) {
      await abrirEtapaCotaOuPrioridadeFluxoCadastro();
      return;
    }

    error("Nao foi possivel determinar a subetapa de titularidade.");
  };

  const avancarEtapaIdentificacaoCotaFluxoCadastro = async () => {
    if (cronogramaEmp.current === 1 && origemApRef.current !== 0) {
      const sucessoReinicioFluxo = await iniciarFluxoCadastroCota();

      if (!sucessoReinicioFluxo) {
        error("Nao foi possivel ressicronizar o fluxo da propriedade.");
      }
      return;
    }

    if (
      renderCotaSteps !== 1 ||
      cronogramaEmp.current !== 1 ||
      origemApRef.current !== 0
    ) {
      error("Esta etapa ainda esta sendo migrada para o novo fluxo.");
      return;
    }

    const cotaSelecionadaId =
      formMinhaCotaOrigemProprietario.numeroCota ??
      formMinhaCota.id ??
      undefined;

    if (!naoSabeNumeroCota && !cotaSelecionadaId) {
      error("Selecione uma cota para continuar.");
      return;
    }

    const payloadIdentificacao = naoSabeNumeroCota
      ? { naoSei: true }
      : { cotaId: cotaSelecionadaId };
    const cotaUsuarioIdAtual = obterCotaUsuarioIdAtual();
    const sucesso = cotaUsuarioIdAtual
      ? await concluirEtapaFluxoCadastro(
          "AGUARDANDO_IDENTIFICACAO_COTA",
          payloadIdentificacao
        )
      : await identificarCotaFluxoCadastro(payloadIdentificacao);

    if (!sucesso) {
      return;
    }
  };

  type TelaCadastroVisivel =
    | "EMPREENDIMENTO_BUSCA"
    | "EMPREENDIMENTO_MENSAGEM"
    | "EMPREENDIMENTO_CADASTRO"
    | "APARTAMENTO_BUSCA"
    | "APARTAMENTO_CADASTRO"
    | "APARTAMENTO_RELACAO"
    | "APARTAMENTO_SERVICOS"
    | "APARTAMENTO_INFO"
    | "TITULARIDADE"
    | "REPRESENTANTE_BUSCA"
    | "REPRESENTANTE_DADOS"
    | "PROPRIETARIO_DADOS"
    | "COMPROVANTE"
    | "COTA_ESCOLHA"
    | "COTA_NUMERO"
    | "PRIORIDADE"
    | "SEMANAS_POR_ANO"
    | "PRIORIDADE_DEFINICAO"
    | "PAGAMENTO_ANUNCIO"
    | "PAGAMENTO_INFO"
    | "PAGAMENTO_DESISTENCIA"
    | "PERIODOS_ADICIONAR"
    | "PERIODOS_ADICIONAR_AVULSO"
    | "PERIODOS_DEFINIR"
    | "PERIODOS_DEFINIR_AVULSO"
    | "FINALIZACAO";

  const obterTelaCadastroAtual = (): TelaCadastroVisivel => {
    if (activeStep === 0) {
      if (renderEmpSteps === 1) {
        return "EMPREENDIMENTO_MENSAGEM";
      }

      if (renderEmpSteps === 2) {
        return "EMPREENDIMENTO_CADASTRO";
      }

      if (renderEmpSteps === 3) {
        return "APARTAMENTO_CADASTRO";
      }

      if (renderApSteps === 4) {
        return "APARTAMENTO_SERVICOS";
      }

      if (renderApSteps === 3) {
        return "APARTAMENTO_INFO";
      }

      if (renderApSteps === 2) {
        return "APARTAMENTO_RELACAO";
      }

      if (renderApSteps === 1) {
        return "APARTAMENTO_BUSCA";
      }

      return "EMPREENDIMENTO_BUSCA";
    }

    if (activeStep === 1) {
      switch (renderProprietario) {
        case 1:
          return "REPRESENTANTE_BUSCA";
        case 2:
          return "REPRESENTANTE_DADOS";
        case 3:
          return "PROPRIETARIO_DADOS";
        case 4:
          return "COMPROVANTE";
        default:
          return "TITULARIDADE";
      }
    }

    if (activeStep === 2) {
      if (renderCotaSteps === 1) {
        return "COTA_NUMERO";
      }

      switch (renderPrioridadeSteps) {
        case 1:
          return "PRIORIDADE";
        case 2:
          return "SEMANAS_POR_ANO";
        case 3:
          return "PRIORIDADE_DEFINICAO";
        default:
          return "COTA_ESCOLHA";
      }
    }

    if (activeStep === 3) {
      switch (renderPagamentoSteps) {
        case 2:
          return "PAGAMENTO_INFO";
        case 3:
          return "PAGAMENTO_DESISTENCIA";
        default:
          return "PAGAMENTO_ANUNCIO";
      }
    }

    if (activeStep === 4) {
      return renderAdicionarPeriodo === 2
        ? "PERIODOS_ADICIONAR_AVULSO"
        : "PERIODOS_ADICIONAR";
    }

    if (activeStep === 5) {
      return renderAdicionarPeriodo === 4
        ? "PERIODOS_DEFINIR_AVULSO"
        : "PERIODOS_DEFINIR";
    }

    return "FINALIZACAO";
  };

  const obterTelaAnteriorLocal = (
    telaAtual: TelaCadastroVisivel
  ): TelaCadastroVisivel | null => {
    switch (telaAtual) {
      case "EMPREENDIMENTO_MENSAGEM":
      case "EMPREENDIMENTO_CADASTRO":
      case "APARTAMENTO_BUSCA":
        return "EMPREENDIMENTO_BUSCA";
      case "APARTAMENTO_CADASTRO":
        return origemEmpRef.current === 0
          ? "APARTAMENTO_BUSCA"
          : "EMPREENDIMENTO_CADASTRO";
      case "APARTAMENTO_RELACAO":
        return apCriadoPeloUsuario || origemApRef.current !== 0
          ? "APARTAMENTO_CADASTRO"
          : "APARTAMENTO_BUSCA";
      case "APARTAMENTO_SERVICOS":
        return "APARTAMENTO_RELACAO";
      case "APARTAMENTO_INFO":
        return "APARTAMENTO_SERVICOS";
      case "REPRESENTANTE_BUSCA":
        return "TITULARIDADE";
      case "REPRESENTANTE_DADOS":
        return "REPRESENTANTE_BUSCA";
      case "PROPRIETARIO_DADOS":
        return "REPRESENTANTE_DADOS";
      case "COMPROVANTE":
        return relacaoEhTerceiro() ? "PROPRIETARIO_DADOS" : "TITULARIDADE";
      case "PRIORIDADE":
        return origemApRef.current !== 0 ? "COTA_ESCOLHA" : null;
      case "SEMANAS_POR_ANO":
        return cronogramaFixoOuPrioridade === 1 ? "COTA_NUMERO" : "PRIORIDADE";
      case "PRIORIDADE_DEFINICAO":
        return "SEMANAS_POR_ANO";
      case "COTA_NUMERO":
        return origemApRef.current !== 0 ? "COTA_ESCOLHA" : null;
      case "PAGAMENTO_INFO":
        return "PAGAMENTO_ANUNCIO";
      case "PAGAMENTO_DESISTENCIA":
        return anunciar === 1 ? "PAGAMENTO_INFO" : "PAGAMENTO_ANUNCIO";
      case "PERIODOS_DEFINIR":
        return "PERIODOS_ADICIONAR";
      case "PERIODOS_DEFINIR_AVULSO":
        return "PERIODOS_ADICIONAR_AVULSO";
      case "FINALIZACAO":
        return anunciar === 1 ? "PAGAMENTO_INFO" : "PAGAMENTO_ANUNCIO";
      default:
        return null;
    }
  };

  const abrirTelaCadastro = async (
    tela: TelaCadastroVisivel
  ): Promise<boolean> => {
    switch (tela) {
      case "EMPREENDIMENTO_BUSCA":
        setActiveStep(0);
        setRenderApSteps(0);
        setRenderEmpSteps(0);
        setBloquearBotaoProximo(true);
        setState("AGUARDANDO_CADASTRO");
        stateNovo.current = "AGUARDANDO_CADASTRO";
        return true;
      case "EMPREENDIMENTO_MENSAGEM":
        setActiveStep(0);
        setRenderApSteps(0);
        setRenderEmpSteps(1);
        setBloquearBotaoProximo(false);
        setState("AGUARDANDO_CADASTRO");
        stateNovo.current = "AGUARDANDO_CADASTRO";
        return true;
      case "EMPREENDIMENTO_CADASTRO":
        setActiveStep(0);
        setRenderApSteps(0);
        setRenderEmpSteps(2);
        setBloquearBotaoProximo(
          formEmpreendimento.cidadeId === undefined ||
            formEmpreendimento.estado === undefined ||
            formEmpreendimento.pais === undefined ||
            formEmpreendimento.nome === ""
        );
        setState("AGUARDANDO_CADASTRO");
        stateNovo.current = "AGUARDANDO_CADASTRO";
        return true;
      case "APARTAMENTO_BUSCA":
        setActiveStep(0);
        setRenderEmpSteps(0);
        setRenderApSteps(1);
        setBloquearBotaoProximo(isCampoVazio() && !apCriadoPeloUsuario);
        setState("AGUARDANDO_APTO");
        stateNovo.current = "AGUARDANDO_APTO";
        return true;
      case "APARTAMENTO_CADASTRO":
        setActiveStep(0);
        setRenderApSteps(100);
        setRenderEmpSteps(3);
        setApCriadoPeloUsuario(true);
        setBloquearBotaoProximo(true);
        setState("AGUARDANDO_APTO");
        stateNovo.current = "AGUARDANDO_APTO";
        return true;
      case "APARTAMENTO_RELACAO":
        setActiveStep(0);
        setRenderEmpSteps(0);
        setRenderApSteps(2);
        setBloquearBotaoProximo(!possuiRelacaoSelecionada());
        setState("AGUARDANDO_SERVICO");
        stateNovo.current = "AGUARDANDO_SERVICO";
        return true;
      case "APARTAMENTO_SERVICOS":
        setActiveStep(0);
        setRenderEmpSteps(0);
        setRenderApSteps(4);
        setBloquearBotaoProximo(
          !possuiServicoSelecionado(servicosSelecionados)
        );
        setState("AGUARDANDO_SERVICO");
        stateNovo.current = "AGUARDANDO_SERVICO";
        return true;
      case "APARTAMENTO_INFO":
        setActiveStep(0);
        setRenderEmpSteps(0);
        setRenderApSteps(3);
        setBloquearBotaoProximo(
          formInfo.numeroApto === null ||
            formInfo.andar === null ||
            formInfo.vista === null
        );
        setState("AGUARDANDO_APTOMAISINFO");
        stateNovo.current = "AGUARDANDO_APTOMAISINFO";
        return true;
      case "TITULARIDADE":
        abrirEtapaTitularidadeFluxoCadastro();
        return true;
      case "REPRESENTANTE_BUSCA":
        setActiveStep(1);
        setRenderProprietario(1);
        setBloquearBotaoProximo(false);
        setState("AGUARDANDO_REPRESENTANTE");
        stateNovo.current = "AGUARDANDO_REPRESENTANTE";
        return true;
      case "REPRESENTANTE_DADOS":
        setActiveStep(1);
        setRenderProprietario(2);
        setBloquearBotaoProximo(
          formAtualizarCadastro.nacionalidade === undefined ||
            formAtualizarCadastro.cidadeId === undefined ||
            formAtualizarCadastro.rg === undefined ||
            formAtualizarCadastro.complemento === undefined ||
            formAtualizarCadastro.endereco === undefined ||
            formAtualizarCadastro.estadoCivil === undefined ||
            formAtualizarCadastro.estadoId === undefined
        );
        setState("AGUARDANDO_REPRESENTANTE");
        stateNovo.current = "AGUARDANDO_REPRESENTANTE";
        return true;
      case "PROPRIETARIO_DADOS":
        setActiveStep(1);
        setRenderProprietario(3);
        setBloquearBotaoProximo(false);
        setState("AGUARDANDO_REPRESENTANTE");
        stateNovo.current = "AGUARDANDO_REPRESENTANTE";
        return true;
      case "COMPROVANTE": {
        const possuiArquivos = await verificarSeTemArquivos(cotaUsuarioId);
        setActiveStep(1);
        setRenderProprietario(4);
        setBloquearBotaoProximo(!possuiArquivos);
        setState("AGUARDANDO_COMPROVANTE");
        stateNovo.current = "AGUARDANDO_COMPROVANTE";
        return true;
      }
      case "COTA_ESCOLHA":
        setActiveStep(2);
        setRenderCotaSteps(0);
        setRenderPrioridadeSteps(0);
        setBloquearBotaoProximo(cronogramaFixoOuPrioridade === 0);
        setState("AGUARDANDO_COTA");
        stateNovo.current = "AGUARDANDO_COTA";
        return true;
      case "COTA_NUMERO":
        await buscarCotas();
        setActiveStep(2);
        setRenderCotaSteps(1);
        setRenderPrioridadeSteps(0);
        setBloquearBotaoProximo(
          !naoSabeNumeroCota &&
            !(
              formMinhaCotaOrigemProprietario.numeroCota ??
              formMinhaCota.id ??
              0
            )
        );
        setState("AGUARDANDO_COTA");
        stateNovo.current = "AGUARDANDO_COTA";
        return true;
      case "PRIORIDADE":
        setActiveStep(2);
        setRenderCotaSteps(0);
        setRenderPrioridadeSteps(1);
        setBloquearBotaoProximo(
          formPrioridade.prioridade === null ||
            formPrioridade.prioridade === ""
        );
        setState("AGUARDANDO_COTA");
        stateNovo.current = "AGUARDANDO_COTA";
        return true;
      case "SEMANAS_POR_ANO":
        setActiveStep(2);
        setRenderCotaSteps(0);
        setRenderPrioridadeSteps(2);
        setBloquearBotaoProximo(!formSemanasPorAno.semanasPorAno);
        setState("AGUARDANDO_COTA");
        stateNovo.current = "AGUARDANDO_COTA";
        return true;
      case "PRIORIDADE_DEFINICAO":
        setActiveStep(2);
        setRenderCotaSteps(0);
        setRenderPrioridadeSteps(3);
        setBloquearBotaoProximo(false);
        setState("AGUARDANDO_COTA");
        stateNovo.current = "AGUARDANDO_COTA";
        return true;
      case "PAGAMENTO_ANUNCIO":
        setActiveStep(3);
        setRenderPagamentoSteps(1);
        setBloquearBotaoProximo(false);
        setState("AGUARDANDO_DEFINICAO_ANUNCIO");
        stateNovo.current = "AGUARDANDO_DEFINICAO_ANUNCIO";
        return true;
      case "PAGAMENTO_INFO":
        setActiveStep(3);
        setRenderPagamentoSteps(2);
        setBloquearBotaoProximo(false);
        setState("AGUARDANDO_MAISINFO_ANUNCIO");
        stateNovo.current = "AGUARDANDO_MAISINFO_ANUNCIO";
        return true;
      case "PAGAMENTO_DESISTENCIA":
        setActiveStep(3);
        setRenderPagamentoSteps(3);
        setBloquearBotaoProximo(false);
        return true;
      case "PERIODOS_ADICIONAR":
        setActiveStep(4);
        setRenderAdicionarPeriodo(1);
        setBloquearBotaoProximo(false);
        setState("AGUARDANDO_PERIODOS");
        stateNovo.current = "AGUARDANDO_PERIODOS";
        return true;
      case "PERIODOS_ADICIONAR_AVULSO":
        setActiveStep(4);
        setRenderAdicionarPeriodo(2);
        setBloquearBotaoProximo(false);
        setState("AGUARDANDO_PERIODOS");
        stateNovo.current = "AGUARDANDO_PERIODOS";
        return true;
      case "PERIODOS_DEFINIR":
        setActiveStep(5);
        setRenderAdicionarPeriodo(3);
        setBloquearBotaoProximo(false);
        setState("AGUARDANDO_DEFINICAO_PERIODOS");
        stateNovo.current = "AGUARDANDO_DEFINICAO_PERIODOS";
        return true;
      case "PERIODOS_DEFINIR_AVULSO":
        setActiveStep(5);
        setRenderAdicionarPeriodo(4);
        setBloquearBotaoProximo(false);
        setState("AGUARDANDO_DEFINICAO_PERIODOS");
        stateNovo.current = "AGUARDANDO_DEFINICAO_PERIODOS";
        return true;
      case "FINALIZACAO":
        setActiveStep(6);
        setBloquearBotaoProximo(false);
        return true;
      default:
        return false;
    }
  };

  const avancarStepCadastroPropriedade = async () => {
    const fluxoCadastroAtual = fluxoCadastroEstadoRef.current;
    const etapaAtualTela = obterEtapaFluxoDaTelaAtual(fluxoCadastroAtual);
    const proximaEtapaFluxo = obterProximaEtapaNavegacaoFluxoCadastro(
      fluxoCadastroAtual,
      etapaAtualTela
    );
    console.log("fluxoCadastroAtual", fluxoCadastroAtual);
    console.log("etapaAtualTela", etapaAtualTela);
    console.log("proximaEtapaFluxo", proximaEtapaFluxo);
    

    if (proximaEtapaFluxo && proximaEtapaFluxo !== etapaAtualTela) {
      const abriuProximaEtapa = await abrirEtapaFluxoCadastro(
        proximaEtapaFluxo
      );

      if (abriuProximaEtapa) {
        return;
      }
    }

    switch (activeStep) {
      case 0:
        await avancarEtapaInicialFluxoCadastro();
        return;

      case 1:
        await avancarEtapaTitularidadeFluxoCadastro();
        return;

      case 2:
        await avancarEtapaIdentificacaoCotaFluxoCadastro();
        return;

      case 3:
        await telaDePagamento();
        return;

      case 4:
        switch (renderAdicionarPeriodo) {
          case 1:
            navigate(`/adicionarPeriodos?cotaUsuarioId=${cotaUsuarioId}`);
            return;
          case 2:
            navigate(
              `/disponibilizacaoPeriodos?cotaUsuarioId=${cotaUsuarioId}`
            );
            return;
          default:
            error("Nao foi possivel determinar a navegacao dos periodos.");
            return;
        }

      case 5:
        navigate(`/disponibilizacaoPeriodos?cotaUsuarioId=${cotaUsuarioId}`);
        return;

      case 6:
        navigate(`/cadastroCotas`);
        window.scrollTo(0, 0);
        return;

      default:
        error("Nao foi possivel determinar a etapa atual do cadastro.");
    }
  };

  const handleBack = async () => {
    changing.current = false;

    const telaAtual = obterTelaCadastroAtual();
    const telaAnteriorLocal = obterTelaAnteriorLocal(telaAtual);

    if (telaAnteriorLocal) {
      const voltouNaMesmaTela = await abrirTelaCadastro(telaAnteriorLocal);

      if (voltouNaMesmaTela) {
        return;
      }
    }

    const fluxoCadastroAtual = fluxoCadastroEstadoRef.current;
    const etapaAtualTela = obterEtapaFluxoDaTelaAtual(fluxoCadastroAtual);
    const etapaAnteriorFluxo = obterEtapaAnteriorNavegacaoFluxoCadastro(
      fluxoCadastroAtual,
      etapaAtualTela
    );

    if (etapaAnteriorFluxo && etapaAnteriorFluxo !== etapaAtualTela) {
      const voltouPelaEtapaAnterior = await abrirEtapaFluxoCadastro(
        etapaAnteriorFluxo
      );

      if (voltouPelaEtapaAnterior) {
        return;
      }
    }

    if (telaAtual !== "EMPREENDIMENTO_BUSCA") {
      await abrirTelaCadastro("EMPREENDIMENTO_BUSCA");
    }
  };

  const propriedadeChange = (e: RadioChangeEvent) => {
    changing.current = true;
    setBloquearBotaoProximo(false);

    setPropriedadeRes(e.target.value);
  };

  const cronogramaFixoOuPrioridadeChange = (e: RadioChangeEvent) => {
    changing.current = true;
    setBloquearBotaoProximo(false);

    setCronogramaFixoOuPrioridade(e.target.value);
  };

  //FunÃ§Ã£o que armazena no state o estado selecionado
  const handleEstadoChange = (value: number, formAtualizar: any) => {
    changing.current = true;

    setSelectedEstado(value);

    formAtualizar.setFieldsValue({ cidadeId: undefined }); // Limpa o valor da cidade no formulÃ¡rio especÃ­fico

    setCidades([]);
  };

  //FunÃ§Ã£o que armazena no state e filtra de acordo com id o empreendimento selecionado Etapa: De qual empreendimento Ã© sua propriedade?
  const handleSelectChange = (value: number) => {
   
    const selectedEmp = empreendimento.find(
      (emp: Empreendimento) => emp.id === value
    );

    if (selectedEmp) {
      changing.current = true;
      setBloquearBotaoProximo(false);
      setEmpreendimentoSearch("");
      idEmpRef.current = selectedEmp.id ?? 0;
      origemEmpRef.current = selectedEmp.origem ?? 0;
      setEmpreendimentoSelecionadoAp(null);
      setApSelecionado(null);
      idApRef.current = 0;
      origemApRef.current = 0;
      setApEmpreendimentoId(undefined);
      setEmpreendimentoSelecionado(selectedEmp);
      setFormEmpreendimento((prevState) => ({
        ...prevState,
        id: selectedEmp.id,
        origem: selectedEmp.origem,
        cronograma: selectedEmp.cronograma,
        nome: selectedEmp.nome,
      }));
      if (selectedEmp.cronograma) {
        cronogramaEmp.current = selectedEmp.cronograma;
      }
    } else {
      // Lidar com o caso onde nenhum empreendimento foi encontrado
      console.error("Erro, por favor entre em contato");
    }
  };

  //FunÃ§Ã£o que armazena no state se o empreendimento foi encontrado ou nÃ£o
  // TRUE - empreendimento nÃ£o encontrado
  // FALSE - empreendimento encontrado
  const iniciarCadastroNovoEmpreendimento = (nomeDigitado?: string) => {
    const nomeEmpreendimento = nomeDigitado?.trim() ?? "";
    const values = {
      ...formEmpreendimento,
      nome: nomeEmpreendimento,
    };

    changing.current = true;
    setBloquearBotaoProximo(true);
    setNaoEncontrouEmpreendimento(true);
    setEmpreendimentoNaoSelecionado(true);
    setEmpreendimentoSelecionado(null);
    setEmpreendimentoSelecionadoAp(null);
    setApSelecionado(null);
    setRenderApSteps(0);
    setRenderEmpSteps(2);
    setEmpreendimentoSearch("");
    setFormEmpreendimento(values);
    formAtualizarEstadoEmpreendimento.setFieldsValue(values);
  };

  const handleEmpreendimentoEnter = (
    event: React.KeyboardEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    if (
      event.key === "Enter" &&
      empreendimentoSearch.trim() !== "" &&
      !existeEmpreendimentoComNome
    ) {
      event.preventDefault();
      iniciarCadastroNovoEmpreendimento(empreendimentoSearch);
    }
  };

  const naoEncontradoChange: CheckboxProps["onChange"] = (e) => {
    if (e.target.checked) {
      iniciarCadastroNovoEmpreendimento();
    } else {
      setNaoEncontrouEmpreendimento(false);
      setBloquearBotaoProximo(true);
      setEmpreendimentoNaoSelecionado(false);
    }
  };

  //FunÃ§Ã£o que armazena no state e filtra de acordo com id do apartamento selecionado
  const handleEmpreendimentoApChange = (value: number) => {
    const selectedEmp = empreendimentoAp.find(
      (emp: ApData) => emp.id === value
    );
    if (selectedEmp) {
      changing.current = true;
      setBloquearBotaoProximo(false);
      setEmpreendimentoSelecionadoAp(selectedEmp);
      setApSelecionado(selectedEmp);
      setOrigemAp(selectedEmp.origem);
      origemApRef.current = selectedEmp.origem;
      idApRef.current = selectedEmp.id;
      setApEmpreendimentoId(selectedEmp.id);
      setFormAp((prevState) => ({
        ...prevState,
        id: selectedEmp.id,
        empreendId: selectedEmp.empreendId,
        nome: selectedEmp.nome,
        capacidade: selectedEmp.capacidade,
        quartos: selectedEmp.quartos,
        banheiros: selectedEmp.banheiros,
        metragem: selectedEmp.metragem,
        varanda: selectedEmp.varanda,
        terreo: selectedEmp.terreo,
        estacionamento: selectedEmp.estacionamento,
        origem: selectedEmp.origem,
      }));
    } else {
      console.error("Erro, por favor entre em contato");
    }
  };

  //FunÃ§Ã£o que reseta o formulario caso o apartamento nao tenha sido encontrado
  // TRUE - apartamento nÃ£o encontrado
  // FALSE - apartamento encontrado

  const naoEncontradoAp: CheckboxProps["onChange"] = (e) => {
    if (e.target.checked) {
      changing.current = true;
      setBloquearBotaoProximo(false);
      formApartamento.resetFields();
      setApCriadoPeloUsuario(true);
      setEmpreendimentoSelecionadoAp(null);
      setApSelecionado(null);
      setOrigemAp(undefined);
      origemApRef.current = 0;
      idApRef.current = 0;
      setApEmpreendimentoId(undefined);
      setFormAp((prevState) => ({
        ...prevState,
        id: undefined,
        origem: undefined,
        nome: undefined,
        capacidade: undefined,
        quartos: undefined,
        banheiros: undefined,
        metragem: undefined,
        varanda: undefined,
        terreo: undefined,
        estacionamento: undefined,
        vista: undefined,
        empreendId: idEmpRef.current || empreedimentoSelecionado?.id,
      }));
      formApartamento.setFields([
        { name: ["propriedade", "nomeAp"], value: undefined },
        {
          name: ["propriedade", "capacidade"],
          value: undefined,
        },
        { name: ["propriedade", "quartos"], value: undefined },
        {
          name: ["propriedade", "banheiros"],
          value: undefined,
        },
        { name: ["propriedade", "metragem"], value: undefined },
        { name: ["propriedade", "varanda"], value: undefined },
        { name: ["propriedade", "terreo"], value: undefined },
        {
          name: ["propriedade", "estacionamento"],
          value: undefined,
        },
      ]);
    } else {
      setApCriadoPeloUsuario(false);
      setBloquearBotaoProximo(true);
      formApartamento.setFields([
        { name: ["propriedade", "nomeAp"] },
        { name: ["propriedade", "capacidade"] },
        { name: ["propriedade", "quartos"] },
        { name: ["propriedade", "banheiros"] },
        { name: ["propriedade", "metragem"] },
        { name: ["propriedade", "varanda"] },
        { name: ["propriedade", "terreo"] },
        { name: ["propriedade", "estacionamento"] },
      ]);
    }
  };

  //FunÃ§Ã£o que Busca o empreendimento que o usuÃ¡rio cadastrou
  const buscarMeusEmpreendimentos = async () => {
    const Token = validateToken();

    if (Token) {
      const URL = `${Globais.DOMINIOBACK}/empreendimento`;

      try {
        const response = await axios.get(URL, {
          headers: { Authorization: Token.AuthStr },
        });
        if (response) {
          const empreendimentos: Empreendimentos[] = response.data;
          // Convertendo Token.id para inteiro antes de comparar
          const tokenId = Token.id;
          // Ordena os empreendimentos por ordem decrescente de created_at
          empreendimentos.sort((a, b) => {
            // Assume que created_at Ã© uma string no formato adequado para comparaÃ§Ã£o
            if (a.created_at < b.created_at) return 1;
            if (a.created_at > b.created_at) return -1;
            return 0;
          });

          // Filtra o empreendimento mais recente com base na origem do usuÃ¡rio
          const meuEmpreend = empreendimentos.find(
            (empreend) => empreend.origem === tokenId
          );

          if (meuEmpreend) {
            setMeusEmpreendimentos([meuEmpreend]); // Armazena o empreendimento mais recente no estado
          } else {
            setMeusEmpreendimentos([]); // Se nÃ£o houver empreendimento, define como array vazio
          }
        }
      } catch (error) {
        console.error("Erro na solicitaÃ§Ã£o:", error);
        if (error.response && error.response.status === 401) {
          logout();
          console.log("Erro de autenticaÃ§Ã£o:", error);
        }
        console.error("Erro ao buscar meus empreendimentos:", error);
      }
    }
  };

  const buscarDadosProprietario = async (
    usuarioId: number
  ): Promise<boolean> => {
    const Token = validateToken();
    if (Token) {
      const URL = `${Globais.DOMINIOBACK}/usuario/${usuarioId}`;
      try {
        const response = await axios.get(URL, {
          headers: { Authorization: Token.AuthStr },
        });

        if (response && response.data) {
          const values = {
            nome: response.data.nome,
            sobrenome: response.data.sobrenome,
            cpf: response.data.cpf,
            email: response.data.email,
            celular: response.data.celular,
            nacionalidade: response.data.nacionalidade,
            estadoCivil: response.data.estadoCivil,
          };
          setFormCadastroProprietario(values);
          proprietarioRef.current = response.data.id;
        }
        return true;
      } catch (error) {
        console.log(error);
        return false;
      }
    } else {
      return false;
    }
  };

  const buscarEndereco = async (
    usuarioId: number,
    tipo: string
  ): Promise<boolean> => {
    const Token = validateToken();
    if (Token) {
      const URL = `${Globais.DOMINIOBACK}/endereco/usuario/${usuarioId}`;
      try {
        const response = await axios.get(URL, {
          headers: { Authorization: Token.AuthStr },
        });

        if (response && response.data) {
          if (tipo === "proprietario") {
            setFormCadastroProprietario((prevState) => ({
              ...prevState,
              endereco: response.data.endereco,
              complemento: response.data.complemento,
              estadoId: response.data.estadoId,
              cidadeId: response.data.cidadeId,
            }));
            buscarMinhaCidade(response.data.cidadeId, "proprietario");
          } else if (tipo === "representante") {
            setFormAtualizarCadastro((prevState) => ({
              ...prevState,
              endereco: response.data.endereco,
              complemento: response.data.complemento,
              estadoId: response.data.estadoId,
              cidadeId: response.data.cidadeId,
            }));
            buscarMinhaCidade(response.data.cidadeId, "representante");
          } else {
            console.log(
              "Houve um erro ao buscar os dados, por favor tente novamente"
            );
          }
        }
        return true;
      } catch (error) {
        console.log(error);
        return false;
      }
    } else {
      return false;
    }
  };

  const buscarDadosRepresentante = async (): Promise<boolean> => {
    const Token = validateToken();
    if (Token) {
      const tokenId = Token.id;
      const URL = `${Globais.DOMINIOBACK}/usuario/${tokenId}`;
      try {
        const response = await axios.get(URL, {
          headers: { Authorization: Token.AuthStr },
        });

        if (response && response.data) {
          const values = {
            nacionalidade: response.data.nacionalidade,
            estadoCivil: response.data.estadoCivil,
            rg: response.data.rg,
          };
          setFormAtualizarCadastro(values);
          buscarEndereco(tokenId, "representante");
        }
        return true;
      } catch (error) {
        console.log(error);
        return false;
      }
    } else {
      return false;
    }
  };

  // FunÃ§Ã£o que armazena o dado selecionado da varanda
  const possuiVarandaChange = (e: RadioChangeEvent) => {
    changing.current = true;
    setPossuiVaranda(e.target.value);
  };

  // FunÃ§Ã£o que armazena o dado selecionado do estacionamento
  const estacionamentoChange = (e: RadioChangeEvent) => {
    changing.current = true;
    setEstacionamento(e.target.value);
  };

  // FunÃ§Ã£o que armazena o dado selecionado do terreo
  const terreoChange = (e: RadioChangeEvent) => {
    changing.current = true;
    setTerreo(e.target.value);
  };

  // FunÃ§Ã£o que armazena no objetos os dados do formulario empreendimento
  const empreendimentosChange = (
    changedValues: Partial<Empreendimento>,
    allValues: Empreendimento
  ) => {
    changing.current = true;

    //validaÃ§Ã£o do preenchimento dos campos

    if (
      formEmpreendimento.nome !== undefined ||
      formEmpreendimento.nome !== "" ||
      changedValues.nome !== ""
    ) {
      if (
        formEmpreendimento.pais !== undefined ||
        (changedValues.pais !== 0 && changedValues.pais !== undefined)
      ) {
        if (
          formEmpreendimento.estado !== undefined ||
          (changedValues.estado !== 0 && changedValues.estado !== undefined)
        ) {
          if (
            formEmpreendimento.cidadeId !== undefined ||
            (changedValues.cidadeId !== 0 &&
              changedValues.cidadeId !== undefined)
          ) {
            setBloquearBotaoProximo(false);
          }
        }
      }
    }

    //Caso o usuario apague o campo nome ele desabilitarÃ¡ o botÃ£o proximo
    if (changedValues.nome === "") {
      setBloquearBotaoProximo(true);
    }

    setFormEmpreendimento(allValues);
  };

  const verificarSeFormApartamentoProprietarioVazio = () => {
    if (
      formAp.capacidade === null ||
      formAp.quartos === null ||
      formAp.banheiros === null ||
      formAp.varanda === null ||
      formAp.estacionamento === null ||
      formAp.terreo === null
    ) {
      setBloquearBotaoProximo(true);
    }
  };

  // FunÃ§Ã£o que armazena os dados do formulario cadastro de apartamento
  const novoApartamentoChange = (
    changedValues: Partial<Apartamento>,
    allValues: Apartamento
  ) => {
    changing.current = true;
    setFormAp(allValues);
  };

  const atualizarCampoCadastroApartamento = (
    campo: "capacidade" | "quartos" | "banheiros",
    marcado: boolean
  ) => {
    const nextValues = {
      ...formAp,
      [campo]: undefined,
    };

    formCadastrarApartamento.setFieldsValue({
      [campo]: undefined,
    });

    setNaoSeiApartamento((prevState) => ({
      ...prevState,
      [campo]: marcado,
    }));

    novoApartamentoChange(
      {
        [campo]: undefined,
      } as Partial<Apartamento>,
      nextValues
    );
  };

  // FunÃ§Ã£o que armazena os dados do formulario de cadastro de mais informaÃ§Ãµes do apartamento
  useEffect(() => {
    if (activeStep !== 0 || renderEmpSteps !== 3) {
      return;
    }

    const capacidadePreenchida =
      naoSeiApartamento.capacidade ||
      !(formAp.capacidade === undefined || formAp.capacidade === null);
    const quartosPreenchidos =
      naoSeiApartamento.quartos ||
      !(formAp.quartos === undefined || formAp.quartos === null);
    const banheirosPreenchidos =
      naoSeiApartamento.banheiros ||
      !(formAp.banheiros === undefined || formAp.banheiros === null);
    const varandaPreenchida =
      !(formAp.varanda === undefined || formAp.varanda === null);
    const estacionamentoPreenchido =
      !(formAp.estacionamento === undefined || formAp.estacionamento === null);
    const terreoPreenchido =
      !(formAp.terreo === undefined || formAp.terreo === null);

    if (
      capacidadePreenchida &&
      quartosPreenchidos &&
      banheirosPreenchidos &&
      varandaPreenchida &&
      estacionamentoPreenchido &&
      terreoPreenchido
    ) {
      setBloquearBotaoProximo(false);
    } else {
      setBloquearBotaoProximo(true);
    }
  }, [activeStep, formAp, naoSeiApartamento, renderEmpSteps]);

  const MaisInfoApChange = (
    changedValues: Partial<MaisInfoAp>,
    allValues: MaisInfoAp
  ) => {
    changing.current = true;

    if (changedValues.numeroApto === "" || changedValues.andar === null) {
      setBloquearBotaoProximo(true);
    }

    if (
      (formInfo.numeroApto === "" &&
        changedValues.numeroApto !== "" &&
        !(
          (formInfo.numeroApto !== "" && changedValues.numeroApto === "") ||
          changedValues.numeroApto === undefined
        )) ||
      (formInfo.numeroApto !== "" && changedValues.numeroApto !== "")
    ) {
      if (
        (formInfo.andar === undefined && changedValues.andar !== undefined) ||
        (formInfo.andar !== undefined && changedValues.andar !== null)
      ) {
        if (
          (formInfo.vista === undefined &&
            changedValues.vista !== "" &&
            changedValues.vista !== undefined) ||
          (formInfo.vista !== undefined && changedValues.vista === undefined)
        ) {
          setBloquearBotaoProximo(false);
        }
      }
    }

  
    setFormInfo(allValues);
  };

  // FunÃ§Ã£o que armazena os dados do apartamento selecionado
  const apEmpreendimentoChange = (changedValues: any, allValues: any) => {
    changing.current = true;
    setBloquearBotaoProximo(false);
    setApEmpreendimentoId(allValues.propriedade.nomeAp);
  };

  // FunÃ§Ã£o de cadastrar o empreendimento
  const cadastrarOuAtualizarEmpreendimento = async (
    atualizar?: boolean
  ): Promise<boolean> => {
    const Token = validateToken();
    if (Token) {
      const URL = `${Globais.DOMINIOBACK}/empreendimento/${idEmpRef.current}`;

      if (atualizar) {
        const values = {
          ...formEmpreendimento,
        };

        try {
          const response = await axios.put(URL, values, {
            headers: {
              "Content-Type": "application/json",
              Authorization: Token.AuthStr,
            },
          });

          
          if (response && response.data) {
            cronogramaEmp.current = response.data.cronograma;
            idEmpRef.current = response.data.id;
            setFormEmpreendimento(response.data);

            // ApÃ³s cadastrar com sucesso, chama a funÃ§Ã£o para buscar os empreendimentos atualizados

            buscarMeusEmpreendimentos();
          }

          return true;
        } catch (error) {
          console.error("Erro ao cadastrar o empreendimento", error);
          error("Erro ao cadastrar o empreendimento. CÃ³digo erro: VCP-010");
          return false;
        }
      } else {
        const URLCriarEmpreendimento = `${Globais.DOMINIOBACK}/empreendimento/${formEmpreendimento.cidadeId}`;
        const values = {
          ...formEmpreendimento,
          origem: Token.id,
        };

        try {
          const response = await axios.post(URLCriarEmpreendimento, values, {
            headers: {
              "Content-Type": "application/json",
              Authorization: Token.AuthStr,
            },
          });
          if (response && response.data) {
            cronogramaEmp.current = response.data.cronograma;
            idEmpRef.current = response.data.id;

            const sucessoApto = cadastrarNovoApartamento();

            // ApÃ³s cadastrar com sucesso, chama a funÃ§Ã£o para buscar os empreendimentos atualizados

            buscarMeusEmpreendimentos();
          }

          return true;
        } catch (error) {
          console.error("Erro ao cadastrar o empreendimento", error);
          error("Erro ao cadastrar o empreendimento. CÃ³digo erro. VCP-013");
          return false;
        }
      }
    } else {
      return false;
    }
  };


  // FunÃ§Ã£o de cadastrar apartamento
  const cadastrarNovoApartamento = async (): Promise<boolean> => {
    const Token = validateToken();

    if (Token) {
      const URL = `${Globais.DOMINIOBACK}/apto`;
      const tokenId = Token.id;
      let values;
      const nomeApartamento =
        formAp.nome && formAp.nome.trim() !== ""
          ? formAp.nome.trim()
          : "Apartamento";
      const capacidadeApartamento = naoSeiApartamento.capacidade
        ? 0
        : formAp.capacidade;
      const quartosApartamento = naoSeiApartamento.quartos ? 0 : formAp.quartos;
      const banheirosApartamento = naoSeiApartamento.banheiros
        ? 0
        : formAp.banheiros;

      if (origemMinhaCota === 0) {
        values = {
          ...formAp,
          origem: tokenId,
          empreendId: idEmpRef.current,
          nome: nomeApartamento,
          capacidade: capacidadeApartamento,
          quartos: quartosApartamento,
          banheiros: banheirosApartamento,
          metragem: undefined,
          varanda: undefined,
          terreo: undefined,
          vista: undefined,
          estacionamento: undefined,
        };
      } else {
        values = {
          ...formAp,
          origem: tokenId,
          empreendId: idEmpRef.current,
          nome: nomeApartamento,
          capacidade: capacidadeApartamento,
          quartos: quartosApartamento,
          banheiros: banheirosApartamento,
        };
      }

      try {
        const response = await axios.post(URL, values, {
          headers: {
            "Content-Type": "application/json",
            Authorization: Token.AuthStr,
          },
        });

        if (response && response.data) {
          setOrigemAp(response.data.origem);
          origemApRef.current = response.data.origem;
          const aptoId = response.data.id;
          idApRef.current = response.data.id;
          setApEmpreendimentoId(response.data.id);

          setFormAp((prevState) => ({
            ...prevState, // mantÃ©m os valores antigos do estado
            id: response.data.id, // atualiza id com o valor da resposta
            origem: response.data.origem,
            empreendId: response.data.empreendId ?? idEmpRef.current,
          }));

          const sucessoInicioFluxo = await iniciarFluxoCadastroCota();

          if (!sucessoInicioFluxo) {
            return false;
          }

          // alert("Apartamento Cadastrado com Sucesso!");
        } else {
          return false;
        }
        return true;
      } catch (error) {
        console.error("Erro ao cadastrar meu Apartamento", error);
        error("HÃ¡ algo de errado. VCP-032");
        return false;
      }
    } else {
      return false;
    }
  };

  const editarAP = async (): Promise<boolean> => {
    const Token = validateToken();
    if (Token) {
      const URL = `${Globais.DOMINIOBACK}/apto/${idApRef.current}`;
      const values = {
        ...formAp,
      };
      try {
        const response = await axios.put(URL, values, {
          headers: {
            "Content-Type": "application/json",
            Authorization: Token.AuthStr,
          },
        });
        setApCriadoPeloUsuario(true);
        return true;
      } catch (error) {
        console.log(error);
        return false;
      }
    } else {
      return false;
    }
  };

  // FunÃ§Ã£o de criar uma nova cota
  /* const criarOuAtualizarCota = async (
    aptoId?: number,
    atualizar?: boolean
  ): Promise<boolean> => {
    const Token = validateToken();
    const apId = aptoId ? aptoId : ApEmpreendimentoId;
    if (Token) {
      const URL = `${Globais.DOMINIOBACK}/cota/${apId}`;
      const tokenId = Token.id;
      const cota = 1;

      if (atualizar) {
        const valuesAtualizarCota = {
          aptoId: apId,
          numeroCota: null,
          qtdSemanas: 0,
        };

        try {
          const response = await axios.put(URL, valuesAtualizarCota, {
            headers: {
              "Content-Type": "application/json",
              Authorization: Token.AuthStr,
            },
          });
          if (response) {
            setCotaId(response.data.id);
            cotaIdRef.current = response.data.id;
          } else {
            error("Erro ao atualizar a cota");
          }

          return true;
        } catch (error) {
          console.error("Erro ao atualizar a cota", error);
          error("Erro ao atualizar a cota");
          return false;
        }
      } else {
        if (cotaUsuarioId === 0) {
          const sucessoInicioFluxo = await criarCotaUsuario(
            "AGUARDANDO_TITULARIDADE"
          );

          if (sucessoInicioFluxo) {
            return true;
          }

          error("HÃƒÂ¡ algo errado. CÃƒÂ³digo de erro: VCP-028");
          return false;
        }

        const valuesCriarCota = {
          aptoId: apId,
          origem: tokenId,
          numeroCota: cota,
          qtdSemanas: 0,
        };
        try {
          const response = await axios.post(URL, valuesCriarCota, {
            headers: {
              "Content-Type": "application/json",
              Authorization: Token.AuthStr,
            },
          });

          if (response) {
            setCotaId(response.data.id);
            cotaIdRef.current = response.data.id;

            if (cotaUsuarioId !== 0) {
              const sucesso = atualizarCotaUsuario(
                "AGUARDANDO_TITULARIDADE",
                0,
                "ALTERAR_COTAID",
                response.data.id
              );

              if (await sucesso) {
                return true;
              } else {
                error("HÃ¡ algo errado. CÃ³digo de erro: VCP-027");
              }
            } else {
              const sucesso = criarCotaUsuario(
                "AGUARDANDO_TITULARIDADE",
                response.data.id
              );
              if (await sucesso) {
                return true;
              } else {
                error("HÃ¡ algo errado. CÃ³digo de erro: VCP-028");
              }
            }

            return true;
          } else {
            console.error("Erro ao cadastrar a cota", error);
            error("Erro ao cadastrar o cota. CÃ³digo erro: VCP-006");
            return false;
          }
        } catch (error) {
          console.error("Erro ao cadastrar a cota", error);
          error("Erro ao cadastrar o cota. CÃ³digo erro: VCP-005");
          return false;
        }
      }
    } else {
      return false;
    }
  };

  */
  const obterCotaId = async () => {
    const Token = validateToken();
    const URLApto = `${Globais.DOMINIOBACK}/apto/${ApEmpreendimentoId}`;

    if (Token) {
      if (
        cotaUsuarioId === 0 &&
        (renderEmpSteps === 3 || renderEmpSteps === 2)
      ) {
        return cotaIdRef.current;
      } else {
        try {
          const responseApto = await axios.get(URLApto, {
            headers: {
              "Content-Type": "application/json",
              Authorization: Token.AuthStr,
            },
          });
          if (responseApto) {
            const URLEmpreend = `${Globais.DOMINIOBACK}/empreendimento/${responseApto.data.empreendId}`;
            try {
              const responseEmpreend = await axios.get(URLEmpreend, {
                headers: {
                  "Content-Type": "application/json",
                  Authorization: Token.AuthStr,
                },
              });
              
              if (responseEmpreend) {
                if(origemApRef.current !== 0) {
                  cronogramaEmp.current = 2;
                }else{
                  cronogramaEmp.current = responseEmpreend.data.cronograma;
                }
                
                const URLCota = `${Globais.DOMINIOBACK}/cota/apto/${responseApto.data.id}`;

                try {
                  const responseCota = await axios.get(URLCota, {
                    headers: {
                      "Content-Type": "application/json",
                      Authorization: Token.AuthStr,
                    },
                  });
                  if (responseCota) {
                    let cotaId = 0;
                    responseCota.data.map((c: any, index: number) => {
                      if (index === 0) {
                        cotaId = c.id;
                      } else {
                        if (cotaId > c.id) {
                          cotaId = c.id;
                        }
                      }
                    });
                    return cotaId;
                  } else {
                    error(
                      "HÃ¡ algo de errado. Favor entrar em contato conosco. VCP-007"
                    );
                  }
                } catch (e) {
                  console.log(e);
                  return 0;
                }
              }
            } catch (e) {
              console.log(e);
              return 0;
            }
          } else {
            error(
              "HÃ¡ algo de errado. Favor entrar em contato conosco. VCP-015"
            );
          }
        } catch (e) {
          console.log(e);
          return 0;
        }
      }
    } else {
      document.location.href = "/login";
    }
  };
  const iniciarFluxoCadastroCota = async (): Promise<boolean> => {
    const Token = validateToken();

    if (!Token) {
      document.location.href = "/login";
      return false;
    }

    const URL = `${Globais.DOMINIOBACK}/cota-usuario/fluxo-cadastro/iniciar`;
    const empreendimentoIdFluxo =
      idEmpRef.current ??
      empreedimentoSelecionado?.id ??
      formEmpreendimento.id ??
      formAp.empreendId;
    const apartamentoIdFluxo =
      idApRef.current ??
      formAp.id ??
      apSelecionado?.id ??
      empreendimentoSelecionadoAp?.id ??
      ApEmpreendimentoId;
    const origemEmpreendimentoFluxo =
      origemEmpRef.current ??
      empreedimentoSelecionado?.origem ??
      formEmpreendimento.origem;
    const cronogramaEmpreendimentoFluxo =
      empreedimentoSelecionado?.cronograma ??
      formEmpreendimento.cronograma ??
      cronogramaEmp.current;
    const origemApartamentoFluxo =
      origemApRef.current ??
      formAp.origem ??
      apSelecionado?.origem ??
      empreendimentoSelecionadoAp?.origem;
    const capacidadeApartamentoFluxo = naoSeiApartamento.capacidade
      ? 0
      : formAp.capacidade;
    const quartosApartamentoFluxo = naoSeiApartamento.quartos
      ? 0
      : formAp.quartos;
    const banheirosApartamentoFluxo = naoSeiApartamento.banheiros
      ? 0
      : formAp.banheiros;
    const nomeApartamentoFluxo =
      formAp.nome && formAp.nome.trim() !== ""
        ? formAp.nome.trim()
        : "Apartamento";

    if (!empreendimentoIdFluxo || !apartamentoIdFluxo) {
      error("NÃƒÂ£o foi possÃƒÂ­vel identificar o empreendimento ou apartamento.");
      return false;
    }

    const payloadIniciarFluxo = {
      usuarioId: Token.id,
      empreendimento: {
        modo: origemEmpreendimentoFluxo === 0 ? "EXISTENTE" : "NOVO",
        empreendimentoId: empreendimentoIdFluxo,
        origem: origemEmpreendimentoFluxo,
        cronograma: cronogramaEmpreendimentoFluxo,
      },
      apartamento: {
        modo: origemApartamentoFluxo === 0 ? "EXISTENTE" : "NOVO",
        apartamentoId: apartamentoIdFluxo,
        origem: origemApartamentoFluxo,
        nome: nomeApartamentoFluxo,
        empreendId: empreendimentoIdFluxo,
        capacidade: capacidadeApartamentoFluxo,
        quartos: quartosApartamentoFluxo,
        banheiros: banheirosApartamentoFluxo,
        metragem: formAp.metragem,
        varanda: formAp.varanda,
        terreo: formAp.terreo,
        estacionamento: formAp.estacionamento,
        vista: formAp.vista,
      },
    };

    try {
      const responseIniciarFluxo = await axios.post<IniciarFluxoCadastroResponse>(
        URL,
        { payload: payloadIniciarFluxo },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: Token.AuthStr,
          },
        }
      );

      if (!responseIniciarFluxo?.data?.success) {
        error("HÃƒÂ¡ algo de errado. Entre em contato conosco. CÃƒÂ³digo erro: VCP-016");
        return false;
      }

      fluxoCadastroEstadoRef.current = extrairFluxoCadastroEstado(
        responseIniciarFluxo.data
      );

      const etapaAtualFluxo = resolverStatusFluxoCadastro(
        responseIniciarFluxo.data
      );
      setState(etapaAtualFluxo);
      stateNovo.current = etapaAtualFluxo;

      const cotaUsuarioIdFluxo = responseIniciarFluxo.data.cotaUsuarioId ?? 0;
      const deveAbrirIdentificacaoCota =
        responseIniciarFluxo.data.etapaAtual ===
          "AGUARDANDO_IDENTIFICACAO_COTA" ||
        responseIniciarFluxo.data.proximaEtapa ===
          "AGUARDANDO_IDENTIFICACAO_COTA";

      contextoFluxoCadastroRef.current =
        responseIniciarFluxo.data.contextoFluxo ?? {
          usuarioId: Token.id,
          empreendimentoId: empreendimentoIdFluxo,
          apartamentoId: apartamentoIdFluxo,
        };

      if (cotaUsuarioIdFluxo) {
        const resultUsuario = await atualizarUsuarioGlobais(+Token.id, {
          status: "REGULAR",
        });

        if (!resultUsuario) {
          error("HÃƒÂ¡ algo de errado. Entre em contato conosco. CÃƒÂ³digo erro: VCP-096");
          return false;
        }

        cotaUsuarioRef.current = cotaUsuarioIdFluxo;
        setCotaUsuarioId(cotaUsuarioIdFluxo);
        setPcotaUsuarioId({
          pCotaUsuarioId: cotaUsuarioIdFluxo,
        });
      } else {
        cotaUsuarioRef.current = 0;
        setCotaUsuarioId(0);
      }

      if (deveAbrirIdentificacaoCota) {
        setState("AGUARDANDO_COTA");
        stateNovo.current = "AGUARDANDO_COTA";
        setNaoSabeNumeroCota(false);
        formNumeroCota.resetFields();
        await buscarCotas();
        setActiveStep(2);
        setRenderCotaSteps(1);
        setRenderPrioridadeSteps(0);
        setBloquearBotaoProximo(true);
        return true;
      }

      if (cotaUsuarioIdFluxo) {
        document.location.href = `/cadastroPropriedade/?pCotaUsuarioId=${cotaUsuarioIdFluxo}`;
        return true;
      }

      error("Resposta inesperada ao iniciar o fluxo da cota usuÃƒÂ¡rio.");
      return false;
    } catch (errIniciarFluxo) {
      console.error("Erro ao iniciar o fluxo da cota usuario", {
        errIniciarFluxo,
        payloadIniciarFluxo,
      });
      error(
        extrairMensagemErroApi(
          errIniciarFluxo,
          "Erro ao iniciar o fluxo da cota usuario. Codigo erro: VCP-017"
        )
      );
      return false;
    }
  };

  const obterUsuarioIdCTU = async () => {
    const Token = validateToken();
    const URLCTU = `${Globais.DOMINIOBACK}/cota-usuario/${pCotaUsuarioId.pCotaUsuarioId}`;

    if (Token) {
      try {
        const responseCTU = await axios.get(URLCTU, {
          headers: {
            "Content-Type": "application/json",
            Authorization: Token.AuthStr,
          },
        });
        if (responseCTU) {
          return responseCTU.data.usuarioId;
        } else {
          error("HÃ¡ algo de errado. Favor entrar em contato conosco. VCP-041");
        }
      } catch (e) {
        console.log(e);
        return 0;
      }
    } else {
      document.location.href = "/login";
    }
  };

  // FunÃ§Ã£o de criar uma cotaUsuario
  const criarCotaUsuario = async (
    status?: string,
    cotaNovaId?: number
  ): Promise<boolean> => {
    return iniciarFluxoCadastroCota();

    const Token = validateToken();
    if (Token) {
      const URL = `${Globais.DOMINIOBACK}/cota-usuario/fluxo-cadastro/iniciar`;
      const empreendimentoIdFluxo =
        empreedimentoSelecionado?.id ??
        formEmpreendimento.id ??
        idEmpRef.current ??
        formAp.empreendId;
      const apartamentoIdFluxo =
        formAp.id ??
        apSelecionado?.id ??
        empreendimentoSelecionadoAp?.id ??
        idApRef.current ??
        ApEmpreendimentoId;
      const origemEmpreendimentoFluxo =
        empreedimentoSelecionado?.origem ??
        formEmpreendimento.origem ??
        origemEmpRef.current;
      const cronogramaEmpreendimentoFluxo =
        empreedimentoSelecionado?.cronograma ??
        formEmpreendimento.cronograma ??
        cronogramaEmp.current;
      const origemApartamentoFluxo =
        formAp.origem ??
        apSelecionado?.origem ??
        empreendimentoSelecionadoAp?.origem ??
        origemApRef.current;

      if (!empreendimentoIdFluxo || !apartamentoIdFluxo) {
        error("NÃƒÂ£o foi possÃƒÂ­vel identificar o empreendimento ou apartamento.");
        return false;
      }

      const payloadIniciarFluxo = {
        usuarioId: Token!.id,
        empreendimento: {
          modo: origemEmpreendimentoFluxo === 0 ? "EXISTENTE" : "NOVO",
          empreendimentoId: empreendimentoIdFluxo,
          origem: origemEmpreendimentoFluxo,
          cronograma: cronogramaEmpreendimentoFluxo,
        },
        apartamento: {
          modo: origemApartamentoFluxo === 0 ? "EXISTENTE" : "NOVO",
          apartamentoId: apartamentoIdFluxo,
          origem: origemApartamentoFluxo,
        },
      };

      try {
        const responseIniciarFluxo =
          await axios.post<IniciarFluxoCadastroResponse>(
            URL,
            { payload: payloadIniciarFluxo },
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: Token!.AuthStr,
              },
            }
          );

        if (!responseIniciarFluxo?.data?.success) {
          error(
            "HÃƒÂ¡ algo de errado. Entre em contato conosco. CÃƒÂ³digo erro: VCP-016"
          );
          return false;
        }

        fluxoCadastroEstadoRef.current = extrairFluxoCadastroEstado(
          responseIniciarFluxo.data
        );

        const etapaAtualFluxo = resolverStatusFluxoCadastro(
          responseIniciarFluxo.data
        );
        setState(etapaAtualFluxo);
        stateNovo.current = etapaAtualFluxo;

        const deveAbrirIdentificacaoCota =
          responseIniciarFluxo.data.etapaAtual ===
            "AGUARDANDO_IDENTIFICACAO_COTA" ||
          responseIniciarFluxo.data.proximaEtapa ===
            "AGUARDANDO_IDENTIFICACAO_COTA";

        if (deveAbrirIdentificacaoCota) {
          const cotaUsuarioIdFluxo = responseIniciarFluxo.data.cotaUsuarioId ?? 0;

          contextoFluxoCadastroRef.current =
            responseIniciarFluxo.data.contextoFluxo ?? {
              usuarioId: Token!.id,
              empreendimentoId: empreendimentoIdFluxo,
              apartamentoId: apartamentoIdFluxo,
            };

          if (cotaUsuarioIdFluxo) {
            const resultUsuario = await atualizarUsuarioGlobais(+Token!.id, {
              status: "REGULAR",
            });

            if (!resultUsuario) {
              error(
                "HÃƒÂ¡ algo de errado. Entre em contato conosco. CÃƒÂ³digo erro: VCP-096"
              );
              return false;
            }

            cotaUsuarioRef.current = cotaUsuarioIdFluxo;
            setCotaUsuarioId(cotaUsuarioIdFluxo);
            setPcotaUsuarioId({
              pCotaUsuarioId: cotaUsuarioIdFluxo,
            });
          } else {
            setCotaUsuarioId(0);
          }

          setState("AGUARDANDO_COTA");
          stateNovo.current = "AGUARDANDO_COTA";
          setNaoSabeNumeroCota(false);
          formNumeroCota.resetFields();
          await buscarCotas();
          setActiveStep(2);
          setRenderCotaSteps(1);
          setRenderPrioridadeSteps(0);
          setBloquearBotaoProximo(true);
          return true;
        }

        if (responseIniciarFluxo.data.cotaUsuarioId) {
          const formData = {
            status: "REGULAR",
          };
          const resultUsuario = await atualizarUsuarioGlobais(
            +Token!.id,
            formData
          );

          if (!resultUsuario) {
            error(
              "HÃƒÂ¡ algo de errado. Entre em contato conosco. CÃƒÂ³digo erro: VCP-096"
            );
            return false;
          }

          setCotaUsuarioId(responseIniciarFluxo.data.cotaUsuarioId);
          document.location.href = `/cadastroPropriedade/?pCotaUsuarioId=${responseIniciarFluxo.data.cotaUsuarioId}`;
          return true;
        }

        error("Resposta inesperada ao iniciar o fluxo da cota usuÃƒÂ¡rio.");
        return false;
      } catch (errIniciarFluxo) {
        console.error("Erro ao iniciar o fluxo da cota usuario", errIniciarFluxo);
        error("Erro ao iniciar o fluxo da cota usuario. CÃƒÂ³digo erro: VCP-017");
        return false;
      }

      const tokenId = Number(Token?.id ?? 0);
      let minhaCotaId;

      if (cotaNovaId) {
        minhaCotaId = cotaNovaId;
      } else {
        minhaCotaId = await obterCotaId();
      }

      // Inicializa os valores do objeto com o conteÃºdo de formInfo
      const values: Record<string, any> = {
        ...formInfo,
        usuarioId: tokenId,
      };
      // // Adiciona cotaId somente se nÃ£o for nulo ou undefined
      if (
        minhaCotaId !== null &&
        minhaCotaId !== undefined &&
        minhaCotaId !== 0
      ) {
        values.cotaId = minhaCotaId;
      }

      if (
        formPrioridade.prioridade !== undefined &&
        formPrioridade.prioridade !== null &&
        formPrioridade.prioridade !== ""
      ) {
        values.prioridade = formPrioridade.prioridade;
      }

      if (
        formMaisInfo.saldoDevedor !== undefined &&
        formMaisInfo.saldoDevedor !== null
      ) {
        values.saldoDevedor = formMaisInfo.saldoDevedor;
      }

      if (
        formMaisInfo.valorCondominio !== undefined &&
        formMaisInfo.valorCondominio !== null
      ) {
        values.valorCondominio = formMaisInfo.valorCondominio;
      }

      if (
        formMaisInfo.valorVenda !== undefined &&
        formMaisInfo.valorVenda !== null
      ) {
        values.valorVenda = formMaisInfo.valorVenda;
      }

      try {
        const response = await axios.post<IniciarFluxoCadastroResponse>(
          URL,
          { payload: values },
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: Token?.AuthStr ?? "",
            },
          }
        );

        if (response?.data?.success && response.data.cotaUsuarioId) {
          fluxoCadastroEstadoRef.current = extrairFluxoCadastroEstado(
            response.data
          );
          const etapaAtualFluxo = resolverStatusFluxoCadastro(response.data);
          const formData = {
            status: "REGULAR",
          };
          const resultUsuario = await atualizarUsuarioGlobais(
            Number(Token?.id ?? 0),
            formData
          );
          if (resultUsuario) {
            setState(etapaAtualFluxo);
            stateNovo.current = etapaAtualFluxo;
            setCotaUsuarioId(response.data.cotaUsuarioId);
            document.location.href = `/cadastroPropriedade/?pCotaUsuarioId=${response.data.cotaUsuarioId}`;
          } else {
            error(
              "HÃ¡ algo de errado. Entre em contato conosco. CÃ³digo erro: VCP-096"
            );
          }
        } else {
          error(
            "HÃ¡ algo de errado. Entre em contato conosco. CÃ³digo erro: VCP-016"
          );
        }

        return true;
      } catch (err) {
        console.error("Erro ao iniciar o fluxo da cota usuario", err);
        error("Erro ao iniciar o fluxo da cota usuario. CÃ³digo erro: VCP-017");
        return false;
      }
    } else {
      return false;
    }
  };

  // FunÃ§Ã£o que armazena o id do pais selecionado para a atualizaÃ§Ã£o de cadastro e cadastro do proprietario
  const paisChange = (value: any) => {
    // Encontrar o paÃ­s correspondente ao valor selecionado
    const paisSelecionado = paises.find((pais) => pais.abreviacao === value);

    // Verificar se encontrou o paÃ­s
    if (paisSelecionado) {
      changing.current = true;
      setFormAtualizarCadastro((prevState) => ({
        ...prevState,
        paisId: paisSelecionado.id,
      }));
      setFormCadastroProprietario((prevState) => ({
        ...prevState,
        paisId: paisSelecionado.id,
      }));
    }
  };

  // FunÃ§Ã£o que armazena os dados do formulario de atualizaÃ§Ã£o de cadastro
  const atualizarCadastroChange = (
    changedValues: Partial<Cadastro>,
    allValues: Cadastro
  ) => {
    changing.current = true;

    setFormAtualizarCadastro((prevState) => ({
      ...prevState,
      ...allValues,
    }));

    // caso os campos endereÃ§o e complemento sejam apagados o botÃ£o proximo fica desabilitado

    if (
      changedValues.endereco === "" ||
      changedValues.complemento === "" ||
      changedValues.rg === ""
    ) {
      setBloquearBotaoProximo(true);
    }

    // sÃ³ habilita o botÃ£o proximo apÃ³s validar
    if (allValues.rg !== "") {
      if (
        allValues.nacionalidade !== undefined &&
        allValues.nacionalidade !== ""
      ) {
        if (
          allValues.estadoCivil !== undefined &&
          allValues.estadoCivil !== ""
        ) {
          if (allValues.endereco !== undefined && allValues.endereco !== "") {
            if (
              allValues.complemento !== undefined &&
              allValues.complemento !== ""
            ) {
              if (allValues.estadoId !== undefined) {
                if (allValues.cidadeId !== undefined) {
                  
                  setBloquearBotaoProximo(false);
                }
              }
            }
          }
        }
      }
    }
    // caso seja alterado o estado deverÃ¡ ser selecionado a nova cidade.
    if (changedValues.estadoId !== undefined) {
      setBloquearBotaoProximo(true);
      warning("Selecione a cidade de sua residÃªncia.");
    }
  };

  // FunÃ§Ã£o que armazena os dados do formulario de cadastro do proprietario
  const cadastrarProprietarioChange = (
    changedValues: Partial<Cadastro>,
    allValues: Cadastro
  ) => {
    changing.current = true;

    setFormCadastroNovoProprietario((prevState) => ({
      ...prevState,
      ...allValues,
    }));

    // let CPF = changedValues.cpf? validaCPF(changedValues.cpf):"";

    let cpfDigitado =
      changedValues.cpf !== undefined
        ? changedValues.cpf?.indexOf("_")
        : formCadastroNovoProprietario.cpf?.indexOf("_");
    let celularDigitado =
      changedValues.celular !== undefined
        ? changedValues.celular?.indexOf("_")
        : formCadastroNovoProprietario.celular?.indexOf("_");

    if (
      changedValues.nome === "" ||
      changedValues.sobrenome === "" ||
      cpfDigitado !== -1 ||
      changedValues.email === "" ||
      celularDigitado !== -1 ||
      changedValues.rg === "" ||
      changedValues.endereco === "" ||
      changedValues.complemento === ""
    ) {
      setBloquearBotaoProximo(true);
    }

    //validaÃ§Ã£o preenchimento de todos os campos. Se as condiÃ§Ãµes forem atendidas o botÃ£o proximo serÃ¡ liberado
    if (
      (formCadastroNovoProprietario.nome === "" &&
        changedValues.nome !== "" &&
        !(
          (formCadastroNovoProprietario.nome !== "" &&
            changedValues.nome === "") ||
          changedValues.nome === undefined
        )) ||
      (formCadastroNovoProprietario.nome !== "" && changedValues.nome !== "")
    ) {
      if (
        (!(
          formCadastroNovoProprietario.sobrenome === undefined &&
          changedValues.sobrenome === undefined
        ) &&
          !(
            formCadastroNovoProprietario.sobrenome !== undefined &&
            changedValues.sobrenome === ""
          )) ||
        (formCadastroNovoProprietario.sobrenome !== undefined &&
          changedValues.sobrenome !== undefined &&
          changedValues.sobrenome !== "")
      ) {
        if (cpfDigitado === -1) {
          if (allValues.email !== undefined && allValues.email !== "") {
            if (allValues.rg !== undefined && allValues.rg !== "") {
              if (celularDigitado === -1) {
                if (
                  allValues.nacionalidade !== undefined &&
                  allValues.nacionalidade !== ""
                ) {
                  if (
                    allValues.estadoCivil !== undefined &&
                    allValues.estadoCivil !== ""
                  ) {
                    if (
                      allValues.endereco !== undefined &&
                      allValues.endereco !== ""
                    ) {
                      if (
                        allValues.complemento !== undefined &&
                        allValues.complemento !== ""
                      ) {
                        if (allValues.estadoId !== undefined) {
                          if (allValues.cidadeId !== undefined) {
                            setBloquearBotaoProximo(false);
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  };

  // FunÃ§Ã£o de atualizaÃ§Ã£o de cadastro
  const atualizarUsuario = async (statusUsuario: string): Promise<boolean> => {
    const Token = validateToken();

    if (Token) {
      const tokenId = Token.id;
      let usuarioId = 0;

      const values: Usuario = {};

      if (statusUsuario === "REPRESENTANTE") {
        usuarioId = tokenId;
        values.estadoCivil = formAtualizarCadastro.estadoCivil;
        values.nacionalidade = formAtualizarCadastro.nacionalidade;
        values.rg = formAtualizarCadastro.rg;
      }

      if (statusUsuario === "PROPRIETARIO") {
        usuarioId = proprietarioRef.current;
        values.nome = formCadastroNovoProprietario.nome;
        values.sobrenome = formCadastroNovoProprietario.sobrenome;

        // values.email = formCadastroNovoProprietario.email;
        // values.cpf = formCadastroNovoProprietario.cpf;
        values.celular = numberPadrao(formCadastroNovoProprietario.celular);
        values.estadoCivil = formCadastroNovoProprietario.estadoCivil;
        values.nacionalidade = formCadastroNovoProprietario.nacionalidade;
        values.rg = formCadastroNovoProprietario.rg;
      }

      const URL = `${Globais.DOMINIOBACK}/usuario/${usuarioId}`;

      try {
        const response = await axios.put(URL, values, {
          headers: {
            "Content-Type": "application/json",
            Authorization: Token.AuthStr,
          },
        });
        if (response) {
          // document.location.reload();
        } else {
          error("HÃ¡ algo de errado. CÃ³digo de erro: VCP-044");
        }

        return true;
      } catch (error) {
        console.log(error);
        return false;
      }
    } else {
      return false;
    }
  };

  // FunÃ§Ã£o de cadastro de endereÃ§o
  const cadastrarEndereco = async (usuarioId?: number): Promise<boolean> => {
    const Token = validateToken();
    if (Token) {
      const tokenId = usuarioId ? usuarioId : Token.id;
      const URL = `${Globais.DOMINIOBACK}/endereco`;
      const form = usuarioId
        ? formCadastroNovoProprietario
        : formAtualizarCadastro;
      const values = {
        usuarioId: tokenId,
        endereco: form.endereco,
        complemento: form.complemento,
        cidadeId: form.cidadeId,
        estadoId: form.estadoId,
        paisId: 2,
      };

      try {
        const response = await axios.post(URL, values, {
          headers: {
            "Content-Type": "application/json",
            Authorization: Token.AuthStr,
          },
        });

        return true;
      } catch (error) {
        console.log(error);
        return false;
      }
    } else {
      return false;
    }
  };

  const buscarMeuEndereco = async (statusUsuario: string): Promise<boolean> => {
    const Token = validateToken();

    if (Token) {
      let usuarioId = 0;
      const tokenId = Token.id;
      if (statusUsuario === "REPRESENTANTE") {
        usuarioId = tokenId;
      }
      if (statusUsuario === "PROPRIETARIO") {
        usuarioId = proprietarioRef.current;
      }

      const URL = `${Globais.DOMINIOBACK}/endereco/usuario/${usuarioId}`;
      try {
        const response = await axios.get(URL, {
          headers: { Authorization: Token.AuthStr },
        });

        if (response.data && Object.keys(response.data).length > 0) {
          const sucesso = await atualizarEndereco(
            response.data.id,
            statusUsuario
          );
          if (sucesso) {
            return true;
          } else {
            return false;
          }
        } else {
          const sucesso = await cadastrarEndereco();
          if (sucesso) {
            return true;
          } else {
            return false;
          }
        }
      } catch (error) {
        console.log(error);
        return false;
      }
    } else {
      return false;
    }
  };

  const atualizarEndereco = async (
    enderecoId: number,
    statusUsuario: string
  ): Promise<boolean> => {
    const Token = validateToken();
    if (Token) {
      const URL = `${Globais.DOMINIOBACK}/endereco`;
      const form =
        statusUsuario === "PROPRIETARIO"
          ? formCadastroProprietario
          : formAtualizarCadastro;
      const values = {
        endereco: form.endereco,
        complemento: form.complemento,
        cidadeId: form.cidadeId,
        estadoId: form.estadoId,
        paisId: form.paisId,
        enderecoId: enderecoId,
      };

      try {
        const response = await axios.put(URL, values, {
          headers: {
            "Content-Type": "application/json",
            Authorization: Token.AuthStr,
          },
        });

        return true;
      } catch (error) {
        console.log(error);
        return false;
      }
    } else {
      return false;
    }
  };

  // FunÃ§Ã£o principal que Ã© chamada em handleNext para a atualizaÃ§Ã£o de DADOS

  const atualizarDados = async (status: string): Promise<boolean> => {
    const statusUsuario = status;
    const sucesso = await atualizarUsuario(statusUsuario);
    if (sucesso) {
      const sucesso = await buscarMeuEndereco(statusUsuario);
      if (sucesso) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  };

  const buscarUsuario = async (usuarioLogadoId?: string) => {
    const Token = validateToken();
    if (Token) {
      const URL = `${Globais.DOMINIOBACK}/usuario/buscarUsuario`;
      const values = {
        usuarioLogadoId: usuarioLogadoId,
        email: formCadastroNovoProprietario.email,
        cpf: formCadastroNovoProprietario.cpf,
      };
      try {
        const response = await axios.post(URL, values, {
          headers: {
            "Content-Type": "application/json",
            Authorization: Token.AuthStr,
          },
        });

        if (response) {
          return response.data;
        } else {
          error("HÃ¡ algo de errado. CÃ³digo de erro: VCP-036");
          return false;
        }
      } catch (error) {
        throw error;
      }
    } else {
      return false;
    }
  };

  // FunÃ§Ã£o de cadastro do proprietario
  const cadastrarUsuario = async (usuarioId?: number): Promise<boolean> => {
    const Token = validateToken();

    let usuarioIdProp;

    if (Token) {
      if (usuarioId) {
        usuarioIdProp = usuarioId;
      } else {
        const URL = `${Globais.DOMINIOBACK}/usuario/0/0`;
        const values = {
          nome: formCadastroNovoProprietario.nome,
          sobrenome: formCadastroNovoProprietario.sobrenome,
          email: formCadastroNovoProprietario.email,
          cpf: formCadastroNovoProprietario.cpf,
          rg: formCadastroNovoProprietario.rg,
          celular: numberPadrao(formCadastroNovoProprietario.celular),
          estadoCivil: formCadastroNovoProprietario.estadoCivil,
          nacionalidade: formCadastroNovoProprietario.nacionalidade,
        };

        try {
          const response = await axios.post(URL, values, {
            headers: {
              "Content-Type": "application/json",
              Authorization: Token.AuthStr,
            },
          });
          if (response) {
            usuarioIdProp = response.data.id;
            cadastrarEndereco(response.data.id);
          } else {
            error("HÃ¡ algo de errado. VCP-092");
            return false;
          }

          return true;
        } catch (error) {
          return false;
        }
      }

      proprietarioRef.current = usuarioIdProp;
      const resultado = await atualizarCotaUsuario(
        "AGUARDANDO_COMPROVANTE",
        usuarioIdProp
      );
      if (resultado) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  };

  // FunÃ§Ã£o de atualizaÃ§Ã£o de cotaUsuario, do representante para o proprietario criado
  const atualizarCotaUsuario = async (
    status?: string,
    idProprietario?: number,
    tipo?: string,
    cotaNovaId?: number,
    patch?: Partial<ServicosMulticotas>
  ): Promise<boolean> => {
    const Token = validateToken();
    if (Token) {
      const URL = `${Globais.DOMINIOBACK}/cota-usuario/${pCotaUsuarioId.pCotaUsuarioId}`;
      const prioridade = formPrioridade ? formPrioridade.prioridade : null;
      const maisInfo: any = formMaisInfo;
      const keys: Array<keyof typeof maisInfo> = [
        "situacao",
        "valorVenda",
        "valorCondominio",
        "saldoDevedor",
      ];
      const values: any = {};

      // Adiciona usuarioId somente se idProprietario tiver um valor definido

      if (
        idProprietario !== undefined &&
        idProprietario !== null &&
        idProprietario !== 0
      ) {
        values.usuarioId = idProprietario;
      }
      if (
        prioridade !== undefined &&
        prioridade !== null &&
        prioridade !== ""
      ) {
        values.prioridade = prioridade;
      }

      if (tipo === "ALTERAR_COTAID") {
        if (cotaNovaId) {
          values.cotaId = cotaNovaId;
        } else {
          values.cotaId = await obterCotaId();

          if (values.cotaId) {
            if (origemMinhaCota !== 0) {
              const URLCota = `${Globais.DOMINIOBACK}/cota/${cotaId}`;
              try {
                const responseCotaDelete = await axios.delete(URLCota, {
                  headers: {
                    "Content-Type": "application/json",
                    Authorization: Token.AuthStr,
                  },
                });
                if (responseCotaDelete) {
                  if (origemApRef.current !== 0) {
                    const URLApto = `${Globais.DOMINIOBACK}/apto/${idApRef.current}`;
                    try {
                      const responseAptoDelete = await axios.delete(URLApto, {
                        headers: {
                          "Content-Type": "application/json",
                          Authorization: Token.AuthStr,
                        },
                      });
                      if (responseAptoDelete) {
                        if (naoEncontrouEmpreendimento) {
                          const URLEmp = `${Globais.DOMINIOBACK}/empreendimento/${idEmpRef.current}`;
                          try {
                            const responseEmpDelete = await axios.delete(
                              URLEmp,
                              {
                                headers: {
                                  "Content-Type": "application/json",
                                  Authorization: Token.AuthStr,
                                },
                              }
                            );
                            if (responseEmpDelete) {
                              
                            } else {
                              error("HÃ¡ algo de errado. CÃ³digo erro: VCP-026.");
                            }
                          } catch (e) {
                            console.log(e);
                            error("HÃ¡ algo de errado. CÃ³digo erro: VCP-025.");
                          }
                        }
                      } else {
                        error("HÃ¡ algo de errado. CÃ³digo erro: VCP-023.");
                      }
                    } catch (e) {
                      console.log(e);
                      error("HÃ¡ algo de errado. CÃ³digo erro: VCP-022.");
                    }
                  }
                } else {
                  error("HÃ¡ algo de errado. CÃ³digo erro: VCP-021.");
                }
              } catch (e) {
                console.log(e);
                error("HÃ¡ algo de errado. CÃ³digo erro: VCP-020.");
              }
            }
          }
        }
      }

      if (tipo === "MODIFICAR_CTU_NAOENCONTRADO") {
        const responseDelete = await axios.delete(URL, {
          headers: {
            "Content-Type": "application/json",
            Authorization: Token.AuthStr,
          },
        });
        if (responseDelete) {
          return true;
        } else {
          error("NÃ£o foi possÃ­vel atualizar a propriedade. VCP-012");
        }
      }

      if (status === "AGUARDANDO_TITULARIDADE") {
        values.andar = formInfo.andar;
        values.bloco = formInfo.bloco;
        values.numeroApto = formInfo.numeroApto;
        values.vista = formInfo.vista;
        values.cotaId = await obterCotaId();
      }
      if (tipo === "ALTERAR_MAIS_INFO") {
        values.andar = formInfo.andar;
        values.bloco = formInfo.bloco;
        values.numeroApto = formInfo.numeroApto;

        values.vista = formInfo.vista;
      }

      // Atualiza os valores somente se os valores em maisInfo nÃ£o forem undefined ou null
      keys.forEach((key) => {
        if (maisInfo[key] !== undefined && maisInfo[key] !== null) {
          values[key] = maisInfo[key];
        }
      });

      if (patch) {
        Object.assign(values, patch);
      }

      if (
        (status === "AGUARDANDO_PERIODOS" ||
          status === "AGUARDANDO_DEFINICAO_ANUNCIO") &&
        formMinhaCota.id !== undefined &&
        formMinhaCota.id !== null
      ) {
        values.cotaId = formMinhaCota.id;
      }

      if (tipo === "ALTERAR_COTAID" && !values.cotaId) {
        try {
          const responseDelete = await axios.delete(URL, {
            headers: {
              "Content-Type": "application/json",
              Authorization: Token.AuthStr,
            },
          });
          if (responseDelete) {
            const sucessoCotaUsuario = await iniciarFluxoCadastroCota();

            if (sucessoCotaUsuario) {
              return true;
            }
          } else {
            error("HÃ¡ algo de errado.  CÃ³digo erro: VCP-018");
          }
        } catch (error) {}
        return false;
      } else {
        try {
          const response = await axios.put(URL, values, {
            headers: {
              "Content-Type": "application/json",
              Authorization: Token.AuthStr,
            },
          });
          if (response) {
            setCotaUsuarioId(response.data.id);

            const deveAvancarFluxo =
              tipo === "ALTERAR_COTAID" ||
              (!!status && statusQueDisparamAvancoFluxo.has(status));

            if (deveAvancarFluxo) {
              const fluxoAtualizado = await avancarFluxoCadastro(
                response.data.id ?? pCotaUsuarioId.pCotaUsuarioId
              );

              if (!fluxoAtualizado) {
                error(
                  "Ha algo de errado. Entre em contato conosco. Codigo erro: VCP-097"
                );
                return false;
              }
            }
          }

          return true;
        } catch (error) {
          console.log(error);
          return false;
        }
      }
    } else {
      return false;
    }
  };

  // FunÃ§Ã£o de cadastro do representante

  const cadastrarRepresentante = async () => {
    const Token = validateToken();
    if (Token) {
      const URL = `${Globais.DOMINIOBACK}/representante`;
      const values = {
        usuarioId: Token.id,
        cotaUsuarioId: cotaUsuarioId,
      };
      try {
        const response = await axios.post(URL, values, {
          headers: {
            "Content-Type": "application/json",
            Authorization: Token.AuthStr,
          },
        });
        if (response) {
          return true;
        } else {
          return false;
        }
      } catch (error) {
        console.log(error);
        error("HÃ¡ algo de errado. CÃ³digo de erro: VCP-038");
      }
    }
  };
  // FunÃ§Ã£o de deletar cadastro do representante

  const deletarRepresentante = async () => {
    const Token = validateToken();
    if (Token) {
      const URL = `${Globais.DOMINIOBACK}/representante/usuario/${Token.id}`;

      try {
        const response = await axios.get(URL, {
          headers: {
            "Content-Type": "application/json",
            Authorization: Token.AuthStr,
          },
        });
        if (response) {
          const representante = response.data.filter((p: any) => {
            if (p.cotasUsuariosId === pCotaUsuarioId.pCotaUsuarioId) {
              return p;
            }
          });
          if (representante) {
            const URLDelete = `${Globais.DOMINIOBACK}/representante/${representante[0].id}`;
            const responseDelete = await axios.delete(URLDelete, {
              headers: {
                "Content-Type": "application/json",
                Authorization: Token.AuthStr,
              },
            });
            if (responseDelete) {
              return true;
            } else {
              return false;
            }
          }
        } else {
          return false;
        }
      } catch (error) {
        console.log(error);
        error("HÃ¡ algo de errado. CÃ³digo de erro: VCP-048");
      }
    }
  };
  // FunÃ§Ã£o principal que Ã© chamada em handleNext para cadastro do proprietario
  const cadastrarProprietario = async (
    usuarioId?: number
  ): Promise<boolean> => {
    // Verifica se o proprietario cadastrado ja existe

    let sucessoUsuario;

    if (usuarioId) {
      sucessoUsuario = await cadastrarUsuario(usuarioId);
    } else {
      sucessoUsuario = await cadastrarUsuario();
    }

    if (sucessoUsuario) {
      const sucessoRepresentante = cadastrarRepresentante();
      if (await sucessoRepresentante) {
        return salvarTitularidadeEAvancar(proprietarioRef.current);
      } else {
        return false;
      }
    } else {
      error("HÃ¡ algo de errado. CÃ³digo erro: VCP-037");
      return false;
    }
  };

  const ativarAnuncio = () => {
    changing.current = true;
    setBloquearBotaoProximo(false);
    setAnunciar(1);
  };

  const naoAtivarAnuncio = () => {
    changing.current = true;
    setBloquearBotaoProximo(false);
    setAnunciar(2);
  };

  const buscarCotas = async (): Promise<boolean> => {
    const Token = validateToken();
    if (!Token) {
      return false; // Retorna false se o token nÃ£o for vÃ¡lido
    }

    const URL = `${Globais.DOMINIOBACK}/cota`;

    try {
      const response = await axios.get(URL, {
        headers: {
          "Content-Type": "application/json",
          Authorization: Token.AuthStr,
        },
      });

      if (response && response.data) {
        const cotas: Cotas[] = response.data;
        let cotasDoUsuario: Cotas[] = [];
        const cotaAtualSelecionadaId = formMinhaCota.id || idMinhaCota;
        const apartamentoIdAtual =
          formAp.id ??
          idApRef.current ??
          contextoFluxoCadastroRef.current?.apartamentoId;

        switch (cronogramaEmp.current === 1 || cronogramaRef.current === 1) {
          case origemAp === 0 || origemApRef.current === 0:
            //Filtrando as cotas de acordo com o apartamento registrado
            cotasDoUsuario = cotas.filter(
              (cotas: Cotas) =>
                cotas.aptoId === apartamentoIdAtual &&
                (cotas.origem === 0 || cotas.id === cotaAtualSelecionadaId)
            );
            break;
          case origemAp !== 0 || origemApRef.current !== 0:
            //Filtrando as cotas de acordo com o apartamento registrado
            cotasDoUsuario = cotas.filter(
              (cotas: Cotas) => cotas.aptoId === apartamentoIdAtual
            );
            break;
          default:
            console.error(
              "NÃ£o foi possivel resgatar as cotas, por favor entre em contato"
            );
            break;
        }

        setCotasUsuario(cotasDoUsuario);

        return true;

        // Retorna true se tudo correr bem e o array nÃ£o estiver vazio
      } else {
        return false;
      }
    } catch (error) {
      console.log(error);
      return false; // Retorna false se houver um erro na chamada da API
    }
  };

  const prioridadeChange = (changedValues: Partial<any>, allValues: any) => {
    changing.current = true;

    setFormPrioridade((prevState: any) => ({
      ...prevState,
      prioridade: allValues.prioridade,
    }));

    if (formPrioridade !== null || changedValues.prioridade !== "") {
      setBloquearBotaoProximo(false);
    }
    if (changedValues.prioridade === "") {
      setBloquearBotaoProximo(true);
    }
  };

  const atualizarMinhaCota = async (tipo?: string): Promise<boolean> => {
    const Token = validateToken();

    if (Token) {
      const URL = `${Globais.DOMINIOBACK}/cota/${idMinhaCota}`;
      let values;
      switch (tipo) {
        case "atualizarNumeroCota":
          if (origemApRef.current === 0) {
            values = {
              numeroCota: formMinhaCota.numeroCota,
            };
          } else {
            values = {
              numeroCota: formMinhaCotaOrigemProprietario.numeroCota,
            };
          }

          break;
        case "atualizarQtdSemanas":
          values = {
            qtdSemanas: formSemanasPorAno.semanasPorAno,
          };
          break;
        case "atualizarDiaSemana":
          values = {
            diaDaSemanaInicio: formDiaDaSemana.diaDaSemana,
          };
          break;
      }

      try {
        const response = await axios.put(URL, values, {
          headers: {
            "Content-Type": "application/json",
            Authorization: Token.AuthStr,
          },
        });
        if (response) {
          return true;
        } else {
          error("HÃ¡ algo de errado. CÃ³digo de erro: VCP-071");
          return false;
        }

        return true;
      } catch (error) {
        console.log(error);
        error("HÃ¡ algo de errado. CÃ³digo de erro: VCP-072");
        return false;
      }
    } else {
      return false;
    }
  };

  const semanasPorAnoChange = (changedValues: Partial<any>, allValues: any) => {
    changing.current = true;
    formSemanasPorAno.semanasPorAno = changedValues.semanasPorAno;

    if (changedValues.semanasPorAno === "") {
      setBloquearBotaoProximo(true);
    } else {
      if (
        changedValues.semanasPorAno === "1" ||
        changedValues.semanasPorAno === "2" ||
        changedValues.semanasPorAno === "3" ||
        changedValues.semanasPorAno === "4"
      ) {
        setBloquearBotaoProximo(false);
      } else {
        error("O sistema sÃ³ permite incluir de 1 a 4 semanas.");
        setBloquearBotaoProximo(true);
      }
    }
  };

  const diaDaSemanaChange = (changedValues: Partial<any>, allValues: any) => {
    changing.current = true;
    //setFormDiaDaSemana(allValues.diaDaSemana);
    formDiaDaSemana.diaDaSemana = changedValues.diaDaSemana;

    if (changedValues.diaDaSemana !== "") {
      setBloquearBotaoProximo(false);
    }
  };
  const [minhaSituacao, setMinhaSituacao] = useState<string>();

  const [maisInfoForm] = Form.useForm(); // Cria uma referÃªncia ao formulÃ¡rio

  const maisInfoChange = (changedValues: Partial<any>, allValues: any) => {
    setFormMaisInfo(allValues);
    changing.current = true;
    setMinhaSituacao(allValues.situacao);

    const { situacao, valorVenda, valorCondominio, saldoDevedor } = allValues;

    // Reseta saldoDevedor se situacao nao for "NAO_QUITADO"
    if (situacao !== "NAO_QUITADO") {
      maisInfoForm.resetFields(["saldoDevedor"]);
    }



    if (
      changedValues.valorVenda == 0 ||
      changedValues.valorCondominio == 0 ||
      ((changedValues.situacao === "NAO_QUITADO" ||
        situacao === "NAO_QUITADO") &&
        (saldoDevedor === null ||
          saldoDevedor === undefined ||
          saldoDevedor === 0 ||
          changedValues.saldoDevedor === 0))
    ) {
      setBloquearBotaoProximo(true);
    } else {
      if (
        (situacao !== null || changedValues.situacao !== undefined) &&
        (valorVenda !== null || changedValues.valorVenda !== undefined) &&
        (valorCondominio !== null ||
          changedValues.valorCondominio !== undefined)
      ) {
        setBloquearBotaoProximo(false);
      }
    }
  };

  const numeroCotaChange = (changedValues: Partial<any>, allValues: any) => {
    changing.current = true;
    const selectedCotaId = changedValues.numeroCota;
    if (selectedCotaId) {
      const cotaSelecionada = cotasUsuario.find(
        (cotaUsuario) => cotaUsuario.id === selectedCotaId
      );

      if (!cotaSelecionada) {
        error("N\u00E3o foi poss\u00EDvel identificar a cota selecionada.");
        return;
      }

      setFormMinhaCota({
        id: cotaSelecionada.id,
        numeroCota: cotaSelecionada.numeroCota,
      });
      setCotaId(cotaSelecionada.id);
      cotaIdRef.current = cotaSelecionada.id;
      setIdMinhaCota(cotaSelecionada.id);
      setOrigemMinhaCota(cotaSelecionada.origem);
      setFormMinhaCotaOrigemProprietario({
        numeroCota: cotaSelecionada.id,
      });
      formNumeroCota.setFieldsValue({ numeroCota: cotaSelecionada.id });
      setNaoSabeNumeroCota(false);
      setBloquearBotaoProximo(false);
    } else {
      console.error("Erro ao selecionar cotas");
    }
  };
  const selecionarCotaPadraoCronogramaAntiga = () => {
    const cotasOrdenadas = [...cotasUsuario].sort(
      (cotaA, cotaB) => cotaA.numeroCota - cotaB.numeroCota
    );
    const cotaPadrao =
      cotasOrdenadas.find((cotaUsuario) => cotaUsuario.numeroCota === 1) ??
      cotasOrdenadas[0];

    if (!cotaPadrao) {
      error("N\u00E3o foi poss\u00EDvel localizar as cotas deste apartamento.");
      return;
    }

    changing.current = true;
    formNumeroCota.setFieldsValue({ numeroCota: cotaPadrao.id });
    setFormMinhaCota({
      id: cotaPadrao.id,
      numeroCota: cotaPadrao.numeroCota,
    });
    setFormMinhaCotaOrigemProprietario({
      numeroCota: cotaPadrao.id,
    });
    setNaoSabeNumeroCota(true);
    setBloquearBotaoProximo(false);
  };
  const selecionarCotaPadraoCronograma = async () => {
    const Token = validateToken();
    const aptoIdAtual = formAp.id || idApRef.current;

    if (!Token || !aptoIdAtual) {
      error("N\u00E3o foi poss\u00EDvel identificar o apartamento desta cota.");
      return;
    }

    const cotaUsuarioExistente = cotasUsuario.find(
      (cotaUsuario) =>
        cotaUsuario.aptoId === aptoIdAtual &&
        cotaUsuario.origem === Token.id &&
        cotaUsuario.numeroCota === 1
    );

    if (cotaUsuarioExistente) {
      changing.current = true;
      setCotaId(cotaUsuarioExistente.id);
      cotaIdRef.current = cotaUsuarioExistente.id;
      setIdMinhaCota(cotaUsuarioExistente.id);
      setOrigemMinhaCota(cotaUsuarioExistente.origem);
      formNumeroCota.setFieldsValue({ numeroCota: cotaUsuarioExistente.id });
      setFormMinhaCota({
        id: cotaUsuarioExistente.id,
        numeroCota: cotaUsuarioExistente.numeroCota,
      });
      setFormMinhaCotaOrigemProprietario({
        numeroCota: cotaUsuarioExistente.id,
      });
      setNaoSabeNumeroCota(true);
      setBloquearBotaoProximo(false);
      return;
    }

    const URL = `${Globais.DOMINIOBACK}/cota/${aptoIdAtual}`;
    const valuesCriarCota = {
      aptoId: aptoIdAtual,
      origem: Token.id,
      numeroCota: 1,
      qtdSemanas: 0,
    };

    try {
      const response = await axios.post(URL, valuesCriarCota, {
        headers: {
          "Content-Type": "application/json",
          Authorization: Token.AuthStr,
        },
      });

      if (!response?.data) {
        error("N\u00E3o foi poss\u00EDvel criar a cota padr\u00E3o.");
        return;
      }

      const novaCota = response.data;

      changing.current = true;
      setCotaId(novaCota.id);
      cotaIdRef.current = novaCota.id;
      setIdMinhaCota(novaCota.id);
      setOrigemMinhaCota(novaCota.origem);
      setCotasUsuario((prevState) => {
        const cotasSemDuplicidade = prevState.filter(
          (cotaUsuario) => cotaUsuario.id !== novaCota.id
        );
        return [...cotasSemDuplicidade, novaCota].sort(
          (cotaA, cotaB) => cotaA.numeroCota - cotaB.numeroCota
        );
      });
      formNumeroCota.setFieldsValue({ numeroCota: novaCota.id });
      setFormMinhaCota({
        id: novaCota.id,
        numeroCota: novaCota.numeroCota,
      });
      setFormMinhaCotaOrigemProprietario({
        numeroCota: novaCota.id,
      });
      setNaoSabeNumeroCota(true);
      setBloquearBotaoProximo(false);
    } catch (err) {
      console.log(err);
      error("N\u00E3o foi poss\u00EDvel criar a cota padr\u00E3o.");
    }
  };
  const numeroCotaOrigemProprietarioChange = (
    changedValues: Partial<any>,
    allValues: any
  ) => {
    changing.current = true;

    //  setFormNumeroCota(changedValues.numeroCota);
    changing.current = true;

    setFormMinhaCota((prevState) => ({
      ...prevState,
      numeroCota: changedValues.numeroCota,
    }));
    setFormMinhaCotaOrigemProprietario((prevState) => ({
      ...prevState,
      numeroCota: changedValues.numeroCota,
    }));

    if (!isNaN(changedValues.numeroCota)) {
      if (
        !formMinhaCota.numeroCota === undefined ||
        changedValues.numeroCota !== ""
      ) {
        setBloquearBotaoProximo(false);
      }
    }

    if (changedValues.numeroCota === "") {
      setBloquearBotaoProximo(true);
    }

    if (isNaN(changedValues.numeroCota)) {
      error("Favor inserir um nÃºmero");
    }
  };
  // FunÃ§Ã£o que realiza o Upload de arquivos

  const props: UploadProps = {
    onRemove: (file) => {
      const index = fileList.indexOf(file);
      const newFileList = fileList.slice();
      newFileList.splice(index, 1);
      setFileList(newFileList);
    },
    beforeUpload: (file) => {
      setFileList([...fileList, file]);

      return false;
    },
    fileList,
  };
  const handleUpload = async () => {
    changing.current = true;
    const formData = new FormData();
    const Token = validateToken();

    if (Token) {
      const URLArquivo = `${Globais.DOMINIOBACK}/arquivo/upload`;
      let cotaUsuarioIdArquivo =
        pCotaUsuarioId.pCotaUsuarioId?.toLocaleString();

      if (cotaUsuarioIdArquivo) {
        fileList.forEach((file) => {
          formData.append("files[]", file as FileType);
        });
      }
      setUploading(true);

      try {
        const uploadPromises = fileList.map(async (f: any) => {
          let formData = {
            file: f,
            tipo: "1",
            cotaUsuarioId: cotaUsuarioIdArquivo,
            origem: Token?.id,
          };

          return axios.post(URLArquivo, formData, {
            headers: {
              Authorization: Token.AuthStr,
              "Content-type": "multipart/form-data",
            },
          });
        });

        // Aguarda todas as requisiÃ§Ãµes serem concluÃ­das
        const responses = await Promise.all(uploadPromises);

        // Se retornadas, chama chama a funÃ§ao handleNext
        if (responses) {
          message.success("Arquivo(s) anexado(s) com sucesso!");
          setUploading(false);
          avancarStepCadastroPropriedade();
        }
      } catch (error) {
        message.error("HÃ¡ algo de errado. CÃ³digo erro: VCP-097");
        if (error.response?.data?.status === 502) {
          error(
            "Ops. Algo deu errado. Entre em contato conosco. CÃ³digo erro: VCP-019"
          );
        }
      }
    }
  };

  const [uploadedFiles, setUploadedFiles] = useState([]);
  const buscarMeuArquivo = async () => {
    const formData = new FormData();
    const Token = validateToken();
    if (Token) {
      const URL = `${Globais.DOMINIOBACK}/arquivo-cota-usuario/cotaUsuario/${cotaUsuarioRef.current}`;

      try {
        const response = await axios.get(URL, {
          headers: {
            Authorization: Token.AuthStr,
            "Content-type": "multipart/form-data",
          },
        });

        setUploadedFiles(response.data);
      } catch (error) {
        console.log(error);
      }
    }
  };
  const excluirCota = async () => {
    const Token = validateToken();
    const URL = `${Globais.DOMINIOBACK}/cota/${cotaId}`;

    if (Token) {
      try {
        const response = await axios.delete(URL, {
          headers: {
            "Content-Type": "application/json",
            Authorization: Token.AuthStr,
          },
        });
      } catch (error) {
        console.error(error);
      }
    }
  };

  const verificarAnuncioPropriedade = async () => {
    const Token = validateToken();
    const URL = `${Globais.DOMINIOBACK}/anuncio-propriedade/venda/cotaUsuario/${pCotaUsuarioId.pCotaUsuarioId}`;

    if (Token) {
      try {
        const response = await axios.get(URL, {
          headers: {
            "Content-Type": "application/json",
            Authorization: Token.AuthStr,
          },
        });
        if (Array.isArray(response.data) && response.data.length > 0) {
          const { active, dataInativacaoAnuncio } = response.data[0]; // Acesse o primeiro item do array
          // Converte dataInativacaoAnuncio para um objeto Date
          const inactivationDate = new Date(dataInativacaoAnuncio);

          if (
            active === 1 &&
            (inactivationDate > new Date() || isNaN(inactivationDate.getTime()))
          ) {
            return true;
          }
        }

        return false; // Retorna false se nÃ£o passar nas verificaÃ§Ãµes
      } catch (error) {
        console.error(error);
      }
    }
  };

  const [anuncioPropriedade, setAnuncioPropriedade] = useState<boolean>();
  const existeEmpreendimentoComNome = empreendimento.some(
    (emp) =>
      emp.nome?.trim().toLowerCase() ===
      empreendimentoSearch.trim().toLowerCase()
  );
  //----------------  Componentes --------------------

  // Componente Em qual empreendimento você tem uma propriedade ou direito de hospedagem?
  const selecionarEmpreendimento = (
    <>
      <Card
        title={
          <CardTitle>
            Em qual empreendimento você tem uma propriedade ou direito de
            hospedagem?
          </CardTitle>
        }
        bordered={true}
        type="inner"
        className="mobile"
        style={{
          width: "100%",
        }}
      >
        <div className="containerEmpreendimento">
          <TypographyAntd.Text
            type="secondary"
            style={{ display: "block", marginBottom: 12 }}
          >
            Verifique seu empreendimento na lista. Caso não encontre, digite o
            nome e pressione Enter para cadastrar um novo.
          </TypographyAntd.Text>
          <Select
            showSearch
            className="selectEmpreendimento"
            placeholder="Selecione um empreendimento"
            optionFilterProp="children"
            onChange={handleSelectChange}
            onSearch={setEmpreendimentoSearch}
            onInputKeyDown={handleEmpreendimentoEnter}
            filterOption={(input, option) => {
              if (typeof option?.label === "string") {
                const inputLowerCase = input.toLowerCase();
                const labelLowerCase = option.label.toLowerCase();
                return (
                  labelLowerCase.includes(inputLowerCase) ||
                  option.label.includes(input) || // original input
                  option.label
                    .toLowerCase()
                    .includes(
                      inputLowerCase.charAt(0).toUpperCase() +
                        inputLowerCase.slice(1)
                    )
                );
              }
              return false;
            }}
            filterSort={(optionA, optionB) => {
              if (
                typeof optionA?.label === "string" &&
                typeof optionB?.label === "string"
              ) {
                return optionA.label
                  .toLowerCase()
                  .localeCompare(optionB.label.toLowerCase());
              }
              return 0;
            }}
            dropdownRender={(menu) => (
              <>
                {menu}
                {empreendimentoSearch.trim() !== "" &&
                  !existeEmpreendimentoComNome && (
                    <div
                      style={{
                        borderTop: "1px solid #f0f0f0",
                        padding: 8,
                      }}
                    >
                      <ButtonForm
                        type="link"
                        style={{
                          padding: 0,
                          height: "auto",
                          textAlign: "left",
                          whiteSpace: "normal",
                        }}
                        onMouseDown={(e) => e.preventDefault()}
                        onClick={() =>
                          iniciarCadastroNovoEmpreendimento(
                            empreendimentoSearch
                          )
                        }
                      >
                        {`NÃ£o encontrou "${empreendimentoSearch}"? Adicionar novo empreendimento`}
                      </ButtonForm>
                    </div>
                  )}
              </>
            )}
            disabled={empreendimentoNaoSelecionado || bloqueadoEdicao.current}
            value={
              empreedimentoSelecionado ? empreedimentoSelecionado.id : undefined
            }
          >
            {empreendimento.map((emp: Empreendimento) => (
              <Select.Option key={emp.id} value={emp.id} label={emp.nome}>
                {emp.nome}
              </Select.Option>
            ))}
          </Select>
          <Checkbox
            disabled={bloqueadoEdicao.current}
            onChange={naoEncontradoChange}
            className="checkBoxEmpreendimento"
            checked={naoEncontrouEmpreendimento}
            style={{ display: "none" }}
          >
            NÃ£o encontrou ?
          </Checkbox>
        </div>
      </Card>
    </>
  );

  const cadastrarEmpreendimentoMensagem = (
    <>
      {!empreedimentoSelecionado && (
        <>
          <Card
            title={<CardTitle> Multicotas</CardTitle>}
            bordered={true}
            type="inner"
            className="mobile"
          >
            <div>
              <h3>Cadastre o empreendimento e mais informaÃ§Ãµes a seguir:</h3>
            </div>
          </Card>
        </>
      )}
    </>
  );

  const cadastrarEmpreendimentos = (
    <>
      <Card
        title={<CardTitle>Conte-me mais sobre o empreendimento:</CardTitle>}
        bordered={true}
        type="inner"
        className="mobile"
      >
        <Form
          form={formAtualizarEstadoEmpreendimento}
          {...layout}
          name="cadastrar-empreendimento"
          //onFinish={cadastrarEmpreendimento}
          initialValues={formEmpreendimento}
          onValuesChange={(changedValues, allValues) =>
            empreendimentosChange(changedValues, allValues)
          }
          style={{
            marginLeft: "-10%",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
          }}
          validateMessages={validarFormulario}
        >
          <Form.Item
            name={["nome"]}
            label="Nome empreendimento"
            className="formItems"
          >
            <Input />
          </Form.Item>
          <Form.Item
            name={["pais"]}
            label="Pais"
            rules={[{ required: true }]}
            className="formItems"
          >
            <Select>
              {paises.map((pais) => (
                <Select.Option key={pais.id} value={pais.id}>
                  {pais.nome}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item
            name={["estado"]}
            label="Estado"
            rules={[{ required: true }]}
            className="formItems"
          >
            <Select
              showSearch
              placeholder="Selecione o estado"
              onChange={(value) =>
                handleEstadoChange(value, formAtualizarEstadoEmpreendimento)
              }
              filterOption={(input, option) => {
                if (typeof option?.label === "string") {
                  const inputLowerCase = input.toLowerCase();
                  const labelLowerCase = option.label.toLowerCase();
                  return (
                    labelLowerCase.includes(inputLowerCase) ||
                    option.label.includes(input) || // original input
                    option.label
                      .toLowerCase()
                      .includes(
                        inputLowerCase.charAt(0).toUpperCase() +
                          inputLowerCase.slice(1)
                      )
                  );
                }
                return false;
              }}
              filterSort={(optionA, optionB) => {
                if (
                  typeof optionA?.label === "string" &&
                  typeof optionB?.label === "string"
                ) {
                  return optionA.label
                    .toLowerCase()
                    .localeCompare(optionB.label.toLowerCase());
                }
                return 0;
              }}
            >
              {estados.map((estado) => (
                <Select.Option
                  key={estado.id}
                  value={estado.id}
                  label={estado.nome}
                >
                  {estado.nome}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item
            name={["cidadeId"]}
            label="Cidade"
            id={"formCidades"}
            rules={[{ required: true }]}
            className="formItems"
          >
            <Select
              showSearch
              placeholder="Selecione a cidade"
              optionFilterProp="children"
              filterOption={(input, option) => {
                if (typeof option?.label === "string") {
                  const inputLowerCase = input.toLowerCase();
                  const labelLowerCase = option.label.toLowerCase();
                  return (
                    labelLowerCase.includes(inputLowerCase) ||
                    option.label.includes(input) || // original input
                    option.label
                      .toLowerCase()
                      .includes(
                        inputLowerCase.charAt(0).toUpperCase() +
                          inputLowerCase.slice(1)
                      )
                  );
                }
                return false;
              }}
              filterSort={(optionA, optionB) => {
                if (
                  typeof optionA?.label === "string" &&
                  typeof optionB?.label === "string"
                ) {
                  return optionA.label
                    .toLowerCase()
                    .localeCompare(optionB.label.toLowerCase());
                }
                return 0;
              }}
            >
              {cidades.map((cidade) => (
                <Select.Option
                  key={cidade.id}
                  value={cidade.id}
                  label={cidade.nome}
                >
                  {cidade.nome}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
        </Form>
      </Card>
    </>
  );

  // Componente Selecione seu apartamento
  const especificacoesApto = (
    <>
      <Card
        title={<CardTitle> Selecione seu apartamento</CardTitle>}
        bordered={true}
        type="inner"
        className="mobile"
        style={{
          width: "100%",
        }}
      >
        <Form
          form={formApartamento}
          {...layout}
          disabled={bloqueadoEdicao.current}
          name="cadastrar-propriedade"
          onValuesChange={apEmpreendimentoChange}
          initialValues={{
            propriedade: {
              nome: apSelecionado ? apSelecionado.nome : "",
              capacidade: apSelecionado ? apSelecionado.capacidade : "",
              quartos: apSelecionado ? apSelecionado.quartos : "",
              banheiros: apSelecionado ? apSelecionado.banheiros : "",
              metragem: apSelecionado ? apSelecionado.metragem : "",
              varanda: apSelecionado ? apSelecionado.varanda : "",
              // terreo: apSelecionado ? apSelecionado.terreo : "",
              estacionamento: apSelecionado ? apSelecionado.estacionamento : "",
            },
          }}
          validateMessages={validarFormulario}
        >
          <Form.Item
            name={["propriedade", "nomeAp"]}
            label="Nome apartamento:"
            className="formItems"
          >
            <Select
              showSearch
              placeholder="Selecione o apartamento"
              onChange={handleEmpreendimentoApChange}
              filterOption={(input, option) => {
                if (typeof option?.label === "string") {
                  return option.label.includes(input);
                }
                return false;
              }}
              filterSort={(optionA, optionB) => {
                if (
                  typeof optionA?.label === "string" &&
                  typeof optionB?.label === "string"
                ) {
                  return optionA.label
                    .toLowerCase()
                    .localeCompare(optionB.label.toLowerCase());
                }
                return 0;
              }}
              disabled={apCriadoPeloUsuario || bloqueadoEdicao.current}
            >
              {empreendimentoAp.map((emp: ApData) => (
                <Select.Option key={emp.id} value={emp.id} label={emp.nome}>
                  {emp.nome}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item
            name={["propriedade", "capacidade"]}
            label="Capacidade"
            className="formItems"
          >
            <Input style={{ width: "30%" }} readOnly />
          </Form.Item>
          <Form.Item
            name={["propriedade", "quartos"]}
            label="Quartos"
            className="formItems"
          >
            <Input style={{ width: "30%" }} readOnly />
          </Form.Item>
          <Form.Item
            name={["propriedade", "banheiros"]}
            label="Banheiros"
            className="formItems"
          >
            <Input style={{ width: "30%" }} readOnly />
          </Form.Item>
        </Form>

        <div className="formItems">
          <Checkbox
            disabled={bloqueadoEdicao.current}
            onChange={naoEncontradoAp}
            style={{
              marginLeft: 10,
              marginTop: 20,
            }}
            checked={apCriadoPeloUsuario}
          >
            Não encontrou o apartamento?
          </Checkbox>
        </div>
      </Card>
    </>
  );

  // Componente Conte-me mais sobre o apartamento
  const cadastrarApartamento = (
    <>
      <>
        <Card
          title={<CardTitle>Conte-me mais sobre o apartamento</CardTitle>}
          bordered={true}
          type="inner"
          className="mobile"
          style={{ width: "100%" }}
        >
          <Form
            {...layout}
            form={formCadastrarApartamento}
            name="cadastrar-apartamento"
            onValuesChange={(changedValues, allValues) =>
              novoApartamentoChange(changedValues, allValues)
            }
            initialValues={formAp}
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
            }}
            validateMessages={validarFormulario}
          >
            <Form.Item
              name={"empreendId"}
              label="Empreendimento: "
              className="formItems"
              rules={[{ required: true }]}
            >
              {empreedimentoSelecionado ? (
                <Select>
                  <Select.Option
                    key={empreedimentoSelecionado.id}
                    value={empreedimentoSelecionado.id}
                  >
                    {empreedimentoSelecionado.nome}
                  </Select.Option>
                </Select>
              ) : (
                <Select>
                  {meusEmpreendimentos.map((mp, index) => (
                    <Select.Option key={mp.id} value={mp.id}>
                      {mp.nome}
                    </Select.Option>
                  ))}
                </Select>
              )}
            </Form.Item>
            <Form.Item
              name={["nome"]}
              label="Nome do apartamento: "
              className="formItems"
              extra="Se não souber, deixe em branco."
            >
              <Input />
            </Form.Item>
            <Form.Item label="Capacidade: " className="formItems">
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  gap: 12,
                  width: "100%",
                }}
              >
                <Form.Item name={["capacidade"]} noStyle>
                  <InputNumber
                    min={0}
                    disabled={naoSeiApartamento.capacidade}
                    style={{ width: "30%" }}
                  />
                </Form.Item>
                <Checkbox
                  checked={naoSeiApartamento.capacidade}
                  onChange={(e) =>
                    atualizarCampoCadastroApartamento(
                      "capacidade",
                      e.target.checked
                    )
                  }
                >
                  Não sei
                </Checkbox>
              </div>
            </Form.Item>
            <Form.Item label="Quartos: " className="formItems">
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  gap: 12,
                  width: "100%",
                }}
              >
                <Form.Item name={["quartos"]} noStyle>
                  <InputNumber
                    min={0}
                    disabled={naoSeiApartamento.quartos}
                    style={{ width: "30%" }}
                  />
                </Form.Item>
                <Checkbox
                  checked={naoSeiApartamento.quartos}
                  onChange={(e) =>
                    atualizarCampoCadastroApartamento(
                      "quartos",
                      e.target.checked
                    )
                  }
                >
                  Não sei
                </Checkbox>
              </div>
            </Form.Item>
            <Form.Item label="Banheiros: " className="formItems">
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  gap: 12,
                  width: "100%",
                }}
              >
                <Form.Item name={["banheiros"]} noStyle>
                  <InputNumber
                    min={0}
                    disabled={naoSeiApartamento.banheiros}
                    style={{ width: "30%" }}
                  />
                </Form.Item>
                <Checkbox
                  checked={naoSeiApartamento.banheiros}
                  onChange={(e) =>
                    atualizarCampoCadastroApartamento(
                      "banheiros",
                      e.target.checked
                    )
                  }
                >
                  Não sei
                </Checkbox>
              </div>
            </Form.Item>
            <Form.Item
              name={["varanda"]}
              label="Possui varanda?"
              rules={[{ required: true }]}
              className="formItems"
            >
              <Radio.Group onChange={possuiVarandaChange} value={possuiVaranda}>
                <Radio value={0}>Não</Radio>
                <Radio value={1}>Sim</Radio>
                <Radio value={2}>Não sei</Radio>
              </Radio.Group>
            </Form.Item>

            <Form.Item
              name={["estacionamento"]}
              label="Possui estacionamento?"
              rules={[{ required: true }]}
              className="formItems"
            >
              <Radio.Group
                onChange={estacionamentoChange}
                value={estacionamento}
              >
                <Radio value={0}>Não</Radio>
                <Radio value={1}>Sim</Radio>
                <Radio value={2}>Não sei</Radio>
              </Radio.Group>
            </Form.Item>
            <Form.Item
              name={["terreo"]}
              label="Fica no térreo?"
              rules={[{ required: true }]}
              className="formItems"
            >
              <Radio.Group onChange={terreoChange} value={terreo}>
                <Radio value={0}>Não</Radio>
                <Radio value={1}>Sim</Radio>
                <Radio value={2}>Não sei</Radio>
              </Radio.Group>
            </Form.Item>
          </Form>
        </Card>
      </>
    </>
  );

  // Componente Mais informaÃ§Ãµes do apartamento
  const maisInfoApartamento = (
    <>
      <Card
        title={<CardTitle> Mais informaÃ§Ãµes do apartamento</CardTitle>}
        bordered={true}
        type="inner"
        className="mobile"
      >
        <Form
          {...layoutAp}
          name="cadastrar-apartamento"
          onValuesChange={(changedValues, allValues) =>
            MaisInfoApChange(changedValues, allValues)
          }
          initialValues={formInfo}
          style={{
            marginLeft: "-15%",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            width: "100%",
          }}
          validateMessages={validarFormulario}
        >
          <Form.Item
            name={["numeroApto"]}
            label="NÂº do apartamento:"
            rules={[{ required: true }]}
            className="formItems"
          >
            <Input />
          </Form.Item>
          <Form.Item
            name={["andar"]}
            label="Andar: "
            rules={[{ required: true }]}
            className="formItems"
          >
            <InputNumber min={0} />
          </Form.Item>
          <Form.Item name={["bloco"]} label="Bloco: " className="formItems">
            <Input />
          </Form.Item>
          <Form.Item
            name={["vista"]}
            label="Vista: "
            rules={[{ required: true }]}
            className="formItems"
          >
            <Select
              style={{ width: 150 }}
              options={vistaOptions}
              // defaultValue={1}
            />
          </Form.Item>
        </Form>
      </Card>
    </>
  );
  const servicosMulticotas = (
    <>
      <Card
        title={
          <CardTitle>
            Como podemos ajudÃ¡-lo com esta propriedade?
          </CardTitle>
        }
        bordered={true}
        type="inner"
        className="mobile"
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: 16,
            width: "100%",
          }}
        >
          <Checkbox.Group
            value={Object.entries(servicosSelecionados)
              .filter(([, value]) => value === 1)
              .map(([key]) => key)}
            onChange={servicosMulticotasChange}
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
              gap: 12,
              width: "fit-content",
              margin: "0 auto",
            }}
          >
            {servicosMulticotasOptions.map((servico) => (
              <Checkbox
                key={servico.value}
                value={servico.value}
                style={{ alignItems: "flex-start" }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: 4,
                    lineHeight: 1.4,
                  }}
                >
                  <TypographyAntd.Text strong>
                    {servico.titulo}
                  </TypographyAntd.Text>
                  <TypographyAntd.Text type="secondary">
                    {servico.descricao}
                  </TypographyAntd.Text>
                </div>
              </Checkbox>
            ))}
          </Checkbox.Group>

          <TypographyAntd.Text type="secondary" style={{ textAlign: "center" }}>
            Pode marcar mais de uma opÃ§Ã£o.
          </TypographyAntd.Text>
        </div>
      </Card>
    </>
  );
  const relacaoComPropriedade = (
    <>
      <Card
        title={
          <CardTitle>{"Qual \u00E9 a sua rela\u00E7\u00E3o com esta propriedade?"}</CardTitle>
        }
        bordered={true}
        type="inner"
        className="mobile"
        style={{ width: "100%" }}
      >
        <Radio.Group
          disabled={bloqueadoEdicao.current}
          onChange={propriedadeChange}
          value={propriedadeRes}
          className="custom-radio"
        >
          <Space direction="vertical">
            {state === "AGUARDANDO_TITULARIDADE" ||
            state === "AGUARDANDO_SERVICO" ? (
              <Radio value={0} disabled>
                Selecione uma opÃ§Ã£o
              </Radio>
            ) : null}
            <Radio value={1}>A propriedade estÃ¡ em meu nome</Radio>
            <Radio value={2}>A propriedade estÃ¡ em nome de outra pessoa</Radio>
          </Space>
        </Radio.Group>
        <div>
          <h6 style={{ fontSize: 15, marginTop: "20px", color: "red" }}>
            O nome do proprietÃ¡rio titular deve constar nos documentos
            referentes Ã  propriedade, como boletos de condomÃ­nio, entre outros.
          </h6>
        </div>
      </Card>
    </>
  );
  const relacaoComPropriedadeStep = (
    <>
      <Card
        title={
          <CardTitle>{"Qual \u00E9 a sua rela\u00E7\u00E3o com esta propriedade?"}</CardTitle>
        }
        bordered={true}
        type="inner"
        className="mobile"
        style={{ width: "100%" }}
      >
        <Radio.Group
          disabled={bloqueadoEdicao.current}
          onChange={propriedadeChange}
          value={propriedadeRes}
          className="custom-radio"
        >
          <Space direction="vertical">
            {(state === "AGUARDANDO_TITULARIDADE" ||
              state === "AGUARDANDO_SERVICO") && (
              <Radio value={0} disabled>
                {"Selecione uma op\u00E7\u00E3o"}
              </Radio>
            )}
            {relacaoPropriedadeOptions.map((relacao) => (
              <Radio key={relacao.value} value={relacao.value}>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: 4,
                    lineHeight: 1.4,
                  }}
                >
                  <TypographyAntd.Text strong>
                    {relacao.titulo}
                  </TypographyAntd.Text>
                  <TypographyAntd.Text type="secondary">
                    {relacao.descricao}
                  </TypographyAntd.Text>
                </div>
              </Radio>
            ))}
          </Space>
        </Radio.Group>
        <TypographyAntd.Text
          type="secondary"
          style={{ display: "block", marginTop: "20px" }}
        >
          {"N\u00E3o \u00E9 necess\u00E1rio enviar documentos agora."}
        </TypographyAntd.Text>
      </Card>
    </>
  );
  const cronogramaFixoOuPrioridadeComponente = (
    <>
      <>
        <Card
          title={<CardTitle>Como sÃ£o definidos seus perÃ­odos?</CardTitle>}
          bordered={true}
          type="inner"
          className="mobile"
        >
          <Radio.Group
            disabled={bloqueadoEdicao.current}
            onChange={cronogramaFixoOuPrioridadeChange}
            value={cronogramaFixoOuPrioridade}
            className="custom-radio"
          >
            <Space direction="vertical">
              {cronogramaFixoOuPrioridade === 0 ? (
                <Radio value={0} disabled>
                  Selecione uma opÃ§Ã£o
                </Radio>
              ) : null}
              <Radio value={1}>
                PerÃ­odos definidos em um cronograma ou calendÃ¡rio fixo.
              </Radio>
              <Radio value={2}>
                PerÃ­odos definidos periodicamente de acordo com uma prioridade.
              </Radio>
            </Space>
          </Radio.Group>
        </Card>
      </>
    </>
  );

  const titularidadeOutraPessoaMensagem = (
    <>
      <Card
        title={<CardTitle> Multicotas</CardTitle>}
        bordered={true}
        type="inner"
        className="mobile"
      >
        <div>
          <h3>
            Certo. <br />
            Faremos uma procuraÃ§Ã£o simples a qual o proprietÃ¡rio lhe darÃ¡
            poderes para representÃ¡-lo perante a Multicotas. <br />
            Como disse antes, Ã© simples e poderÃ¡ ser assinado pelo celular.
            <br />
            ApÃ³s finalizaÃ§Ã£o do cadastro, nossa equipe entrarÃ¡ em contato para
            darmos prosseguimento.
          </h3>
        </div>
      </Card>
    </>
  );

  const atualizarCadastroOutraPessoa = (
    <>
      <Card
        title={<CardTitle> Favor atualizar seu cadastro:</CardTitle>}
        bordered={true}
        type="inner"
        className="mobile"
      >
        <Form
          form={formAtualizarEstadoCadastro}
          {...layout}
          name="atualizar-cadastro"
          onValuesChange={(changedValues, allValues) =>
            atualizarCadastroChange(changedValues, allValues)
          }
          initialValues={formAtualizarCadastro}
          style={{
            padding: -30,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
          }}
          validateMessages={validarFormulario}
        >
          <Form.Item
            name={["nacionalidade"]}
            label="Nacionalidade"
            rules={[{ required: true }]}
            className="formItems"
          >
            <Select
              onChange={paisChange}
              placeholder="Selecione a nacionalidade"
            >
              {paises.map((pais) => (
                <Select.Option key={pais.id} value={pais.abreviacao}>
                  {pais.nome}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>

          <Form.Item
            name={["rg"]}
            label="RG"
            rules={[{ required: true }]}
            className="formItems"
          >
            <Input disabled={cpfEmailBloqueado} placeholder="Digite seu RG" />
          </Form.Item>

          <Form.Item
            name={["estadoCivil"]}
            label="Estado civil"
            rules={[{ required: true }]}
            className="formItems"
          >
            <Select>
              {estadoCivil.map((ec, index) => (
                <Select.Option key={ec.id} value={ec.value}>
                  {ec.label}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item
            name={["endereco"]}
            label="EndereÃ§o"
            rules={[{ required: true }]}
            className="formItems"
          >
            <Input />
          </Form.Item>
          <Form.Item
            name={["complemento"]}
            label="Complemento"
            rules={[{ required: true }]}
            className="formItems"
          >
            <Input />
          </Form.Item>

          <Form.Item
            name={["estadoId"]}
            label="Estado"
            rules={[{ required: true }]}
            className="formItems"
          >
            <Select
              showSearch
              placeholder="Selecione o estado"
              onChange={(value) =>
                handleEstadoChange(value, formAtualizarEstadoCadastro)
              }
              filterOption={(input, option) => {
                if (typeof option?.label === "string") {
                  const inputLowerCase = input.toLowerCase();
                  const labelLowerCase = option.label.toLowerCase();
                  return (
                    labelLowerCase.includes(inputLowerCase) ||
                    option.label.includes(input) || // original input
                    option.label
                      .toLowerCase()
                      .includes(
                        inputLowerCase.charAt(0).toUpperCase() +
                          inputLowerCase.slice(1)
                      )
                  );
                }
                return false;
              }}
              filterSort={(optionA, optionB) => {
                if (
                  typeof optionA?.label === "string" &&
                  typeof optionB?.label === "string"
                ) {
                  return optionA.label
                    .toLowerCase()
                    .localeCompare(optionB.label.toLowerCase());
                }
                return 0;
              }}
            >
              {estados.map((estado) => (
                <Select.Option
                  key={estado.id}
                  value={estado.id}
                  label={estado.nome}
                >
                  {estado.nome}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item
            name={["cidadeId"]}
            label="Cidade"
            rules={[{ required: true }]}
            className="formItems"
          >
            <Select
              showSearch
              placeholder="Selecione a cidade"
              optionFilterProp="children"
            >
              {cidades.map((cidade) => (
                <Select.Option
                  key={cidade.id}
                  value={cidade.id}
                  label={cidade.nome}
                >
                  {cidade.nome}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
        </Form>
      </Card>
    </>
  );

  const atualizarCadastroProprietario = (
    <>
      <>
        <Card
          title={<CardTitle> Favor informar dados do proprietÃ¡rio:</CardTitle>}
          bordered={true}
          type="inner"
          className="mobile"
        >
          <Form
            form={formAtualizarEstadoDadosProprietario}
            {...layout}
            name="dados-proprietario"
            onValuesChange={(changedValues, allValues) =>
              cadastrarProprietarioChange(changedValues, allValues)
            }
            initialValues={formCadastroProprietario}
            style={{
              marginLeft: "25px",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
            }}
            validateMessages={validarFormulario}
          >
            <Form.Item
              name={["nome"]}
              label="Nome"
              rules={[{ required: true }]}
              className="formItems"
            >
              <Input disabled={cpfEmailBloqueado} />
            </Form.Item>
            <Form.Item
              name={["sobrenome"]}
              label="Sobrenome"
              rules={[{ required: true }]}
              className="formItems"
            >
              <Input disabled={cpfEmailBloqueado} />
            </Form.Item>
            <Form.Item
              name={["cpf"]}
              label="CPF"
              rules={[{ required: true }]}
              className="formItems"
            >
              <MaskedInput disabled={cpfEmailBloqueado} mask="000.000.000-00" />
            </Form.Item>
            <Form.Item
              name={["rg"]}
              label="RG"
              rules={[{ required: true }]}
              className="formItems"
            >
              <Input disabled={cpfEmailBloqueado} placeholder="Digite seu RG" />
            </Form.Item>
            <Form.Item
              name={["email"]}
              label="E-mail"
              rules={[{ required: true, type: "email" }]}
              className="formItems"
            >
              <Input disabled={cpfEmailBloqueado} />
            </Form.Item>
            <Form.Item
              name={["celular"]}
              label="Celular"
              rules={[
                {
                  required: true,
                  message: "Por favor, insira seu celular!",
                },
              ]}
              className="formItems"
            >
              <PhoneInput
                country={"br"}
                value={phone}
                onChange={handlePhoneChange}
                placeholder="Digite seu telefone"
                disabled={cpfEmailBloqueado}
                inputClass="phone-input"
              />
            </Form.Item>
            <Form.Item
              name={["nacionalidade"]}
              label="Nacionalidade"
              rules={[{ required: true }]}
              className="formItems"
            >
              <Select
                onChange={paisChange}
                placeholder="Selecione a nacionalidade"
                disabled={cpfEmailBloqueado}
              >
                {paises.map((pais) => (
                  <Select.Option key={pais.id} value={pais.abreviacao}>
                    {pais.nome}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
            <Form.Item
              name={["estadoCivil"]}
              label="Estado Civil"
              rules={[{ required: true }]}
              className="formItems"
            >
              <Select disabled={cpfEmailBloqueado}>
                {estadoCivil.map((ec, index) => (
                  <Select.Option key={ec.id} value={ec.value}>
                    {ec.label}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
            <Form.Item
              name={["endereco"]}
              label="EndereÃ§o"
              rules={[{ required: true }]}
              className="formItems"
            >
              <Input disabled={cpfEmailBloqueado} />
            </Form.Item>
            <Form.Item
              name={["complemento"]}
              label="Complemento"
              rules={[{ required: true }]}
              className="formItems"
            >
              <Input disabled={cpfEmailBloqueado} />
            </Form.Item>

            <Form.Item
              name={["estadoId"]}
              label="Estado"
              rules={[{ required: true }]}
              className="formItems"
            >
              <Select
                disabled={cpfEmailBloqueado}
                showSearch
                placeholder="Selecione o estado"
                onChange={(value) =>
                  handleEstadoChange(
                    value,
                    formAtualizarEstadoDadosProprietario
                  )
                }
                filterOption={(input, option) => {
                  if (typeof option?.label === "string") {
                    const inputLowerCase = input.toLowerCase();
                    const labelLowerCase = option.label.toLowerCase();
                    return (
                      labelLowerCase.includes(inputLowerCase) ||
                      option.label.includes(input) || // original input
                      option.label
                        .toLowerCase()
                        .includes(
                          inputLowerCase.charAt(0).toUpperCase() +
                            inputLowerCase.slice(1)
                        )
                    );
                  }
                  return false;
                }}
                filterSort={(optionA, optionB) => {
                  if (
                    typeof optionA?.label === "string" &&
                    typeof optionB?.label === "string"
                  ) {
                    return optionA.label
                      .toLowerCase()
                      .localeCompare(optionB.label.toLowerCase());
                  }
                  return 0;
                }}
              >
                {estados.map((estado) => (
                  <Select.Option
                    key={estado.id}
                    value={estado.id}
                    label={estado.nome}
                  >
                    {estado.nome}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
            <Form.Item
              name={["cidadeId"]}
              label="Cidade"
              rules={[{ required: true }]}
              className="formItems"
            >
              <Select
                disabled={cpfEmailBloqueado}
                showSearch
                placeholder="Selecione a cidade"
                optionFilterProp="children"
                filterOption={(input, option) => {
                  if (typeof option?.label === "string") {
                    const inputLowerCase = input.toLowerCase();
                    const labelLowerCase = option.label.toLowerCase();
                    return (
                      labelLowerCase.includes(inputLowerCase) ||
                      option.label.includes(input) || // original input
                      option.label
                        .toLowerCase()
                        .includes(
                          inputLowerCase.charAt(0).toUpperCase() +
                            inputLowerCase.slice(1)
                        )
                    );
                  }
                  return false;
                }}
                filterSort={(optionA, optionB) => {
                  if (
                    typeof optionA?.label === "string" &&
                    typeof optionB?.label === "string"
                  ) {
                    return optionA.label
                      .toLowerCase()
                      .localeCompare(optionB.label.toLowerCase());
                  }
                  return 0;
                }}
              >
                {cidades.map((c) => (
                  <Select.Option key={c.id} value={c.id} label={c.nome}>
                    {c.nome}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          </Form>
        </Card>
      </>
    </>
  );

  const comprovantePropriedade = (
    <>
      <>
        <Card
          title={<CardTitle>Incluir comprovante da propriedade</CardTitle>}
          bordered={true}
          type="inner"
          className="mobile"
        >
          <Upload {...props}>
            <ButtonForm icon={<UploadOutlined />}>
              Clique para carregar arquivo
            </ButtonForm>
          </Upload>
          <Flex align="center" justify="center">
            <ButtonForm
              type="primary"
              onClick={handleUpload}
              disabled={fileList.length === 0}
              loading={uploading}
              style={{ marginTop: 50 }}
            >
              {uploading ? "Uploading" : "Anexar"}
            </ButtonForm>
          </Flex>

          {uploadedFiles.length > 0 && (
            <List
              style={{ marginTop: 20 }}
              header={<div>Arquivos Carregados</div>}
              bordered
              dataSource={uploadedFiles}
              renderItem={(item: any) => (
                <List.Item>
                  <a
                    href={item.ArquivoTable.path}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {item.ArquivoTable.originalname}
                  </a>
                </List.Item>
              )}
            />
          )}

          <div>
            <h6 style={{ fontSize: 15, marginTop: "20px", color: "red" }}>
              O nome do proprietÃ¡rio titular deve constar nos documentos
              referentes Ã  propriedade, como boletos de condomÃ­nio, entre
              outros.
            </h6>
          </div>
        </Card>
      </>
    </>
  );

  const minhaCota = (
    <>
      <>
        <Card
          title={<CardTitle>Qual o número de sua cota?</CardTitle>}
          bordered={true}
          type="inner"
          className="mobile"
        >
          {cronogramaEmp.current === 1 && origemApRef.current === 0 ? (
              <>
                <div
                  style={{
                    maxWidth: 580,
                    margin: "0 auto 24px auto",
                    textAlign: "left",
                  }}
                >
                  <p>Qual é o número que identifica sua cota?</p>
                  <p>
                    Esse número normalmente aparece junto ao número do
                    apartamento em seu contrato ou nos documentos do
                    empreendimento.
                  </p>
                  <p>
                    Por exemplo, se estiver escrito 105/21, o apartamento é 105
                    e o número da cota é 21.
                  </p>
                  <p>Não estamos perguntando quantas cotas você possui.</p>
                </div>
                <Form
                  {...layout}
                  form={formNumeroCota}
                  name="numero-cota"
                  disabled={bloqueadoEdicao.current}
                  onValuesChange={(changedValues, allValues) =>
                    numeroCotaChange(changedValues, allValues)
                  }
                  initialValues={formMinhaCotaOrigemProprietario}
                  style={{
                    marginLeft: "25px",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                  validateMessages={validarFormulario}
                >
                  <Form.Item
                    name={["numeroCota"]}
                    label="Número da cota"
                    rules={[{ required: true }]}
                    className="formItems"
                  >
                    <Select placeholder="Ex.: 21">
                      {cotasUsuario.map((cotaUsuario) => (
                        <Select.Option
                          key={cotaUsuario.id}
                          value={cotaUsuario.id}
                        >
                          {cotaUsuario.numeroCota}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Form>
                <div style={{ textAlign: "center", marginTop: 8 }}>
                  <ButtonForm
                    type="link"
                    disabled={bloqueadoEdicao.current}
                    onClick={selecionarCotaPadraoCronograma}
                  >
                    Não sei o número da minha cota
                  </ButtonForm>
                </div>
                {naoSabeNumeroCota && (
                  <div
                    style={{
                      maxWidth: 580,
                      margin: "16px auto 0 auto",
                      textAlign: "left",
                    }}
                  >
                    <p style={{ marginBottom: 12 }}>
                      Sem problema. Você pode informar depois.
                    </p>
                    <p>
                      O número da cota nos ajuda a identificar automaticamente
                      quais são os seus períodos no cronograma do
                      empreendimento. Sem ele, você poderá informar seus
                      períodos manualmente.
                    </p>
                  </div>
                )}
              </>
            ) : (
            <Form
              {...layout}
              name="numero-cota"
              disabled={bloqueadoEdicao.current}
              onValuesChange={(changedValues, allValues) =>
                numeroCotaOrigemProprietarioChange(changedValues, allValues)
              }
              initialValues={formMinhaCotaOrigemProprietario}
              style={{
                marginLeft: "25px",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
              }}
              validateMessages={validarFormulario}
            >
              <Form.Item
                name={["numeroCota"]}
                label="Número da cota"
                rules={[{ required: true }]}
                className="formItems"
              >
                <Input placeholder="Número da cota" />
              </Form.Item>
            </Form>
          )}

          <div>
            <h6 style={{ fontSize: 15, marginTop: "20px", color: "red" }}>
              Atenção: Trata-se do número da cota e não da quantidade de
              cotas que possui.
            </h6>
          </div>
        </Card>
      </>
    </>
  );

  const minhaPrioridade = (
    <>
      <>
        <Card
          title={<CardTitle>Qual a sua prioridade ou nÃºmero de Cota?</CardTitle>}
          bordered={true}
          type="inner"
          className="mobile"
        >
          <Form
            {...layout}
            onValuesChange={(changedValues, allValues) =>
              prioridadeChange(changedValues, allValues)
            }
            initialValues={formPrioridade}
            style={{
              marginLeft: "25px",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
            }}
            validateMessages={validarFormulario}
          >
            <Form.Item
              name={["prioridade"]}
              label="Prioridade"
              rules={[{ required: true }]}
              className="formItems"
            >
              <Input placeholder="Prioridade" />
            </Form.Item>
          </Form>
        </Card>
      </>
    </>
  );

  const minhaPrioridadeSemanasPorAno = (
    <>
      <>
        <Card
          title={<CardTitle>Quantas semanas tem direito ao ano?</CardTitle>}
          bordered={true}
          type="inner"
          className="mobile"
        >
          <Form
            {...layout}
            name="semanas-ano"
            disabled={bloqueadoEdicao.current}
            onValuesChange={(changedValues, allValues) =>
              semanasPorAnoChange(changedValues, allValues)
            }
            initialValues={formSemanasPorAno}
            style={{
              marginLeft: "25px",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
            }}
            validateMessages={validarFormulario}
          >
            <Form.Item
              name={["semanasPorAno"]}
              label="Semanas por ano"
              rules={[{ required: true }]}
              className="formItems"
            >
              <Input placeholder="Quantas semanas tem direito por ano" />
            </Form.Item>
          </Form>
        </Card>
      </>
    </>
  );

  const minhaPrioridadeDiaDaSemana = (
    <>
      <>
        <Card
          title={
            <CardTitle>Qual dia da semana comeÃ§a seus perÃ­odos?</CardTitle>
          }
          bordered={true}
          type="inner"
          className="mobile"
        >
          <Form
            {...layout}
            name="diaDaSemana"
            onValuesChange={(changedValues, allValues) =>
              diaDaSemanaChange(changedValues, allValues)
            }
            initialValues={formDiaDaSemana}
            style={{
              marginLeft: "25px",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
            }}
            validateMessages={validarFormulario}
          >
            <Form.Item
              name={["diaDaSemana"]}
              label="Dia Da Semana"
              rules={[{ required: true }]}
              className="formItems"
            >
              <Select placeholder="Selecione o dia da semana">
                {diasDaSemana.map((dias, index) => (
                  <Select.Option key={dias.id} value={dias.value}>
                    {dias.label}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          </Form>
        </Card>
      </>
    </>
  );

  const anunciarVenda = (
    <Card
      title={<CardTitle>Ative seu anúncio de venda</CardTitle>}
      bordered={true}
      type="inner"
      className="mobile"
    >
      <div style={{ maxWidth: 680, margin: "0 auto" }}>
        <p>
          Sua cota está pronta para ser anunciada. Ative o anúncio para divulgá-la
          na Multicotas, <strong>sem comissão ou corretagem sobre a venda</strong>.
        </p>

        <h3>O que está incluído</h3>
        <p>
          📢 <strong>Anúncio ativo na Multicotas</strong><br />
          Sua cota fica disponível para pessoas interessadas em multipropriedade
          enquanto sua assinatura estiver ativa.
        </p>
        <p>
          💬 <strong>Contato com interessados e suporte</strong><br />
          Receba contatos de potenciais compradores e conte com o suporte da
          Multicotas durante o processo.
        </p>
        <p>
          💳 <strong>Possibilidade de financiamento para o comprador</strong><br />
          Interessados podem solicitar uma análise de financiamento com nossa
          parceira, ampliando as possibilidades de negociação.
        </p>
        <p>
          ⚖️ <strong>Apoio jurídico no fechamento</strong><br />
          Se desejar, você poderá contar com escritório jurídico parceiro para
          auxiliar na transferência da cota.
        </p>

        <div
          style={{
            background: "#f5f8f9",
            borderRadius: 10,
            padding: "18px 20px",
            margin: "24px 0",
            textAlign: "center",
          }}
        >
          <h3 style={{ marginTop: 0 }}>Ativação do anúncio</h3>
          <strong>1 cota</strong>
          <div style={{ fontSize: 36, fontWeight: 700, color: "#003644" }}>
            R$ 118,80
          </div>
          <div>equivalente a <strong>R$ 9,90/mês</strong></div>
          <strong style={{ display: "block", marginTop: 8 }}>
            Cobrança anual · renovação automática
          </strong>
        </div>

        <p>
          ✓ Sem comissão ou corretagem sobre a venda<br />
          ✓ Cancele a renovação quando quiser
        </p>

        <ButtonForm
          type="primary"
          size="large"
          onClick={ativarAnuncio}
          style={{ background: "#003644", borderColor: "#003644", width: "100%" }}
        >
          Ativar meu anúncio
        </ButtonForm>

        <small style={{ display: "block", marginTop: 12 }}>
          A assinatura é renovada automaticamente a cada 12 meses. Você pode
          cancelar a renovação antes da próxima cobrança.
        </small>

        <ButtonForm
          type="link"
          onClick={() => setMostrarMaisCotas((aberto) => !aberto)}
          style={{ padding: "16px 0 8px", color: "#003644", fontWeight: 600 }}
        >
          {mostrarMaisCotas
            ? "− Ocultar opções"
            : "Tem outras cotas que também gostaria de anunciar?"}
        </ButtonForm>

        {mostrarMaisCotas && (
          <div style={{ borderTop: "1px solid #e8eff2", paddingTop: 16 }}>
            <h3>Tem outras cotas que também gostaria de anunciar?</h3>
            <p>Inclua mais cotas na mesma assinatura e aproveite valores reduzidos.</p>
            <ButtonForm type="link" onClick={ativarAnuncio} style={{ padding: 0, color: "#003644", fontWeight: 600 }}>
              Quero anunciar mais cotas
            </ButtonForm>
            <h3>Quantas cotas você gostaria de anunciar?</h3>
            <Radio.Group onChange={ativarAnuncio}>
              <Space direction="vertical">
                <Radio value={2}><strong>2 cotas</strong> — R$ 225,80/ano</Radio>
                <Radio value={3}><strong>3 cotas</strong> — R$ 328,10/ano</Radio>
                <Radio value={4}><strong>4 cotas</strong> — R$ 427,70/ano</Radio>
                <Radio value={5}><strong>5 cotas</strong> — R$ 522,70/ano</Radio>
                <Radio value={6}><strong>6 cotas</strong> — R$ 605,80/ano</Radio>
              </Space>
            </Radio.Group>
            <p style={{ marginTop: 16 }}>
              <small>
                A cota que você está cadastrando será incluída na assinatura. As
                demais poderão ser cadastradas posteriormente.
              </small>
            </p>
          </div>
        )}

        <ButtonForm type="text" onClick={naoAtivarAnuncio} style={{ marginTop: 8 }}>
          Agora não
        </ButtonForm>
      </div>
    </Card>
  );

  const MaisInfoAnuncioVenda = (
    <>
      <Card
        title={<CardTitle>Mais informaÃ§Ãµes do anÃºncio</CardTitle>}
        bordered={true}
        type="inner"
        className="mobile"
      >
        <Form
          {...layout}
          form={maisInfoForm}
          name="maisInfo"
          onValuesChange={(changedValues, allValues) =>
            maisInfoChange(changedValues, allValues)
          }
          initialValues={formMaisInfo}
          style={{
            width: "100%",
            marginLeft: "15px",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
          }}
          validateMessages={validarFormulario}
        >
          <Form.Item
            name={["situacao"]}
            label="SituaÃ§Ã£o da propriedade"
            rules={[{ required: true }]}
            className="formItems"
            style={{ width: "100%", marginBottom: "24px" }}
            labelCol={{ span: 24 }}
            wrapperCol={{ span: 24 }}
          >
            <Select placeholder="SituaÃ§Ã£o da propriedade">
              {situacaoPropriedade.map((dias, index) => (
                <Select.Option key={dias.id} value={dias.value}>
                  {dias.label}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>

          <Form.Item
            name={["valorVenda"]}
            label="Valor da Venda"
            rules={[{ required: true }]}
            className="formItems"
            style={{ width: "60%", marginBottom: "24px" }}
            labelCol={{ span: 24 }}
            wrapperCol={{ span: 24 }}
          >
            <InputNumber
              placeholder="Digite o valor da venda"
              formatter={(value) => {
                if (value === undefined || value === null) return "";
                return `R$ ${Number(value).toLocaleString("pt-BR", {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}`;
              }}
              parser={(value) => {
                if (!value) return "";
                const onlyNumbers = value.replace(/\D+/g, ""); // Remove tudo que nÃ£o for nÃºmero
                const parsedValue = (parseFloat(onlyNumbers) / 100).toFixed(2); // Converte para decimal
                return isNaN(Number(parsedValue)) ? "" : parsedValue;
              }}
              style={{ width: "100%" }}
            />
          </Form.Item>

          <Form.Item
            name={["valorCondominio"]}
            label="Valor do CondomÃ­nio"
            rules={[{ required: true }]}
            className="formItems"
            style={{ width: "60%", marginBottom: "24px" }}
            labelCol={{ span: 24 }}
            wrapperCol={{ span: 24 }}
          >
            <InputNumber
              placeholder="Digite o valor do condomÃ­nio"
              formatter={(value) => {
                if (value === undefined || value === null) return "";
                return `R$ ${Number(value).toLocaleString("pt-BR", {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}`;
              }}
              parser={(value) => {
                if (!value) return "";
                const onlyNumbers = value.replace(/\D+/g, ""); // Remove tudo que nÃ£o for nÃºmero
                const parsedValue = (parseFloat(onlyNumbers) / 100).toFixed(2); // Converte para decimal
                return isNaN(Number(parsedValue)) ? "" : parsedValue;
              }}
              style={{ width: "100%" }}
            />
          </Form.Item>

          {minhaSituacao === "NAO_QUITADO" && (
            <Form.Item
              name={["saldoDevedor"]}
              label="Saldo devedor"
              rules={[{ required: true }]}
              className="formItems"
              style={{ width: "60%", marginBottom: "24px" }}
              labelCol={{ span: 24 }}
              wrapperCol={{ span: 24 }}
            >
              <InputNumber
                placeholder="Digite o Saldo devedor"
                formatter={(value) => {
                  if (value === undefined || value === null) return "";
                  return `R$ ${Number(value).toLocaleString("pt-BR", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })}`;
                }}
                parser={(value) => {
                  if (!value) return "";
                  const onlyNumbers = value.replace(/\D+/g, ""); // Remove tudo que nÃ£o for nÃºmero
                  const parsedValue = (parseFloat(onlyNumbers) / 100).toFixed(
                    2
                  ); // Converte para decimal
                  return isNaN(Number(parsedValue)) ? "" : parsedValue;
                }}
                style={{ width: "100%" }}
              />
            </Form.Item>
          )}
        </Form>
      </Card>
    </>
  );

  const DesistenciaPagamento = (
    <Card
      title={<CardTitle> Multicotas</CardTitle>}
      bordered={true}
      type="inner"
      className="mobile"
    >
      <div>
        <h3>
          Sem problemas. <br />
          Caso mude de ideia, basta acessar "Minhas propriedades", <br />
          clicar em aÃ§Ãµes na propriedade que deseja anunciar e clicar em
          anunciar
        </h3>
      </div>
    </Card>
  );

  const adicionarPeriodosCronoEmpZero = (
    <>
      <Card
        title={<CardTitle> Multicotas</CardTitle>}
        bordered={true}
        type="inner"
        className="mobile"
      >
        <div>
          <h3>
            Informe os perÃ­odos que possui selecionando-os na coluna da esquerda
            e <br /> passando para as colunas da direita. ApÃ³s clique em Salvar.
          </h3>
        </div>
      </Card>
    </>
  );
  const adicionarPeriodosCronoEmpDois = (
    <>
      <Card
        title={<CardTitle> Multicotas</CardTitle>}
        bordered={true}
        type="inner"
        className="mobile"
      >
        <div>
          <h3>Informe os perÃ­odos que possui clicando no botÃ£o + PerÃ­odo.</h3>
        </div>
      </Card>
    </>
  );

  const definaPeriodoCronogramaEmpZeroEDois = (
    <>
      <Card
        title={<CardTitle> Multicotas</CardTitle>}
        bordered={true}
        type="inner"
        className="mobile"
      >
        <div>
          <h3>
            Pronto! <br />
            Agora vamos definir o que fazer com seus perÃ­odos <br /> clicando
            nos Ã­cones <SettingsIcon color="primary" /> de cada semana...
          </h3>
        </div>
      </Card>
    </>
  );
  const definaPeriodoCronogramaEmpUm = (
    <>
      <Card
        title={<CardTitle> Multicotas</CardTitle>}
        bordered={true}
        type="inner"
        className="mobile"
      >
        <div>
          <h3>
            Pronto! <br />
            Agora vamos definir o que fazer com seus perÃ­odos <br /> clicando
            nos Ã­cones <SettingsIcon color="primary" /> de cada semana...
            <br />
            Caso visualize perÃ­odos diferentes do que estÃ¡ <br />
            no cronograma, possÃ­velmente, vocÃª cadastrou <br />o nÃºmero da cota
            de forma equivocada. Se isso ocorrer, <br />
            favor entrar em contato conosco, <br />
            para ajudarmos a regularizar.
          </h3>
        </div>
      </Card>
    </>
  );
  const finalizacao = (
    <>
      <Card
        title={<CardTitle> Multicotas</CardTitle>}
        bordered={true}
        type="inner"
        className="mobile"
      >
        <div>
          <h3>
            Pronto! <br />
            <br />
            SituaÃ§Ã£o:
            <br />A propriedade tem perÃ­odos? :{" "}
            <span
              style={{
                color: propriedadeTemPeriodos === "Sim" ? "green" : "red",
              }}
            >
              {propriedadeTemPeriodos}
            </span>
            <br />
            Os perÃ­odos estÃ£o definidos? :{" "}
            <span
              style={{
                color:
                  propriedadeTemPeriodosDefinidos === "Sim" ? "green" : "red",
              }}
            >
              {propriedadeTemPeriodosDefinidos}
            </span>
            <br />
            Se houver pagamentos, estÃ£o regularizados? :{" "}
            <span
              style={{
                color:
                  pagamentoRegularizado === "NÃ£o" ||
                  pagamentoRegularizado === "NÃ£o. Aguardando confirmaÃ§Ã£o"
                    ? "red"
                    : "green",
              }}
            >
              {pagamentoRegularizado}
            </span>
            <br />
            Se houver representantes, estÃ£o regularizados? :{" "}
            <span
              style={{
                color: representanteRegularizado === "NÃ£o" ? "red" : "green",
              }}
            >
              {representanteRegularizado}
            </span>
            <br />A propriedade jÃ¡ foi autenticada? :{" "}
            <span
              style={{
                color: propriedadeAutenticada === "Sim" ? "green" : "red",
              }}
            >
              {propriedadeAutenticada}
            </span>{" "}
           
            <br />
            VocÃª estÃ¡ anunciando a venda de sua propriedade? :{" "}
            <span
              style={{
                color: anuncioPropriedade === true ? "green" : "red",
              }}
            >
              {anuncioPropriedade === true ? (
                <>
                  Sim{" "}
                  <button
                    style={{
                      backgroundColor: "rgb(0, 54, 68)",
                      color: "white",
                      border: "none",
                      padding: "5px 15px",
                      borderRadius: "5px",
                      cursor: "pointer",
                      fontSize: "16px",
                      transition: "background-color 0.3s",
                    }}
                    onClick={() =>
                      (window.location.href = `https://vendas.multicotas.com.br/detalhes.html?id=${pCotaUsuarioId.pCotaUsuarioId}`)
                    }
                  >
                    Ver anÃºncio
                  </button>
                </>
              ) : (
                "NÃ£o"
              )}
            </span>{" "}
            <br />
            <br />
            <br />
            <div style={{ whiteSpace: "pre-wrap" }}>{textoFinalizacao}</div>
          </h3>
        </div>
      </Card>
    </>
  );
  //-------------------- Componente Principal -----------------------------\\
  return (
    <Flex
      gap="middle"
      vertical
      align="center"
      justify="center"
      style={{
        flex: "display",
        alignItems: "center",
        justifyContent: "center",
        width: "100%",
      }}
    >
      {isLoading.current ? (
        <Skeleton active />
      ) : (
        <div>
          {contextHolder}
          <Row
            style={{
              flex: "display",
              alignItems: "center",
              justifyContent: "center",
              width: "100%",
            }}
          >
            <Col span={3}></Col>
            <Col>
              <StyledTitle>Cadastro de propriedade</StyledTitle>
            </Col>
            <Col span={3}></Col>
          </Row>

          <Divider />

          <Row>
            <Flex gap="large" vertical align="center" justify="center">
              <Box
                sx={{
                  display: "block",
                  width: "100%",
                  maxWidth: {
                    xs: "100%",
                    sm: "980px",
                  },
                  margin: {
                    xs: "0",
                    sm: "0 auto",
                  },
                  border: "1px solid #d9d9d9",
                  borderRadius: 2,
                  padding: 2,
                  backgroundColor: "#fafafa",
                }}
              >
                <TypographyAntd.Text
                  style={{
                    display: "block",
                    fontSize: "0.8rem",
                    color: "#666",
                    marginBottom: 4,
                  }}
                >
                  {`Passo ${mobileStepIndex + 1} de ${stepTitles.length}`}
                </TypographyAntd.Text>
                <TypographyAntd.Text
                  strong
                  style={{
                    display: "block",
                    fontSize: "1rem",
                    color: "#003644",
                    lineHeight: 1.3,
                  }}
                >
                  {stepTitles[mobileStepIndex]}
                </TypographyAntd.Text>
              </Box>
              {/* Condicional de renderizaÃ§Ã£o */}

              {/* Renderiza condicionalmente o conteÃºdo dos passos (primeiroPasso, segundoPasso, terceiroPasso, quartoPasso) baseado no estado activeStep e isLoading.*/}
              <>
                <Typography
                  component="div"
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  {/* RenderizaÃ§Ã£o do Passo 1 */}
                  {activeStep === 0 && !isLoading.current && (
                    <>
                      {renderApSteps === 0 &&
                        renderEmpSteps === 0 &&
                        selecionarEmpreendimento}

                      {/* Quando Encontrado o empreeendimento, vai para tela especificaÃ§Ãµes do apartamento */}
                      {renderApSteps === 1 && especificacoesApto}

                      {renderApSteps === 2 && relacaoComPropriedadeStep}

                      {renderApSteps === 3 && maisInfoApartamento}

                      {renderApSteps === 4 && servicosMulticotas}

                      {/* Quando Nao Encontrado o empreeendimento, vai para a tela de cadastro de empreendiemento */}
                      {renderEmpSteps === 1 && cadastrarEmpreendimentoMensagem}

                      {/* Tela de cadastro de empreendiemento */}
                      {renderEmpSteps === 2 && cadastrarEmpreendimentos}

                      {/* Tela de cadastro de Apartamento */}
                      {renderEmpSteps === 3 && cadastrarApartamento}
                    </>
                  )}

                  {/* RenderizaÃ§Ã£o do Passo 2 */}
                  {activeStep === 1 && !isLoading.current && (
                    <>
                      {renderProprietario === 0 && relacaoComPropriedadeStep}

                      {/* Titularidade em nome de outra pessoa */}
                      {renderProprietario === 1 &&
                        titularidadeOutraPessoaMensagem}
                      {renderProprietario === 2 && atualizarCadastroOutraPessoa}
                      {renderProprietario === 3 &&
                        atualizarCadastroProprietario}
                      {renderProprietario === 4 && comprovantePropriedade}
                    </>
                  )}

                  {/* RenderizaÃ§Ã£o do Passo 3 */}
                  {activeStep === 2 && !isLoading.current && (
                    <>
                      {/* Verifica se o apartamento e o empreendimento sÃ£o do sistema, se forem pula direto para o anuncio. */}
                      {renderCotaSteps === 0 &&
                        renderPrioridadeSteps === 0 &&
                        cronogramaFixoOuPrioridadeComponente}

                      {renderCotaSteps === 1 &&
                        renderPrioridadeSteps === 0 &&
                        minhaCota}

                      {renderCotaSteps === 0 &&
                        renderPrioridadeSteps === 1 &&
                        minhaPrioridade}

                      {/* Se selecionado Prioridade */}
                      {renderPrioridadeSteps === 2 &&
                        minhaPrioridadeSemanasPorAno}
                      {renderPrioridadeSteps === 3 &&
                        minhaPrioridadeDiaDaSemana}
                    </>
                  )}

                  {activeStep === 3 && !isLoading.current && (
                    <>
                      {/* Gostaria de anunciar?*/}
                      {renderPagamentoSteps === 1 && anunciarVenda}
                      {/* Mais informaÃ§Ãµes da propriedade*/}
                      {renderPagamentoSteps === 2 && MaisInfoAnuncioVenda}
                      {/* Mensagem pÃ³s desistencia de pagamento*/}
                      {renderPagamentoSteps === 3 && DesistenciaPagamento}
                    </>
                  )}
                  {activeStep === 4 && !isLoading.current && (
                    <>
                      {/* Adicionar perÃ­odos para cronograma zero ou seja por prioridade*/}
                      {renderAdicionarPeriodo === 1 &&
                        adicionarPeriodosCronoEmpZero}
                      {/* Adicionar perÃ­odos para empreendimento criado pelo usuÃ¡rio*/}
                      {renderAdicionarPeriodo === 2 &&
                        adicionarPeriodosCronoEmpDois}
                    </>
                  )}
                  {activeStep === 5 && !isLoading.current && (
                    <>
                      {/* Empreendimento ja existente e houver cronograma */}
                      {renderAdicionarPeriodo === 3 &&
                        definaPeriodoCronogramaEmpUm}
                      {/* Emprendimento do usuario ou Empreendimento do sistema e prioridade */}
                      {renderAdicionarPeriodo === 4 &&
                        definaPeriodoCronogramaEmpZeroEDois}
                    </>
                  )}
                  {activeStep === 6 && !isLoading.current && (
                    <>
                      {/* Tela de finalizaÃ§Ã£o mas sem anuncio */}
                      {finalizacao}
                    </>
                  )}
                </Typography>

                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    pt: 2,
                    marginBottom: 10,
                  }}
                >
                  <ContainerButton>
                    <Button
                      disabled={
                        activeStep === 0 &&
                        renderApSteps === 0 &&
                        renderEmpSteps === 0
                      }
                      onClick={handleBack}
                      sx={{ mr: 1 }}
                    >
                      Voltar
                    </Button>
                  </ContainerButton>
                  <Box sx={{ flex: "1 1 auto" }} />

                  <ContainerButton>
                    <Button
                      disabled={bloquearBotaoProximo}
                      onClick={avancarStepCadastroPropriedade}
                    >
                      {activeStep === 6 ? "Finalizar" : "Próximo"}
                    </Button>
                  </ContainerButton>
                </Box>
              </>
            </Flex>
          </Row>
        </div>
      )}
    </Flex>
  );
}
